/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { DischemPharmacy } from './models/dischem.model';
import {
  EasyRxPharmaciesResponse,
  EasyRxPrescriptionStatusResponse,
  RestApiResultOfEasyRxPharmaciesResponse,
  RestApiResultOfEasyRxPrescriptionStatusResponse,
  RestApiResultOfSendEasyRxScriptResponse,
  SendEasyRxScript,
  SendEasyRxScriptResponse,
} from './models/easyrx.model';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class AccountClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
     * Returns the list of practices for which the user is authorised to access.
    The method to be called after the authentication.
     * @return OK
     */
  getListOfAuthorisedPractices(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/practices';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfAuthorisedPractices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfAuthorisedPractices(<any>response_);
            } catch (e) {
              return <Observable<string[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<string[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfAuthorisedPractices(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(<any>null);
  }

  /**
   * Get list of all users
   * @return OK
   */
  getListOfAllUsers(): Observable<UserVo[]> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfAllUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfAllUsers(<any>response_);
            } catch (e) {
              return <Observable<UserVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfAllUsers(response: HttpResponseBase): Observable<UserVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <UserVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserVo[]>(<any>null);
  }

  /**
   * Used to register user in system
   * @return OK
   */
  register(userVo: UserVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(userVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRegister(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Search users according to provided filter
   * @return OK
   */
  searchUsers(lookupfilter: string): Observable<UserVo[]> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/{lookupfilter}/search';
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchUsers(<any>response_);
            } catch (e) {
              return <Observable<UserVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchUsers(response: HttpResponseBase): Observable<UserVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <UserVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserVo[]>(<any>null);
  }

  /**
   * Updates an existing user
   * @return OK
   */
  updateUser(userid: string, userVo: UserVo): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(userVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUser(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateUser(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Deletes an existing user
   * @return OK
   */
  deleteUser(userid: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/{userid}';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUser(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteUser(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Updates an existing user password
   * @return OK
   */
  updateUserPassword(userid: string, message: ChangeUserPassword): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/{userid}/password';
    if (userid === undefined || userid === null) throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace('{userid}', encodeURIComponent('' + userid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(message);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserPassword(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateUserPassword(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get user details by username
   * @return OK
   */
  getUserDetailsById(userId: string): Observable<UserVo> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/{userId}';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserDetailsById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserDetailsById(<any>response_);
            } catch (e) {
              return <Observable<UserVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetUserDetailsById(response: HttpResponseBase): Observable<UserVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <UserVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserVo>(<any>null);
  }

  /**
   * Get user details by username
   * @return OK
   */
  getUserDetailsByName(userName: string): Observable<UserVo> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/users/byName/{userName}';
    if (userName === undefined || userName === null) throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserDetailsByName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserDetailsByName(<any>response_);
            } catch (e) {
              return <Observable<UserVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetUserDetailsByName(response: HttpResponseBase): Observable<UserVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <UserVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserVo>(<any>null);
  }

  /**
   * Creates admin user if it doesn't exist
   * @return OK
   */
  initialiseAdmin(): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/authentication/account/initialise';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInitialiseAdmin(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInitialiseAdmin(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInitialiseAdmin(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuditEventClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get latest events for specific node
   * @param nodeId unique identifier of node
   * @return OK
   */
  getNodeEventsAll(nodeId: number): Observable<EventVo[]> {
    let url_ = this.baseUrl + '/api/v1/audit/nodes/{nodeId}/events';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNodeEventsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNodeEventsAll(<any>response_);
            } catch (e) {
              return <Observable<EventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNodeEventsAll(response: HttpResponseBase): Observable<EventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EventVo[]>(<any>null);
  }

  /**
   * Get latest events for specific node
   * @param nodeId unique identifier of node
   * @param top number of events to return
   * @return OK
   */
  getNodeEvents(nodeId: number, top: number): Observable<EventVo[]> {
    let url_ = this.baseUrl + '/api/v1/audit/nodes/{nodeId}/events/top/{top}';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    if (top === undefined || top === null) throw new Error("The parameter 'top' must be defined.");
    url_ = url_.replace('{top}', encodeURIComponent('' + top));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNodeEvents(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNodeEvents(<any>response_);
            } catch (e) {
              return <Observable<EventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNodeEvents(response: HttpResponseBase): Observable<EventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EventVo[]>(<any>null);
  }

  /**
   * Get latest events for specific node, filtered
   * @return OK
   */
  getEvents(): Observable<EventVo[]> {
    let url_ = this.baseUrl + '/api/v1/audit/events';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEvents(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEvents(<any>response_);
            } catch (e) {
              return <Observable<EventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEvents(response: HttpResponseBase): Observable<EventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EventVo[]>(<any>null);
  }

  /**
   * Get latest events for specified AR
   * @param aggregateRootId AR id
   * @return OK
   */
  getEventsForAr(tenant: string, aggregateRootId: string): Observable<EventVo[]> {
    let url_ = this.baseUrl + '/api/v1/{tenant}/audit/events/{aggregateRootId}';
    if (tenant === undefined || tenant === null) throw new Error("The parameter 'tenant' must be defined.");
    url_ = url_.replace('{tenant}', encodeURIComponent('' + tenant));
    if (aggregateRootId === undefined || aggregateRootId === null) throw new Error("The parameter 'aggregateRootId' must be defined.");
    url_ = url_.replace('{aggregateRootId}', encodeURIComponent('' + aggregateRootId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEventsForAr(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEventsForAr(<any>response_);
            } catch (e) {
              return <Observable<EventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEventsForAr(response: HttpResponseBase): Observable<EventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EventVo[]>(<any>null);
  }

  /**
   * Method for getting nodes
   * @return OK
   */
  getNodes(): Observable<number[]> {
    let url_ = this.baseUrl + '/api/v1/audit/nodes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNodes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNodes(<any>response_);
            } catch (e) {
              return <Observable<number[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<number[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNodes(response: HttpResponseBase): Observable<number[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<number[]>(<any>null);
  }

  /**
   * Get events for tenant
   * @param fromDate start event date
   * @param toDate end event date
   * @return OK
   */
  getEventsForTenant(tenant: string, fromDate: Date, toDate: Date): Observable<EventVo[]> {
    let url_ = this.baseUrl + '/api/v1/audit/events/{tenant}/from/{fromDate}/to/{toDate}';
    if (tenant === undefined || tenant === null) throw new Error("The parameter 'tenant' must be defined.");
    url_ = url_.replace('{tenant}', encodeURIComponent('' + tenant));
    if (fromDate === undefined || fromDate === null) throw new Error("The parameter 'fromDate' must be defined.");
    url_ = url_.replace('{fromDate}', encodeURIComponent(fromDate ? '' + fromDate.toJSON() : 'null'));
    if (toDate === undefined || toDate === null) throw new Error("The parameter 'toDate' must be defined.");
    url_ = url_.replace('{toDate}', encodeURIComponent(toDate ? '' + toDate.toJSON() : 'null'));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEventsForTenant(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEventsForTenant(<any>response_);
            } catch (e) {
              return <Observable<EventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEventsForTenant(response: HttpResponseBase): Observable<EventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EventVo[]>(<any>null);
  }

  /**
   * Get latest top messages which come from external system (mymps)
   * @return OK
   */
  getLatestSyncMessages(): Observable<ExternalMessageSyncVo[]> {
    let url_ = this.baseUrl + '/api/v1/audit/sync/events';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestSyncMessages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestSyncMessages(<any>response_);
            } catch (e) {
              return <Observable<ExternalMessageSyncVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ExternalMessageSyncVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetLatestSyncMessages(response: HttpResponseBase): Observable<ExternalMessageSyncVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ExternalMessageSyncVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ExternalMessageSyncVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class BillingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Returns all invoices for a practice
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getInvoices(practiceid: string): Observable<InvoiceVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInvoices(<any>response_);
            } catch (e) {
              return <Observable<InvoiceVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInvoices(response: HttpResponseBase): Observable<InvoiceVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceVo[]>(<any>null);
  }

  /**
   * Returns speciality rule by specialityCode
   * @return OK
   */
  getSpecialityRule(practiceId: string, code: string): Observable<SpecialityRuleVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/billing/specialityrules/{code}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSpecialityRule(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSpecialityRule(<any>response_);
            } catch (e) {
              return <Observable<SpecialityRuleVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<SpecialityRuleVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSpecialityRule(response: HttpResponseBase): Observable<SpecialityRuleVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SpecialityRuleVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SpecialityRuleVo>(<any>null);
  }

  /**
   * Returns list of all speciality rules
   * @return OK
   */
  getSpecialityRules(): Observable<SpecialityRuleVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/specialityrules';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSpecialityRules(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSpecialityRules(<any>response_);
            } catch (e) {
              return <Observable<SpecialityRuleVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<SpecialityRuleVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSpecialityRules(response: HttpResponseBase): Observable<SpecialityRuleVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SpecialityRuleVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SpecialityRuleVo[]>(<any>null);
  }

  /**
   * Returns speciality rule by specialityCode
   * @return OK
   */
  getProviderConfiguration(practiceId: string): Observable<PatientConfigurationVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/billing/providerconfiguration';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProviderConfiguration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProviderConfiguration(<any>response_);
            } catch (e) {
              return <Observable<PatientConfigurationVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientConfigurationVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProviderConfiguration(response: HttpResponseBase): Observable<PatientConfigurationVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientConfigurationVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientConfigurationVo>(<any>null);
  }

  /**
   * Returns the invoice by Id
   * @param practiceid Unique identifier of practice
   * @param invoiceid Unique identifier of invoice
   * @return OK
   */
  getInvoice(practiceid: string, invoiceid: string): Observable<InvoiceVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInvoice(<any>response_);
            } catch (e) {
              return <Observable<InvoiceVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceVo>(<any>null);
  }

  /**
   * Returns the invoice with response details based on invoice Id
   * @param practiceid Unique identifier of practice
   * @param invoiceid Unique identifier of invoice
   * @return OK
   */
  getInvoiceWithchargecodesStatus(practiceid: string, invoiceid: string): Observable<InvoiceWithStatusVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}/status';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInvoiceWithchargecodesStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInvoiceWithchargecodesStatus(<any>response_);
            } catch (e) {
              return <Observable<InvoiceWithStatusVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceWithStatusVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInvoiceWithchargecodesStatus(response: HttpResponseBase): Observable<InvoiceWithStatusVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceWithStatusVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceWithStatusVo>(<any>null);
  }

  /**
   * Get list of invoice templates for invoice
   * @param practiceid Unique identifier of practice
   * @param invoiceid Unique identifier of invoice based on the patient visit
   * @return OK
   */
  getListOfTemplatesForInvoice(practiceid: string, invoiceid: string): Observable<InvoiceTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}/templates';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplatesForInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplatesForInvoice(<any>response_);
            } catch (e) {
              return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplatesForInvoice(response: HttpResponseBase): Observable<InvoiceTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceTemplateVo[]>(<any>null);
  }

  /**
   * Get of invoice templates
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getListOfTemplatesAll(practiceid: string): Observable<InvoiceTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoicetemplates';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplatesAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplatesAll(<any>response_);
            } catch (e) {
              return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplatesAll(response: HttpResponseBase): Observable<InvoiceTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceTemplateVo[]>(<any>null);
  }

  /**
   * Get of invoice templates for specific type
   * @param practiceid Unique identifier of practice
   * @param type template type
   * @return OK
   */
  getListOfTemplates(practiceid: string, type: string): Observable<InvoiceTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoicetemplates/{type}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplates(<any>response_);
            } catch (e) {
              return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplates(response: HttpResponseBase): Observable<InvoiceTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceTemplateVo[]>(<any>null);
  }

  /**
   * Get invoice template by id
   * @param practiceid Unique identifier of practice
   * @param templateid Unique identifier of template
   * @return OK
   */
  getInvoiceTemplateById(practiceid: string, templateid: string): Observable<InvoiceTemplateVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoicetemplates/{templateid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInvoiceTemplateById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInvoiceTemplateById(<any>response_);
            } catch (e) {
              return <Observable<InvoiceTemplateVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceTemplateVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInvoiceTemplateById(response: HttpResponseBase): Observable<InvoiceTemplateVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceTemplateVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceTemplateVo>(<any>null);
  }

  /**
   * Get filtered Diagnoses
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getDiagnosisAll(practiceid: string, invoiceid: string, lookupfilter: string): Observable<InvoiceLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}/lookupdiagnosis/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiagnosisAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiagnosisAll(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDiagnosisAll(response: HttpResponseBase): Observable<InvoiceLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsVo[]>(<any>null);
  }

  /**
   * Get all diagnoses
   * @return OK
   */
  getDiagnosis(): Observable<DiagnosisVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnoses';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiagnosis(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiagnosis(<any>response_);
            } catch (e) {
              return <Observable<DiagnosisVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<DiagnosisVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDiagnosis(response: HttpResponseBase): Observable<DiagnosisVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <DiagnosisVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DiagnosisVo[]>(<any>null);
  }

  /**
   * Get filtered Diagnoses
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getDiagnosisRanking(practiceid: string, invoiceid: string, lookupfilter: string): Observable<InvoiceLineItemsRankingVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}/lookupdiagnosisranking/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiagnosisRanking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiagnosisRanking(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsRankingVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsRankingVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDiagnosisRanking(response: HttpResponseBase): Observable<InvoiceLineItemsRankingVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsRankingVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsRankingVo[]>(<any>null);
  }

  /**
   * Get filtered Procedures
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getProcedures(practiceid: string, invoiceId: string, lookupfilter: string): Observable<InvoiceLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/lookupprocedure/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProcedures(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProcedures(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProcedures(response: HttpResponseBase): Observable<InvoiceLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Medicines
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getMedicines(practiceid: string, invoiceId: string, lookupfilter: string): Observable<InvoiceLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/lookupmedicine/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicines(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicines(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicines(response: HttpResponseBase): Observable<InvoiceLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Consumables
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getConsumables(practiceid: string, invoiceId: string, lookupfilter: string): Observable<InvoiceLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/lookupconsumable/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConsumables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConsumables(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetConsumables(response: HttpResponseBase): Observable<InvoiceLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Medicines and Consumables
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getMedicinesAndConsumables(practiceid: string, invoiceId: string, lookupfilter: string): Observable<InvoiceLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/lookupmedicineandconsumable/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicinesAndConsumables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicinesAndConsumables(<any>response_);
            } catch (e) {
              return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicinesAndConsumables(response: HttpResponseBase): Observable<InvoiceLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsVo[]>(<any>null);
  }

  /**
   * Get list of all billing providers with ability to paginate
   * @return OK
   */
  getProvidersAsQueryable(): Observable<ProviderConfigurationVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/providers';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProvidersAsQueryable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProvidersAsQueryable(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProvidersAsQueryable(response: HttpResponseBase): Observable<ProviderConfigurationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo[]>(<any>null);
  }

  /**
   * Create new billing provider
   * @return OK
   */
  createProvider(createProviderConfiguration: CreateProviderConfiguration): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/billing/providers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createProviderConfiguration);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateProvider(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateProvider(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get all branches available in practice on which specified doctor assigned
   * @param providerId doctor id
   * @return OK
   */
  getPracticeBranches(providerId: string): Observable<ProviderBranchConfigurationVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/billing/branches';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPracticeBranches(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPracticeBranches(<any>response_);
            } catch (e) {
              return <Observable<ProviderBranchConfigurationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderBranchConfigurationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPracticeBranches(response: HttpResponseBase): Observable<ProviderBranchConfigurationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderBranchConfigurationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderBranchConfigurationVo[]>(<any>null);
  }

  /**
   * Get list of filtered billing providers with ability to paginate
   * @return OK
   */
  getProvidersWithFilterAsQueryable(lookupfilter: string): Observable<ProviderConfigurationVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/providers/{lookupfilter}';
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProvidersWithFilterAsQueryable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProvidersWithFilterAsQueryable(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProvidersWithFilterAsQueryable(response: HttpResponseBase): Observable<ProviderConfigurationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo[]>(<any>null);
  }

  /**
   * Get billing provider by Id
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getProvider(practiceid: string): Observable<ProviderConfigurationVo> {
    let url_ = this.baseUrl + '/api/v1/billing/provider/{practiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProvider(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProvider(response: HttpResponseBase): Observable<ProviderConfigurationVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo>(<any>null);
  }

  /**
   * Get billing provider by PracticeXref
   * @return OK
   */
  getProviderByXref(practiceXref: string): Observable<ProviderConfigurationVo> {
    let url_ = this.baseUrl + '/api/v1/billing/provider/xref/{practiceXref}';
    if (practiceXref === undefined || practiceXref === null) throw new Error("The parameter 'practiceXref' must be defined.");
    url_ = url_.replace('{practiceXref}', encodeURIComponent('' + practiceXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProviderByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProviderByXref(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProviderByXref(response: HttpResponseBase): Observable<ProviderConfigurationVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo>(<any>null);
  }

  /**
     * Get supporting providers by practice number for specific category assisting/referring,
    include always treating doctors except current one
     * @param practiceid Unique identifier of practice
     * @param type assisting/reffering/treating
     * @return OK
     */
  getSupportingProvidersAll(practiceid: string, type: string): Observable<SupportingProviderVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/supportingproviders/{practiceid}/{type}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSupportingProvidersAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSupportingProvidersAll(<any>response_);
            } catch (e) {
              return <Observable<SupportingProviderVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<SupportingProviderVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSupportingProvidersAll(response: HttpResponseBase): Observable<SupportingProviderVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SupportingProviderVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SupportingProviderVo[]>(<any>null);
  }

  /**
   * Get supporting providers by practice number
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getSupportingProviders(practiceid: string): Observable<SupportingProviderVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/supportingproviders/{practiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSupportingProviders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSupportingProviders(<any>response_);
            } catch (e) {
              return <Observable<SupportingProviderVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<SupportingProviderVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSupportingProviders(response: HttpResponseBase): Observable<SupportingProviderVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SupportingProviderVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SupportingProviderVo[]>(<any>null);
  }

  /**
   * Get provider contracts
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getProviderContracts(practiceid: string): Observable<ProviderContractVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/providers/{practiceid}/contracts';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProviderContracts(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProviderContracts(<any>response_);
            } catch (e) {
              return <Observable<ProviderContractVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderContractVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProviderContracts(response: HttpResponseBase): Observable<ProviderContractVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderContractVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderContractVo[]>(<any>null);
  }

  /**
   * Get all diagnoses ranked
   * @return OK
   */
  getRankedDiagnosis(): Observable<DiagnosisRankingVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosesranked';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRankedDiagnosis(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRankedDiagnosis(<any>response_);
            } catch (e) {
              return <Observable<DiagnosisRankingVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<DiagnosisRankingVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRankedDiagnosis(response: HttpResponseBase): Observable<DiagnosisRankingVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <DiagnosisRankingVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DiagnosisRankingVo[]>(<any>null);
  }

  /**
   * set billing provider option
   * @return OK
   */
  setProviderConfigurationOptions(
    practiceid: string,
    configurationOption: SetProviderConfigurationOptions
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/providers/setoptions';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configurationOption);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetProviderConfigurationOptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetProviderConfigurationOptions(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetProviderConfigurationOptions(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update only one specific billing provider option
   * @return OK
   */
  setProviderConfigurationOption(
    practiceid: string,
    configurationOption: ChangeProviderConfigurationOption
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/providers/setoption';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configurationOption);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetProviderConfigurationOption(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetProviderConfigurationOption(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetProviderConfigurationOption(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update provider details
   * @return OK
   */
  updateProvider(practiceid: string, updateProviderConfiguration: UpdateProviderConfiguration): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/billing/providers/{practiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateProviderConfiguration);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProvider(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProvider(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Remove practice details
   * @return OK
   */
  removeProvider(practiceid: string, removeProviderConfiguration: RemoveProviderConfiguration): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/billing/providers/{practiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(removeProviderConfiguration);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveProvider(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveProvider(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update provider details, using external xref
   * @return OK
   */
  updateProviderByXref(
    practiceXref: string,
    updateProviderConfiguration: UpdateProviderConfigurationByExternalSystem
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXref}/billing/providers';
    if (practiceXref === undefined || practiceXref === null) throw new Error("The parameter 'practiceXref' must be defined.");
    url_ = url_.replace('{practiceXref}', encodeURIComponent('' + practiceXref));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateProviderConfiguration);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProviderByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProviderByXref(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProviderByXref(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Enable provider by xref
   * @return OK
   */
  enableProviderByXref(practiceXref: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXref}/billing/providers/enable';
    if (practiceXref === undefined || practiceXref === null) throw new Error("The parameter 'practiceXref' must be defined.");
    url_ = url_.replace('{practiceXref}', encodeURIComponent('' + practiceXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEnableProviderByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEnableProviderByXref(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processEnableProviderByXref(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Update branches info for specific tenant (practice/business)
   * @param tenantXref practice tenant ref
   * @return OK
   */
  updateBranches(tenantXref: string, branches: ProviderBranchConfigurationVo[]): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXref}/billing/branches';
    if (tenantXref === undefined || tenantXref === null) throw new Error("The parameter 'tenantXref' must be defined.");
    url_ = url_.replace('{tenantXref}', encodeURIComponent('' + tenantXref));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(branches);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBranches(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBranches(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateBranches(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Deletes specific branch from system
   * @return OK
   */
  removeBranch(practiceTenantId: string, branchId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceTenantId}/billing/branches/{branchId}';
    if (practiceTenantId === undefined || practiceTenantId === null) throw new Error("The parameter 'practiceTenantId' must be defined.");
    url_ = url_.replace('{practiceTenantId}', encodeURIComponent('' + practiceTenantId));
    if (branchId === undefined || branchId === null) throw new Error("The parameter 'branchId' must be defined.");
    url_ = url_.replace('{branchId}', encodeURIComponent('' + branchId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveBranch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveBranch(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveBranch(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update provider related info per branch
   * @return OK
   */
  updateBranchProviderInfo(
    tenantXref: string,
    providerXref: string,
    infos: BranchProviderRelatedInfo[]
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXref}/billing/branches/provider/{providerXref}';
    if (tenantXref === undefined || tenantXref === null) throw new Error("The parameter 'tenantXref' must be defined.");
    url_ = url_.replace('{tenantXref}', encodeURIComponent('' + tenantXref));
    if (providerXref === undefined || providerXref === null) throw new Error("The parameter 'providerXref' must be defined.");
    url_ = url_.replace('{providerXref}', encodeURIComponent('' + providerXref));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(infos);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBranchProviderInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBranchProviderInfo(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateBranchProviderInfo(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Disable provider by xref
   * @return OK
   */
  disableProviderByXref(practiceXref: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXref}/billing/providers/disable';
    if (practiceXref === undefined || practiceXref === null) throw new Error("The parameter 'practiceXref' must be defined.");
    url_ = url_.replace('{practiceXref}', encodeURIComponent('' + practiceXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDisableProviderByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDisableProviderByXref(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDisableProviderByXref(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Submit Invoice
   * @param practiceid Unique identifier of practice
   * @param invoice public domain model = SubmitInvoice
   * @return OK
   */
  submitInvoice(practiceid: string, invoiceId: string, invoice: SubmitInvoice): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(invoice);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubmitInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubmitInvoice(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSubmitInvoice(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Submit Invoice
   * @param practiceid Unique identifier of practice
   * @param invoice public domain model = SubmitInvoice
   * @return OK
   */
  submitInvoice2(practiceid: string, invoiceId: string, invoice: SubmitInvoice): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(invoice);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubmitInvoice2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubmitInvoice2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSubmitInvoice2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Cancel Invoice
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @return OK
   */
  cancelInvoice(practiceid: string, invoiceId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/cancel';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelInvoice(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCancelInvoice(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Return list of invoices which failed to send (available for admins)
   * @return OK
   */
  getFailedInvoices(): Observable<InvoiceSendingStatusVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/invoices/failed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFailedInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFailedInvoices(<any>response_);
            } catch (e) {
              return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFailedInvoices(response: HttpResponseBase): Observable<InvoiceSendingStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceSendingStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceSendingStatusVo[]>(<any>null);
  }

  /**
   * Return list of sent invoices
   * @return OK
   */
  getSentInvoices(sentDate: Date): Observable<InvoiceSendingStatusVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/invoices/sent/sentDate/{sentDate}';
    if (sentDate === undefined || sentDate === null) throw new Error("The parameter 'sentDate' must be defined.");
    url_ = url_.replace('{sentDate}', encodeURIComponent(sentDate ? '' + sentDate.toJSON() : 'null'));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSentInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSentInvoices(<any>response_);
            } catch (e) {
              return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSentInvoices(response: HttpResponseBase): Observable<InvoiceSendingStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceSendingStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceSendingStatusVo[]>(<any>null);
  }

  /**
   * Return list of invoices which failed to send (available for admins)
   * @return OK
   */
  getAbortedInvoices(): Observable<InvoiceSendingStatusVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/invoices/aborted';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAbortedInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAbortedInvoices(<any>response_);
            } catch (e) {
              return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<InvoiceSendingStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAbortedInvoices(response: HttpResponseBase): Observable<InvoiceSendingStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <InvoiceSendingStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceSendingStatusVo[]>(<any>null);
  }

  /**
   * Trigger command to send invoice as uncompleted claim to external system
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @return OK
   */
  sendInvoiceManually(practiceid: string, invoiceId: string, command: MoveInvoiceToManualProcessing): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/sendmanually';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendInvoiceManually(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendInvoiceManually(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendInvoiceManually(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Trigger command to retry invoice sending to external system
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @return OK
   */
  retryInvoice(practiceid: string, invoiceId: string, command: RetryInvoiceProcessing): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/retry';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRetryInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRetryInvoice(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRetryInvoice(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Trigger command to retry all failed invoices to external system
   * @return OK
   */
  retryAllFailedInvoices(): Observable<RestApiResultOfListOfInvoiceSendingStatusVo> {
    let url_ = this.baseUrl + '/api/v1/billing/invoices/retryallfailed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRetryAllFailedInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRetryAllFailedInvoices(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfListOfInvoiceSendingStatusVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfListOfInvoiceSendingStatusVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRetryAllFailedInvoices(response: HttpResponseBase): Observable<RestApiResultOfListOfInvoiceSendingStatusVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfListOfInvoiceSendingStatusVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfListOfInvoiceSendingStatusVo>(<any>null);
  }

  /**
   * Trigger command to abort invoice sending to external system
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @return OK
   */
  abortInvoice(practiceid: string, invoiceId: string, command: AbortInvoiceProcessing): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/abort';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAbortInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAbortInvoice(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAbortInvoice(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Merging Invoice Line Items
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @param mergeinvoiceLineItems public domain model = MergeinvoiceLineItems
   * @return OK
   */
  mergeInvoiceLineItems(
    practiceid: string,
    invoiceId: string,
    mergeinvoiceLineItems: MergeInvoiceLineItems
  ): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/mergeinvoicelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeInvoiceLineItems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeInvoiceLineItems(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeInvoiceLineItems(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * Merging Invoice Line Items
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @param mergeinvoiceLineItems public domain model = MergeinvoiceLineItems
   * @return OK
   */
  mergeInvoiceLineItems2(
    practiceid: string,
    invoiceId: string,
    mergeinvoiceLineItems: MergeInvoiceLineItems
  ): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/mergeinvoicelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeInvoiceLineItems2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeInvoiceLineItems2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeInvoiceLineItems2(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * Merging Invoice Line Items
   * @param practiceid Unique identifier of practice
   * @param mergeinvoiceLineItems public domain model = MergeinvoiceLineItems
   * @return OK
   */
  mergeLineItems(practiceid: string, mergeinvoiceLineItems: MergeInvoiceLineItems): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/mergeinvoicelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeLineItems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeLineItems(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeLineItems(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * Merging Invoice Line Items
   * @param practiceid Unique identifier of practice
   * @param mergeinvoiceLineItems public domain model = MergeinvoiceLineItems
   * @return OK
   */
  mergeLineItems2(practiceid: string, mergeinvoiceLineItems: MergeInvoiceLineItems): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/mergeinvoicelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeLineItems2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeLineItems2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeLineItems2(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * Merging Invoice Hospital Indicator
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @param mergeinvoiceHospital public domain model = MergeInvoiceHospital
   * @return OK
   */
  mergeInvoiceHospitalIndicator(
    practiceid: string,
    invoiceId: string,
    mergeinvoiceHospital: MergeInvoiceHospital
  ): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/mergeinvoicehospitalindicator';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeInvoiceHospitalIndicator(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeInvoiceHospitalIndicator(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeInvoiceHospitalIndicator(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * Merging Invoice Hospital Indicator
   * @param practiceid Unique identifier of practice
   * @param invoiceId Unique identifier of invoice
   * @param mergeinvoiceHospital public domain model = MergeInvoiceHospital
   * @return OK
   */
  mergeInvoiceHospitalIndicator2(
    practiceid: string,
    invoiceId: string,
    mergeinvoiceHospital: MergeInvoiceHospital
  ): Observable<RestApiResultOfInvoiceLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceId}/mergeinvoicehospitalindicator';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceId === undefined || invoiceId === null) throw new Error("The parameter 'invoiceId' must be defined.");
    url_ = url_.replace('{invoiceId}', encodeURIComponent('' + invoiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeinvoiceHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeInvoiceHospitalIndicator2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeInvoiceHospitalIndicator2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInvoiceLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeInvoiceHospitalIndicator2(response: HttpResponseBase): Observable<RestApiResultOfInvoiceLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInvoiceLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInvoiceLineItemsVo>(<any>null);
  }

  /**
   * @return OK
   */
  updateDiagnosis(updateDiagnosis: UpdateDiagnosis): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosis/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDiagnosis);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDiagnosis(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDiagnosis(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateDiagnosis(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * @return OK
   */
  updateDiagnosis2(updateDiagnosisRanked: UpdateDiagnosisRanked): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosisranked/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDiagnosisRanked);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDiagnosis2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDiagnosis2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateDiagnosis2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Update speciality rule
   * @return OK
   */
  updateSpecialityRule(specialityRule: SpecialityRuleVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/specialityrule/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(specialityRule);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSpecialityRule(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSpecialityRule(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateSpecialityRule(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Deactivate speciality rule
   * @return OK
   */
  deactivate(specialityRule: DeactivateSpecialityRule): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/specialityrule/deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(specialityRule);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * @return OK
   */
  deactivate2(deactivateDiagnosis: DeactivateDiagnosis): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosis/deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateDiagnosis);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivate2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivate2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Bulk update speciality rules
   * @return OK
   */
  updateSpecialityRuleBulk(specialityRules: SpecialityRuleVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/specialityrule/bulkupdate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(specialityRules);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSpecialityRuleBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSpecialityRuleBulk(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateSpecialityRuleBulk(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * @return OK
   */
  deactivateDiagnosisRanked(deactivateDiagnosisRanked: DeactivateDiagnosisRanked): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosisranked/deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateDiagnosisRanked);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivateDiagnosisRanked(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivateDiagnosisRanked(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivateDiagnosisRanked(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do update of diagnosis code
   * @return OK
   */
  updateDiagnosisBulk(updateDiagnoses: UpdateDiagnosis[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosis/updatebulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDiagnoses);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDiagnosisBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDiagnosisBulk(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateDiagnosisBulk(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do update of diagnosis explicitly (
   * @return OK
   */
  bulkUpdateDiagnosis(daignosis: DiagnosisVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosis/bulkupdate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(daignosis);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkUpdateDiagnosis(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkUpdateDiagnosis(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkUpdateDiagnosis(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do update of charge code
   * @return OK
   */
  updateDiagnosisRankBulk(updateDiagnosisRankeds: UpdateDiagnosisRanked[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosisranked/updatebulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateDiagnosisRankeds);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDiagnosisRankBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDiagnosisRankBulk(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateDiagnosisRankBulk(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do deactivate diagnoses
   * @return OK
   */
  deactivateDiagnosisBulk(deactivateDiagnoses: DeactivateDiagnosis[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosis/deactivatebulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateDiagnoses);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivateDiagnosisBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivateDiagnosisBulk(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivateDiagnosisBulk(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do deactivate of diagnoses
   * @return OK
   */
  deactivateDiagnosisRankBulk(deactivateDiagnosisRankeds: DeactivateDiagnosisRanked[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/diagnosisranked/deactivatebulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateDiagnosisRankeds);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivateDiagnosisRankBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivateDiagnosisRankBulk(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivateDiagnosisRankBulk(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to update contracts for specified provider
   * @return OK
   */
  updateProviderContracts(
    practiceId: string,
    configurationContracts: UpdateProviderConfigurationContracts
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/providers/{practiceId}/contracts';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configurationContracts);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProviderContracts(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProviderContracts(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProviderContracts(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get practice billing providers by provider Id
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getPracticeProviderList(practiceid: string): Observable<ProviderConfigurationVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/provider/{practiceid}/practiceproviderlist';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPracticeProviderList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPracticeProviderList(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPracticeProviderList(response: HttpResponseBase): Observable<ProviderConfigurationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class CardPaymentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Returns the status of a specific card payment
   * @param tenantid Tenant id
   * @param paymentid Card Payment NodeId
   * @return OK
   */
  getCardPaymentStatus(tenantid: string, paymentid: string): Observable<CardPaymentStatus> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments/{paymentid}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (paymentid === undefined || paymentid === null) throw new Error("The parameter 'paymentid' must be defined.");
    url_ = url_.replace('{paymentid}', encodeURIComponent('' + paymentid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPaymentStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPaymentStatus(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentStatus>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentStatus>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPaymentStatus(response: HttpResponseBase): Observable<CardPaymentStatus> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentStatus>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentStatus>(<any>null);
  }

  /**
   * Returns the status of a specific card payment by external reference
   * @param tenantid Tenant id
   * @param paymentXRef Card Payment XRef
   * @return OK
   */
  getCardPaymentStatus2(tenantid: string, paymentXRef: string): Observable<CardPaymentStatus> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments/xref/{paymentXRef}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (paymentXRef === undefined || paymentXRef === null) throw new Error("The parameter 'paymentXRef' must be defined.");
    url_ = url_.replace('{paymentXRef}', encodeURIComponent('' + paymentXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPaymentStatus2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPaymentStatus2(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentStatus>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentStatus>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPaymentStatus2(response: HttpResponseBase): Observable<CardPaymentStatus> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentStatus>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentStatus>(<any>null);
  }

  /**
   * Returns the status of a specific card payment
   * @param tenantXRef Tenant xref
   * @param paymentid Card Payment NodeId
   * @return OK
   */
  getCardPaymentStatus3(tenantXRef: string, paymentid: string): Observable<CardPaymentStatus> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/cardprocessing/cardpayments/{paymentid}';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    if (paymentid === undefined || paymentid === null) throw new Error("The parameter 'paymentid' must be defined.");
    url_ = url_.replace('{paymentid}', encodeURIComponent('' + paymentid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPaymentStatus3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPaymentStatus3(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentStatus>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentStatus>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPaymentStatus3(response: HttpResponseBase): Observable<CardPaymentStatus> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentStatus>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentStatus>(<any>null);
  }

  /**
   * Returns the status of all card payments for specific tenant
   * @param tenantid Tenant id
   * @return OK
   */
  getCardPaymentsAll(tenantid: string): Observable<CardPaymentStatus[]> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPaymentsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPaymentsAll(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentStatus[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentStatus[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPaymentsAll(response: HttpResponseBase): Observable<CardPaymentStatus[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentStatus[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentStatus[]>(<any>null);
  }

  /**
   * Requests a new card payment
   * @param tenantid Tenant id
   * @param cardPayment Details of the card payment to be made.
   * @return OK
   */
  requestCardPayment(tenantid: string, cardPayment: CardPayment): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardPayment);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestCardPayment(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestCardPayment(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestCardPayment(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Requests a new card payment
   * @param tenantid Tenant id
   * @param cardPayment Details of the card payment to be made.
   * @return OK
   */
  requestCardPayment2(tenantid: string, cardPayment: CardPayment): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardPayment);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestCardPayment2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestCardPayment2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestCardPayment2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Returns the status of all card payments for specific tenant
   * @param tenantid Tenant id
   * @param filter filter
   * @return OK
   */
  getCardPayments(tenantid: string, filter: CardPaymentFilterVo): Observable<CardPaymentsByDateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardpayments/filter';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPayments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPayments(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentsByDateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentsByDateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPayments(response: HttpResponseBase): Observable<CardPaymentsByDateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentsByDateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentsByDateVo[]>(<any>null);
  }

  /**
   * Returns a specific Card Reader
   * @param tenantid Tenant id
   * @param cardReaderId Card Reader id
   * @return OK
   */
  getCardReader(tenantid: string, cardReaderId: string): Observable<CardReaderVo> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders/{cardReaderId}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (cardReaderId === undefined || cardReaderId === null) throw new Error("The parameter 'cardReaderId' must be defined.");
    url_ = url_.replace('{cardReaderId}', encodeURIComponent('' + cardReaderId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardReader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardReader(<any>response_);
            } catch (e) {
              return <Observable<CardReaderVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardReaderVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardReader(response: HttpResponseBase): Observable<CardReaderVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardReaderVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardReaderVo>(<any>null);
  }

  /**
   * Updates the details for an existing Card Reader
   * @param tenantid Tenant id
   * @param cardReaderId Card Reader id
   * @param cardReader Details of the Card Reader to be updated.
   * @return OK
   */
  updateCardReader(tenantid: string, cardReaderId: string, cardReader: CardReaderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders/{cardReaderId}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (cardReaderId === undefined || cardReaderId === null) throw new Error("The parameter 'cardReaderId' must be defined.");
    url_ = url_.replace('{cardReaderId}', encodeURIComponent('' + cardReaderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardReader);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCardReader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCardReader(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCardReader(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates the details for an existing Card Reader
   * @param tenantid Tenant id
   * @param cardReaderId Card Reader id
   * @param cardReader Details of the Card Reader to be updated.
   * @return OK
   */
  updateCardReader2(tenantid: string, cardReaderId: string, cardReader: CardReaderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders/{cardReaderId}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (cardReaderId === undefined || cardReaderId === null) throw new Error("The parameter 'cardReaderId' must be defined.");
    url_ = url_.replace('{cardReaderId}', encodeURIComponent('' + cardReaderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardReader);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCardReader2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCardReader2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCardReader2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates a Card Reader
   * @param tenantid Tenant id
   * @param cardReaderId Card Reader id
   * @return OK
   */
  removeCardReader(tenantid: string, cardReaderId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders/{cardReaderId}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    if (cardReaderId === undefined || cardReaderId === null) throw new Error("The parameter 'cardReaderId' must be defined.");
    url_ = url_.replace('{cardReaderId}', encodeURIComponent('' + cardReaderId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveCardReader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveCardReader(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveCardReader(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Returns the list of Card Readers
   * @param tenantid Tenant id
   * @return OK
   */
  getCardReaders(tenantid: string): Observable<CardReaderVo[]> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardReaders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardReaders(<any>response_);
            } catch (e) {
              return <Observable<CardReaderVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardReaderVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardReaders(response: HttpResponseBase): Observable<CardReaderVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardReaderVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardReaderVo[]>(<any>null);
  }

  /**
   * Adds a new Card Reader
   * @param tenantid Tenant id
   * @param cardReader Details of the Card Reader to be added.
   * @return OK
   */
  addCardReader(tenantid: string, cardReader: CardReaderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardReader);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCardReader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCardReader(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddCardReader(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Adds a new Card Reader
   * @param tenantid Tenant id
   * @param cardReader Details of the Card Reader to be added.
   * @return OK
   */
  addCardReader2(tenantid: string, cardReader: CardReaderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{tenantid}/cardprocessing/cardreaders';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardReader);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCardReader2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCardReader2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddCardReader2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Requests a new card payment
   * @param tenantXRef Tenant xref
   * @param cardPayment Details of the card payment to be made.
   * @return OK
   */
  requestCardPaymentByXref(tenantXRef: string, cardPayment: CardPayment): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/cardprocessing/cardpayments';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardPayment);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestCardPaymentByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestCardPaymentByXref(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestCardPaymentByXref(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Requests a new card payment
   * @param tenantXRef Tenant xref
   * @param cardPayment Details of the card payment to be made.
   * @return OK
   */
  requestCardPaymentByXref2(tenantXRef: string, cardPayment: CardPayment): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/cardprocessing/cardpayments';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cardPayment);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestCardPaymentByXref2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestCardPaymentByXref2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestCardPaymentByXref2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Returns the status of a specific card payment by external reference
   * @param tenantXRef Tenant xref
   * @param paymentXRef Card Payment XRef
   * @return OK
   */
  getCardPaymentStatusByXRef(tenantXRef: string, paymentXRef: string): Observable<CardPaymentStatus> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/cardprocessing/cardpayments/xref/{paymentXRef}';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    if (paymentXRef === undefined || paymentXRef === null) throw new Error("The parameter 'paymentXRef' must be defined.");
    url_ = url_.replace('{paymentXRef}', encodeURIComponent('' + paymentXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCardPaymentStatusByXRef(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCardPaymentStatusByXRef(<any>response_);
            } catch (e) {
              return <Observable<CardPaymentStatus>>(<any>_observableThrow(e));
            }
          } else return <Observable<CardPaymentStatus>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCardPaymentStatusByXRef(response: HttpResponseBase): Observable<CardPaymentStatus> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CardPaymentStatus>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CardPaymentStatus>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ChargeCodeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get all charge codes
   * @return OK
   */
  get(): Observable<ChargeCodeVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/chargecodes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<ChargeCodeVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ChargeCodeVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ChargeCodeVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ChargeCodeVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ChargeCodeVo[]>(<any>null);
  }

  /**
   * Get all charge codes
   * @return OK
   */
  getByType(type: string): Observable<ChargeCodeVo[]> {
    let url_ = this.baseUrl + '/api/v1/billing/chargecodes/{type}';
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByType(<any>response_);
            } catch (e) {
              return <Observable<ChargeCodeVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ChargeCodeVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetByType(response: HttpResponseBase): Observable<ChargeCodeVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ChargeCodeVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ChargeCodeVo[]>(<any>null);
  }

  /**
   * Used to do update of charge code
   * @return OK
   */
  update(updateChargeCode: UpdateChargeCode): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/chargecodes/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateChargeCode);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do add of charge code
   * @return OK
   */
  bulkUpdate(updateChargeCode: ChargeCodeVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/chargecodes/bulkupdate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateChargeCode);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do deactivate of charge code
   * @return OK
   */
  deactivate(deactivateChargeCode: DeactivateChargeCode): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/billing/chargecodes/deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateChargeCode);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClaimClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Send claim
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  sendClaim(practiceid: string, claim: Claim): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/claiming/claims/sendclaim';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(claim);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendClaim(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendClaim(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendClaim(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get claim by their id
   * @param practiceid practice NodeId
   * @param claimid claim id
   * @return OK
   */
  getClaim(practiceid: string, claimid: string): Observable<Claim> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/claiming/claims/{claimid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (claimid === undefined || claimid === null) throw new Error("The parameter 'claimid' must be defined.");
    url_ = url_.replace('{claimid}', encodeURIComponent('' + claimid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClaim(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClaim(<any>response_);
            } catch (e) {
              return <Observable<Claim>>(<any>_observableThrow(e));
            }
          } else return <Observable<Claim>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClaim(response: HttpResponseBase): Observable<Claim> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Claim>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Claim>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClinicalClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Returns all encounters for a practice
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getEncounterAll(practiceid: string): Observable<EncounterVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncounterAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncounterAll(<any>response_);
            } catch (e) {
              return <Observable<EncounterVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncounterAll(response: HttpResponseBase): Observable<EncounterVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterVo[]>(<any>null);
  }

  /**
   * Returns the encounter by Id
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @return OK
   */
  getEncounter(practiceid: string, encounterId: string): Observable<EncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncounter(<any>response_);
            } catch (e) {
              return <Observable<EncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncounter(response: HttpResponseBase): Observable<EncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterVo>(<any>null);
  }

  /**
   * Submit encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = Submitencounter
   * @return OK
   */
  completeEncounter(
    practiceid: string,
    encounterId: string,
    encounter: CompleteEncounter
  ): Observable<RestApiResultOfCompleteEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCompleteEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCompleteEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCompleteEncounterResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCompleteEncounterResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCompleteEncounter(response: HttpResponseBase): Observable<RestApiResultOfCompleteEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCompleteEncounterResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCompleteEncounterResult>(<any>null);
  }

  /**
   * Submit encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = Submitencounter
   * @return OK
   */
  completeEncounter2(
    practiceid: string,
    encounterId: string,
    encounter: CompleteEncounter
  ): Observable<RestApiResultOfCompleteEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCompleteEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCompleteEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCompleteEncounterResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCompleteEncounterResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCompleteEncounter2(response: HttpResponseBase): Observable<RestApiResultOfCompleteEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCompleteEncounterResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCompleteEncounterResult>(<any>null);
  }

  /**
   * Returns all encounters for specific patient
   * @param practiceId Unique identifier of practice
   * @return OK
   */
  getEncountersForPatient(practiceId: string, patientId: string): Observable<EncounterStatusVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/byPatientId/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncountersForPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncountersForPatient(<any>response_);
            } catch (e) {
              return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncountersForPatient(response: HttpResponseBase): Observable<EncounterStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterStatusVo[]>(<any>null);
  }

  /**
   * Returns the encounter by Id
   * @param practiceid Unique identifier of practice
   * @param patientVisitId Unique identifier of patient visit
   * @return OK
   */
  getEncounterByVisitId(practiceid: string, patientVisitId: string): Observable<EncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/bypatientvisitid/{patientVisitId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientVisitId === undefined || patientVisitId === null) throw new Error("The parameter 'patientVisitId' must be defined.");
    url_ = url_.replace('{patientVisitId}', encodeURIComponent('' + patientVisitId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncounterByVisitId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncounterByVisitId(<any>response_);
            } catch (e) {
              return <Observable<EncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncounterByVisitId(response: HttpResponseBase): Observable<EncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterVo>(<any>null);
  }

  /**
   * Returns active encounter for patient
   * @param practiceId Unique identifier of practice
   * @param patientId Unique identifier of patient id
   * @return OK
   */
  getActiveEncounter(practiceId: string, patientId: string): Observable<EncounterStatusVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/byPatientId/{patientId}/active';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetActiveEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetActiveEncounter(<any>response_);
            } catch (e) {
              return <Observable<EncounterStatusVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterStatusVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetActiveEncounter(response: HttpResponseBase): Observable<EncounterStatusVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterStatusVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterStatusVo>(<any>null);
  }

  /**
   * Get list of templates for encounter (from mymps) or use local templates (for ihealth)
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter based on the patient visit
   * @return OK
   */
  getListOfTemplatesForEncounter(practiceid: string, encounterId: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/templates';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplatesForEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplatesForEncounter(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplatesForEncounter(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
   * Get of encounter templates
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getListOfTemplatesAll(practiceid: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplatesAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplatesAll(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplatesAll(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
   * Create encounter template
   * @param practiceid Unique identifier of practice
   * @param encounterTemplate encounter template object
   * @return OK
   */
  updateEncounterTemplate(practiceid: string, encounterTemplate: UpdateEncounterTemplate): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEncounterTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateEncounterTemplate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateEncounterTemplate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get of encounter templates based on external practice XRef
   * @param practiceXRef Unique external identifier of practice
   * @return OK
   */
  getListOfTemplates(practiceXRef: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/clinical/encountertemplates';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplates(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplates(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
     * Generate multiple report based on provided separate htmls and save in one pdf
    Stateless/pure function
     * @param practiceId practice id
     * @param htmls list of communications which should combined into one pdf
     * @return OK
     */
  getCommunicationReportsAsSinglePdf(practiceId: string, encounterId: string, htmls: string[]): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/{encounterId}/communications/htmltopdf';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(htmls);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCommunicationReportsAsSinglePdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCommunicationReportsAsSinglePdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processGetCommunicationReportsAsSinglePdf(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }

  /**
   * Generate communication reports as single PDF and capture as patient document
   * @param practiceId practice id
   * @param encounterId encounter id
   * @param patientId patient id
   * @return OK
   */
  captureAsSingleDocumentPdf(
    practiceId: string,
    encounterId: string,
    patientId: string,
    request: CommunicationPdfCaptureRequest
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/{encounterId}/communications/{patientId}/htmltopdf/capture';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaptureAsSingleDocumentPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaptureAsSingleDocumentPdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processCaptureAsSingleDocumentPdf(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }

  /**
   * Get of encounter templates based on template
   * @param practiceid Unique identifier of practice
   * @param type template type
   * @return OK
   */
  getListOfTemplates2(practiceid: string, type: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{type}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplates2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplates2(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplates2(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
   * Deletes a encounter template in the practice by type
   * @param practiceid Id of the practice that owns the templateid data
   * @return OK
   */
  removeEncounterTemplatesByGroups(practiceid: string, type: string): Observable<RestApiResultOfInt32> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{type}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveEncounterTemplatesByGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveEncounterTemplatesByGroups(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInt32>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInt32>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveEncounterTemplatesByGroups(response: HttpResponseBase): Observable<RestApiResultOfInt32> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInt32>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInt32>(<any>null);
  }

  /**
   * Get of encounter templates for specific type based on external practice xref
   * @param practiceXRef Unique external identifier of practice
   * @param type template type (MyTemplate, Diagnosis, Medicine, Procedure, Consumable, etc)
   * @return OK
   */
  getListOfTemplates3(practiceXRef: string, type: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/clinical/encountertemplates/{type}';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetListOfTemplates3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetListOfTemplates3(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetListOfTemplates3(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
   * Get encounter template by id
   * @param practiceid Unique identifier of practice
   * @param templateid Unique identifier of template
   * @return OK
   */
  getEncounterTemplateById(practiceid: string, templateid: string): Observable<EncounterTemplateVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncounterTemplateById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncounterTemplateById(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncounterTemplateById(response: HttpResponseBase): Observable<EncounterTemplateVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo>(<any>null);
  }

  /**
   * Update existing encounter template
   * @param practiceid Unique identifier of practice
   * @param templateid Unique identifier of template
   * @param updateencountertemplate Update encounter template command
   * @return OK
   */
  updateEncounterTemplate2(
    practiceid: string,
    templateid: string,
    updateencountertemplate: UpdateEncounterTemplate
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateencountertemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEncounterTemplate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateEncounterTemplate2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateEncounterTemplate2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update existing encounter template
   * @param practiceid Unique identifier of practice
   * @param templateid Unique identifier of template
   * @param updateencountertemplate Update encounter template command
   * @return OK
   */
  updateEncounterTemplate3(
    practiceid: string,
    templateid: string,
    updateencountertemplate: UpdateEncounterTemplate
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateencountertemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEncounterTemplate3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateEncounterTemplate3(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateEncounterTemplate3(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Deletes a encounter template in the practice
   * @param practiceid Id of the practice that owns the templateid data
   * @param templateid Id of the templateid to be updated
   * @return OK
   */
  removeEncounterTemplate(practiceid: string, templateid: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveEncounterTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveEncounterTemplate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveEncounterTemplate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get filtered Diagnoses
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getDiagnosis(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupdiagnosis/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiagnosis(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiagnosis(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDiagnosis(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Diagnoses
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getDiagnosisRanking(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsRankingVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupdiagnosisranking/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiagnosisRanking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiagnosisRanking(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsRankingVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsRankingVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDiagnosisRanking(response: HttpResponseBase): Observable<EncounterLineItemsRankingVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsRankingVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsRankingVo[]>(<any>null);
  }

  /**
   * Get filtered Diagnoses
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  loadDiagnosisRanking(practiceid: string, invoiceid: string, request: RequestDiagnosisRanking): Observable<EncounterLineItemsRankingVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/billing/invoices/{invoiceid}/lookupdiagnosisranking';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (invoiceid === undefined || invoiceid === null) throw new Error("The parameter 'invoiceid' must be defined.");
    url_ = url_.replace('{invoiceid}', encodeURIComponent('' + invoiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLoadDiagnosisRanking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLoadDiagnosisRanking(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<InvoiceLineItemsRankingVo[]>;
            }
          } else return _observableThrow(response_) as any as Observable<InvoiceLineItemsRankingVo[]>;
        })
      );
  }

  protected processLoadDiagnosisRanking(response: HttpResponseBase): Observable<InvoiceLineItemsRankingVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as InvoiceLineItemsRankingVo[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InvoiceLineItemsRankingVo[]>(null as any);
  }
  /**
   * Get filtered Procedures
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getProceduresAll(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupprocedure/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProceduresAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProceduresAll(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProceduresAll(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Procedures
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getProcedures(practiceid: string, encounterId: string, lookupfilter: string, dateOfService: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupprocedure/{lookupfilter}/dos/{dateOfService}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    if (dateOfService === undefined || dateOfService === null) throw new Error("The parameter 'dateOfService' must be defined.");
    url_ = url_.replace('{dateOfService}', encodeURIComponent('' + dateOfService));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProcedures(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProcedures(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProcedures(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Modifier
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getModifiers(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupmodifier/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetModifiers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetModifiers(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetModifiers(response: HttpResponseBase): Observable<EncounterLineItemVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemVo[]>(<any>null);
  }

  /**
   * Get Medical Insurer Procedures
   * @param practiceid Unique identifier of practice
   * @param insurerXref Minimum length of filter is 3 characters
   * @return OK
   */
  getInsurerProcedures(practiceid: string, encounterId: string, insurerXref: string): Observable<EncounterTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupmedicalinsurerprocedure/{insurerXref}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (insurerXref === undefined || insurerXref === null) throw new Error("The parameter 'insurerXref' must be defined.");
    url_ = url_.replace('{insurerXref}', encodeURIComponent('' + insurerXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInsurerProcedures(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInsurerProcedures(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInsurerProcedures(response: HttpResponseBase): Observable<EncounterTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo[]>(<any>null);
  }

  /**
   * Get filtered Medicines
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getMedicines(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupmedicine/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicines(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicines(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicines(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Get filtered Medicines
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getPrescriptions(practiceid: string, encounterId: string, lookupfilter: string): Observable<MedicationPrescriptionLine[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupprescription/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPrescriptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPrescriptions(<any>response_);
            } catch (e) {
              return <Observable<MedicationPrescriptionLine[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<MedicationPrescriptionLine[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPrescriptions(response: HttpResponseBase): Observable<MedicationPrescriptionLine[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <MedicationPrescriptionLine[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MedicationPrescriptionLine[]>(<any>null);
  }

  /**
   * Get filtered Consumables
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getConsumables(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupconsumable/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConsumables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConsumables(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetConsumables(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Get referral templates list for provided encounter
   * @return OK
   */
  getReferrals(practiceId: string, encounterTemplateId: string): Observable<CommunicationTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encountertemplates/{encounterTemplateId}/referrals';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterTemplateId === undefined || encounterTemplateId === null)
      throw new Error("The parameter 'encounterTemplateId' must be defined.");
    url_ = url_.replace('{encounterTemplateId}', encodeURIComponent('' + encounterTemplateId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReferrals(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReferrals(<any>response_);
            } catch (e) {
              return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReferrals(response: HttpResponseBase): Observable<CommunicationTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CommunicationTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CommunicationTemplateVo[]>(<any>null);
  }

  /**
   * Get communication template body
   * @return OK
   */
  getRenderReferralTemplate(practiceId: string, encounterId: string, templateId: string, indexId: number): Observable<string> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/communications/{templateId}/{indexId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (templateId === undefined || templateId === null) throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    if (indexId === undefined || indexId === null) throw new Error("The parameter 'indexId' must be defined.");
    url_ = url_.replace('{indexId}', encodeURIComponent('' + indexId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRenderReferralTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRenderReferralTemplate(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRenderReferralTemplate(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Get communication template body in pdf format
   * @return OK
   */
  getRenderReferralTemplatePdf(practiceId: string, encounterId: string, templateId: string, indexId: number): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/communications/{templateId}/pdf/{indexId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (templateId === undefined || templateId === null) throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    if (indexId === undefined || indexId === null) throw new Error("The parameter 'indexId' must be defined.");
    url_ = url_.replace('{indexId}', encodeURIComponent('' + indexId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRenderReferralTemplatePdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRenderReferralTemplatePdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRenderReferralTemplatePdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get filtered Medicines and Consumables
   * @param practiceid Unique identifier of practice
   * @param lookupfilter Minimum length of filter is 3 characters
   * @return OK
   */
  getMedicinesAndConsumables(practiceid: string, encounterId: string, lookupfilter: string): Observable<EncounterLineItemsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/lookupmedicineandconsumable/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicinesAndConsumables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicinesAndConsumables(<any>response_);
            } catch (e) {
              return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterLineItemsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicinesAndConsumables(response: HttpResponseBase): Observable<EncounterLineItemsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterLineItemsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterLineItemsVo[]>(<any>null);
  }

  /**
   * Save encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = SaveEncounter
   * @return OK
   */
  saveEncounter(practiceid: string, encounterId: string, encounter: SaveEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/save';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSaveEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Save encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = SaveEncounter
   * @return OK
   */
  saveEncounter2(practiceid: string, encounterId: string, encounter: SaveEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/save';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSaveEncounter2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Records historical encounter
   * @param practiceid Unique identifier of practice
   * @param encounter Encounter object
   * @return OK
   */
  postHistoricalEncounter(practiceid: string, encounter: RecordHistoricalEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/historicalencounter';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostHistoricalEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostHistoricalEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPostHistoricalEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
     * Return expected meta-data required to properly apply calculation logic for specific modifier
    (e.g. 0018 it would be 2 elements: Weight,Height)
     * @param practiceId Unique identifier of practice
     * @param code Unique identifier of modifier (e.g. 00005,0009, etc)
     * @return OK
     */
  getModifiersRequiredInfo(practiceId: string, code: string): Observable<ModifierRequiredParameter[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/modifiers/{code}/requiredinfo';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetModifiersRequiredInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetModifiersRequiredInfo(<any>response_);
            } catch (e) {
              return <Observable<ModifierRequiredParameter[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ModifierRequiredParameter[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetModifiersRequiredInfo(response: HttpResponseBase): Observable<ModifierRequiredParameter[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ModifierRequiredParameter[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ModifierRequiredParameter[]>(<any>null);
  }

  /**
     * Return modifier info (expected meta-data required to properly apply calculation logic for specific modifier), status
    (e.g. 0018 it would be 2 elements: Weight,Height)
     * @param practiceId Unique identifier of practice
     * @param code Unique identifier of modifier (e.g. 00005,0009, etc)
     * @return OK
     */
  getModifiersInfo(practiceId: string, code: string): Observable<ModifierInformation> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/modifiers/{code}/info';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetModifiersInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetModifiersInfo(<any>response_);
            } catch (e) {
              return <Observable<ModifierInformation>>(<any>_observableThrow(e));
            }
          } else return <Observable<ModifierInformation>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetModifiersInfo(response: HttpResponseBase): Observable<ModifierInformation> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ModifierInformation>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ModifierInformation>(<any>null);
  }

  /**
   * Get list of all billing providers
   * @return OK
   */
  getProviders(): Observable<ProviderConfigurationVo2[]> {
    let url_ = this.baseUrl + '/api/v1/clinical/providers';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProviders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProviders(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo2[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo2[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProviders(response: HttpResponseBase): Observable<ProviderConfigurationVo2[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo2[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo2[]>(<any>null);
  }

  /**
   * Get billing provider by Id
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getProvider(practiceid: string): Observable<ProviderConfigurationVo2> {
    let url_ = this.baseUrl + '/api/v1/clinical/provider/{practiceid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProvider(<any>response_);
            } catch (e) {
              return <Observable<ProviderConfigurationVo2>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProviderConfigurationVo2>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetProvider(response: HttpResponseBase): Observable<ProviderConfigurationVo2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ProviderConfigurationVo2>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConfigurationVo2>(<any>null);
  }

  /**
   * Convert Html to PDF
   * @return OK
   */
  htmlToPdf(html: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/report/htmltopdf';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(html);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHtmlToPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHtmlToPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processHtmlToPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Convert Html to PDF and save
   * @param watermark (optional)
   * @param password (optional)
   * @return OK
   */
  saveHtmlToPdf(
    html: string,
    watermark?: string | null | undefined,
    password?: string | null | undefined
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/report/savehtmltopdf?';
    if (watermark !== undefined && watermark !== null) url_ += 'watermark=' + encodeURIComponent('' + watermark) + '&';
    if (password !== undefined && password !== null) url_ += 'password=' + encodeURIComponent('' + password) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(html);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveHtmlToPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveHtmlToPdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processSaveHtmlToPdf(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }
  /**
   * Encrypt an existing PDF file with password protection
   * @param pdfBytes PDF file content as byte array
   * @param password Password to encrypt the PDF
   * @return OK
   */
  encryptPdf(pdfBytes: string, password: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/report/encryptpdf?';
    if (password === undefined || password === null) throw new Error("The parameter 'password' must be defined and cannot be null.");
    else url_ += 'password=' + encodeURIComponent('' + password) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(pdfBytes);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEncryptPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEncryptPdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<any>;
            }
          } else return _observableThrow(response_) as any as Observable<any>;
        })
      );
  }

  protected processEncryptPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(null as any);
  }

  /**
   * Encrypt an existing PDF file and save it to the reports folder
   * @param pdfBytes PDF file content as byte array
   * @param password Password to encrypt the PDF
   * @return OK
   */
  saveEncryptPdf(pdfBytes: string, password: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/report/saveencryptpdf?';
    if (password === undefined || password === null) throw new Error("The parameter 'password' must be defined and cannot be null.");
    else url_ += 'password=' + encodeURIComponent('' + password) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(pdfBytes);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveEncryptPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveEncryptPdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processSaveEncryptPdf(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }
  /**
   * Generate prescription report for provided encounter
   * @param practiceId practice id
   * @param encounterVo encounter object for which we need to generate prescription
   * @return OK
   */
  generatePrescriptionReport(practiceId: string, encounterVo: EncounterVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/prescription/report';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeneratePrescriptionReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeneratePrescriptionReport(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGeneratePrescriptionReport(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Generate prescription report for provided encounter based on EncounterId and PrescriptionId
   * @param practiceid practice id
   * @param encounterVo encounter object for which we need to generate prescription
   * @param prescriptionId prescription Id
   * @return OK
   */
  generatePrescriptionReportById(practiceid: string, encounterVo: EncounterVo, prescriptionId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/prescription/report/{prescriptionId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (prescriptionId === undefined || prescriptionId === null) throw new Error("The parameter 'prescriptionId' must be defined.");
    url_ = url_.replace('{prescriptionId}', encodeURIComponent('' + prescriptionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeneratePrescriptionReportById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeneratePrescriptionReportById(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGeneratePrescriptionReportById(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Generate prescription report for provided encounter in pdf format
   * @param practiceid practice id
   * @param encounterVo encounter object for which we need to generate prescription
   * @return OK
   */
  generatePrescriptionReportPdf(practiceid: string, encounterVo: EncounterVo): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/prescription/report/pdf';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeneratePrescriptionReportPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeneratePrescriptionReportPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGeneratePrescriptionReportPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Generate sick notes report for provided encounter
   * @param practiceId practice id
   * @param encounterVo encounter object for which we need to generate sick note
   * @return OK
   */
  generateMedicalCertificateReport(practiceId: string, encounterVo: EncounterVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/medicalcertificate/report/html';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerateMedicalCertificateReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerateMedicalCertificateReport(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGenerateMedicalCertificateReport(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Return all barcode to nappi mappings
   * @return OK
   */
  getAllBarcodeNappiMappings(): Observable<BarcodeNappiMappingVo[]> {
    let url_ = this.baseUrl + '/api/v1/clinical/barcodenappimapping';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllBarcodeNappiMappings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllBarcodeNappiMappings(<any>response_);
            } catch (e) {
              return <Observable<BarcodeNappiMappingVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<BarcodeNappiMappingVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllBarcodeNappiMappings(response: HttpResponseBase): Observable<BarcodeNappiMappingVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <BarcodeNappiMappingVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BarcodeNappiMappingVo[]>(<any>null);
  }

  /**
   * Update barcode to nappi code mapping
   * @return OK
   */
  updateBarcodeNappiMapping(mapping: BarcodeNappiMappingVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/clinical/barcodenappimapping';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mapping);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBarcodeNappiMapping(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBarcodeNappiMapping(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateBarcodeNappiMapping(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Use to delete existing barcode to nappi mapping
   * @return OK
   */
  updateBarcodeNappiMapping2(nappiCodeId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/clinical/barcodenappimapping/{nappiCodeId}';
    if (nappiCodeId === undefined || nappiCodeId === null) throw new Error("The parameter 'nappiCodeId' must be defined.");
    url_ = url_.replace('{nappiCodeId}', encodeURIComponent('' + nappiCodeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBarcodeNappiMapping2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBarcodeNappiMapping2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateBarcodeNappiMapping2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Lookup barcode to nappi code by barcode
   * @return OK
   */
  getBarcodeNappiMappingByBarcode(barcode: string): Observable<BarcodeNappiMappingVo> {
    let url_ = this.baseUrl + '/api/v1/clinical/barcodenappimapping/lookup/{barcode}/barcode';
    if (barcode === undefined || barcode === null) throw new Error("The parameter 'barcode' must be defined.");
    url_ = url_.replace('{barcode}', encodeURIComponent('' + barcode));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBarcodeNappiMappingByBarcode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBarcodeNappiMappingByBarcode(<any>response_);
            } catch (e) {
              return <Observable<BarcodeNappiMappingVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<BarcodeNappiMappingVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetBarcodeNappiMappingByBarcode(response: HttpResponseBase): Observable<BarcodeNappiMappingVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <BarcodeNappiMappingVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BarcodeNappiMappingVo>(<any>null);
  }

  /**
   * Lookup barcode to nappi code by nappi
   * @return OK
   */
  getBarcodeNappiMappingByNappi(nappi: string): Observable<BarcodeNappiMappingVo> {
    let url_ = this.baseUrl + '/api/v1/clinical/barcodenappimapping/lookup/{nappi}/nappi';
    if (nappi === undefined || nappi === null) throw new Error("The parameter 'nappi' must be defined.");
    url_ = url_.replace('{nappi}', encodeURIComponent('' + nappi));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBarcodeNappiMappingByNappi(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBarcodeNappiMappingByNappi(<any>response_);
            } catch (e) {
              return <Observable<BarcodeNappiMappingVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<BarcodeNappiMappingVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetBarcodeNappiMappingByNappi(response: HttpResponseBase): Observable<BarcodeNappiMappingVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <BarcodeNappiMappingVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BarcodeNappiMappingVo>(<any>null);
  }

  /**
   * Generate sick notes report for provided encounter in pdf format
   * @param practiceid practice id
   * @param encounterVo encounter object for which we need to generate sick note
   * @return OK
   */
  generateMedicalCertificateReportPdf(practiceid: string, encounterVo: EncounterVo): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/medicalcertificate/report/pdf';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerateMedicalCertificateReportPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerateMedicalCertificateReportPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGenerateMedicalCertificateReportPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Generate multiple report based on provided communications and save in one pdf
   * @param practiceId practice id
   * @param communications list of communications which should combined into one pdf
   * @return OK
   */
  generateCommunicationReports(
    practiceId: string,
    encounterId: string,
    communications: CommunicationVo[]
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/{encounterId}/communications/pdf';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(communications);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerateCommunicationReports(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerateCommunicationReports(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGenerateCommunicationReports(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Generate sick notes report for provided communication template in pdf format
   * @param practiceid practice id
   * @param encounterVo encounter object for which we need to generate sick note
   * @return OK
   */
  generateCommunicationReportPdf(
    practiceid: string,
    encounterId: string,
    communicationId: string,
    encounterVo: EncounterVo
  ): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/communication/{encounterId}/report/{communicationId}/pdf';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerateCommunicationReportPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerateCommunicationReportPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGenerateCommunicationReportPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Migrate encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = migrateencounter
   * @return OK
   */
  migrateEncounter(practiceid: string, encounterId: string, encounter: MigrateEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/migrate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrateEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrateEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMigrateEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Migrate encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = migrateencounter
   * @return OK
   */
  migrateEncounter2(practiceid: string, encounterId: string, encounter: MigrateEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/migrate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrateEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrateEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMigrateEncounter2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * @return OK
   */
  finishEncounterPUT(
    practiceId: string,
    encounterId: string,
    encounter: CompleteEncounter
  ): Observable<RestApiResultOfCompleteEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/finish';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFinishEncounterPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFinishEncounterPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfCompleteEncounterResult>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfCompleteEncounterResult>;
        })
      );
  }

  protected processFinishEncounterPUT(response: HttpResponseBase): Observable<RestApiResultOfCompleteEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfCompleteEncounterResult);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCompleteEncounterResult>(null as any);
  }

  /**
   * @return OK
   */
  finishEncounterPOST(
    practiceId: string,
    encounterId: string,
    encounter: CompleteEncounter
  ): Observable<RestApiResultOfCompleteEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/finish';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFinishEncounterPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFinishEncounterPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfCompleteEncounterResult>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfCompleteEncounterResult>;
        })
      );
  }

  protected processFinishEncounterPOST(response: HttpResponseBase): Observable<RestApiResultOfCompleteEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfCompleteEncounterResult);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCompleteEncounterResult>(null as any);
  }

  /**
   * Use to invite doctor
   * @return OK
   */
  inviteDoctor(providerId: string, doctor: InviteDoctorVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/referrals/invite';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(doctor);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInviteDoctor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInviteDoctor(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInviteDoctor(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Cancel encounter
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @return OK
   */
  cancelEncounter(practiceid: string, encounterId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/cancel';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCancelEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Remove encounter
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @return OK
   */
  removeEncounter(practiceid: string, encounterId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/remove';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Validate encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = Submitencounter
   * @return OK
   */
  validateEncounter(practiceid: string, encounterId: string, encounter: CompleteEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/validate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidateEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidateEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidateEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Validate encounter
   * @param practiceid Unique identifier of practice
   * @param encounter public domain model = Submitencounter
   * @return OK
   */
  validateEncounter2(practiceid: string, encounterId: string, encounter: CompleteEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/validate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidateEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidateEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidateEncounter2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
     * Refresh encounter, with 2 main goals
      1) switch encounter type which requires predefined lines
         (e.g. if Medical Insurance selected add Z02.6 diagnosis, delete line items)
      2) apply modifier calculations logic if any
     * @param practiceid Unique identifier of practice
     * @param refreshEncounter public domain model = RefreshEncounter
     * @return OK
     */
  refreshEncounter(practiceid: string, encounterId: string, refreshEncounter: RefreshEncounter): Observable<RestApiResultOfEncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/refresh';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(refreshEncounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRefreshEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRefreshEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRefreshEncounter(response: HttpResponseBase): Observable<RestApiResultOfEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterVo>(<any>null);
  }

  /**
     * Refresh encounter, with 2 main goals
      1) switch encounter type which requires predefined lines
         (e.g. if Medical Insurance selected add Z02.6 diagnosis, delete line items)
      2) apply modifier calculations logic if any
     * @param practiceid Unique identifier of practice
     * @param refreshEncounter public domain model = RefreshEncounter
     * @return OK
     */
  refreshEncounter2(practiceid: string, encounterId: string, refreshEncounter: RefreshEncounter): Observable<RestApiResultOfEncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/refresh';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(refreshEncounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRefreshEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRefreshEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRefreshEncounter2(response: HttpResponseBase): Observable<RestApiResultOfEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterVo>(<any>null);
  }

  /**
   * Get all historical encounters with prescription for provided patient
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getEncountersWithPrescription(practiceid: string, patientId: string): Observable<EncounterStatusVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patient/{patientId}/encounters/withprescriptions';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncountersWithPrescription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncountersWithPrescription(<any>response_);
            } catch (e) {
              return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncountersWithPrescription(response: HttpResponseBase): Observable<EncounterStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterStatusVo[]>(<any>null);
  }

  /**
   * Create encounter Template
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of the encounter
   * @param encounterTemplate public domain model = CreateencounterTemplate
   * @return OK
   */
  createEncounterTemplate(
    practiceid: string,
    encounterId: string,
    encounterTemplate: UpdateEncounterTemplate
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/createencountertemplate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateEncounterTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateEncounterTemplate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateEncounterTemplate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Used to do bulk update of templates for specific practice
   * @return OK
   */
  updateTemplates(practiceid: string, encounterTemplates: EncounterTemplateVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/bulkupdate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterTemplates);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTemplates(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateTemplates(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Merging encounter Line Items
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeencounterLineItems public domain model = MergeencounterLineItems
   * @return OK
   */
  mergeEncounterLineItems(
    practiceid: string,
    encounterId: string,
    mergeencounterLineItems: MergeEncounterLineItems
  ): Observable<RestApiResultOfMergeEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/mergeencounterlineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeencounterLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeEncounterLineItems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeEncounterLineItems(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfMergeEncounterResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfMergeEncounterResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeEncounterLineItems(response: HttpResponseBase): Observable<RestApiResultOfMergeEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfMergeEncounterResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfMergeEncounterResult>(<any>null);
  }

  /**
   * Merging encounter Line Items
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeencounterLineItems public domain model = MergeencounterLineItems
   * @return OK
   */
  mergeEncounterLineItems2(
    practiceid: string,
    encounterId: string,
    mergeencounterLineItems: MergeEncounterLineItems
  ): Observable<RestApiResultOfMergeEncounterResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/mergeencounterlineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeencounterLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeEncounterLineItems2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeEncounterLineItems2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfMergeEncounterResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfMergeEncounterResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeEncounterLineItems2(response: HttpResponseBase): Observable<RestApiResultOfMergeEncounterResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfMergeEncounterResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfMergeEncounterResult>(<any>null);
  }

  /**
   * Merging encounter template Line Items
   * @param practiceid Unique identifier of practice
   * @param templateId Unique identifier of template
   * @param mergeEncounterLineItems public domain model = MergeencounterLineItems
   * @return OK
   */
  mergeLineItems(
    practiceid: string,
    templateId: string,
    mergeEncounterLineItems: MergeEncounterTemplateLineItems
  ): Observable<RestApiResultOfEncounterTemplateVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateId}/mergelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateId === undefined || templateId === null) throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeLineItems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeLineItems(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterTemplateVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterTemplateVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeLineItems(response: HttpResponseBase): Observable<RestApiResultOfEncounterTemplateVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterTemplateVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterTemplateVo>(<any>null);
  }

  /**
   * Merging encounter template Line Items
   * @param practiceid Unique identifier of practice
   * @param templateId Unique identifier of template
   * @param mergeEncounterLineItems public domain model = MergeencounterLineItems
   * @return OK
   */
  mergeLineItems2(
    practiceid: string,
    templateId: string,
    mergeEncounterLineItems: MergeEncounterTemplateLineItems
  ): Observable<RestApiResultOfEncounterTemplateVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/{templateId}/mergelineitems';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (templateId === undefined || templateId === null) throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace('{templateId}', encodeURIComponent('' + templateId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterLineItems);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeLineItems2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeLineItems2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterTemplateVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterTemplateVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeLineItems2(response: HttpResponseBase): Observable<RestApiResultOfEncounterTemplateVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterTemplateVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterTemplateVo>(<any>null);
  }

  /**
   * Merging encounter Hospital Indicator
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeEncounterHospital public domain model = MergeencounterHospital
   * @return OK
   */
  mergeEncounterHospitalIndicator(
    practiceid: string,
    encounterId: string,
    mergeEncounterHospital: MergeEncounterHospital
  ): Observable<RestApiResultOfEncounterLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/mergeencounterhospitalindicator';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeEncounterHospitalIndicator(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeEncounterHospitalIndicator(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeEncounterHospitalIndicator(response: HttpResponseBase): Observable<RestApiResultOfEncounterLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterLineItemsVo>(<any>null);
  }

  /**
   * Merging encounter Hospital Indicator
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeEncounterHospital public domain model = MergeencounterHospital
   * @return OK
   */
  mergeEncounterHospitalIndicator2(
    practiceid: string,
    encounterId: string,
    mergeEncounterHospital: MergeEncounterHospital
  ): Observable<RestApiResultOfEncounterLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/mergeencounterhospitalindicator';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMergeEncounterHospitalIndicator2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMergeEncounterHospitalIndicator2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMergeEncounterHospitalIndicator2(response: HttpResponseBase): Observable<RestApiResultOfEncounterLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterLineItemsVo>(<any>null);
  }

  /**
   * Change encounter place of service
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeEncounterHospital public domain model = MergeencounterHospital
   * @return OK
   */
  changePlaceOfService(
    practiceid: string,
    encounterId: string,
    mergeEncounterHospital: MergeEncounterHospital
  ): Observable<RestApiResultOfEncounterLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/changeplaceofservice';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePlaceOfService(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePlaceOfService(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePlaceOfService(response: HttpResponseBase): Observable<RestApiResultOfEncounterLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterLineItemsVo>(<any>null);
  }

  /**
   * Change encounter place of service
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param mergeEncounterHospital public domain model = MergeencounterHospital
   * @return OK
   */
  changePlaceOfService2(
    practiceid: string,
    encounterId: string,
    mergeEncounterHospital: MergeEncounterHospital
  ): Observable<RestApiResultOfEncounterLineItemsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/changeplaceofservice';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(mergeEncounterHospital);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePlaceOfService2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePlaceOfService2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterLineItemsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePlaceOfService2(response: HttpResponseBase): Observable<RestApiResultOfEncounterLineItemsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterLineItemsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterLineItemsVo>(<any>null);
  }

  /**
   * Price encounter
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param encounterVo Encounter object
   * @return OK
   */
  priceEncounter(practiceid: string, encounterId: string, encounterVo: EncounterVo): Observable<RestApiResultOfEncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/price';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPriceEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPriceEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPriceEncounter(response: HttpResponseBase): Observable<RestApiResultOfEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterVo>(<any>null);
  }

  /**
   * Price encounter
   * @param practiceid Unique identifier of practice
   * @param encounterId Unique identifier of encounter
   * @param encounterVo Encounter object
   * @return OK
   */
  priceEncounter2(practiceid: string, encounterId: string, encounterVo: EncounterVo): Observable<RestApiResultOfEncounterVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/price';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPriceEncounter2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPriceEncounter2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPriceEncounter2(response: HttpResponseBase): Observable<RestApiResultOfEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEncounterVo>(<any>null);
  }

  /**
     * Initiate encounter communication and return communication body (
    rendered based on provided template)
     * @return OK
     */
  createCommunication(
    practiceId: string,
    encounterId: string,
    communicationId: string,
    encounter: EncounterVo
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/communications/{communicationId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCommunication(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCommunication(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateCommunication(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
     * Initiate encounter communication and return communication body (
    rendered based on provided template)
     * @return OK
     */
  createCommunication2(
    practiceId: string,
    encounterId: string,
    communicationId: string,
    encounter: EncounterVo
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounters/{encounterId}/communications/{communicationId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCommunication2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCommunication2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateCommunication2(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Update encounter communication with provided communication body
   * @return OK
   */
  updateCommunication(
    practiceid: string,
    encounterId: string,
    communicationId: string,
    indexId: number,
    body: UpdateEncounterCommunication
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/communications/{communicationId}/{indexId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    if (indexId === undefined || indexId === null) throw new Error("The parameter 'indexId' must be defined.");
    url_ = url_.replace('{indexId}', encodeURIComponent('' + indexId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCommunication(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCommunication(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCommunication(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Update encounter communication with provided communication body
   * @return OK
   */
  updateCommunication2(
    practiceid: string,
    encounterId: string,
    communicationId: string,
    indexId: number,
    body: UpdateEncounterCommunication
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encounters/{encounterId}/communications/{communicationId}/{indexId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    if (indexId === undefined || indexId === null) throw new Error("The parameter 'indexId' must be defined.");
    url_ = url_.replace('{indexId}', encodeURIComponent('' + indexId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCommunication2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCommunication2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCommunication2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get pathology report workflow in html format.
   * @param practiceId practice id
   * @param workflowId pathology report workflow id
   * @return OK
   */
  getPathologyReportWorkflowHtml(practiceId: string, workflowId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/{workflowId}/html';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (workflowId === undefined || workflowId === null) throw new Error("The parameter 'workflowId' must be defined.");
    url_ = url_.replace('{workflowId}', encodeURIComponent('' + workflowId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowHtml(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowHtml(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowHtml(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get pathology report workflow in pdf format.
   * @param practiceId practice id
   * @param workflowId pathology report workflow id
   * @return OK
   */
  getPathologyReportWorkflowPdf(practiceId: string, workflowId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/{workflowId}/pdf';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (workflowId === undefined || workflowId === null) throw new Error("The parameter 'workflowId' must be defined.");
    url_ = url_.replace('{workflowId}', encodeURIComponent('' + workflowId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get pathology report workflow
   * @param practiceId practice id
   * @param workflowId pathology report workflow id
   * @return OK
   */
  getPathologyReportWorkflow(practiceId: string, workflowId: string): Observable<PathologyReportWorkflowVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/{workflowId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (workflowId === undefined || workflowId === null) throw new Error("The parameter 'workflowId' must be defined.");
    url_ = url_.replace('{workflowId}', encodeURIComponent('' + workflowId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflow(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflow(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflow(response: HttpResponseBase): Observable<PathologyReportWorkflowVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo>(<any>null);
  }

  /**
   * Get all pathology reports for provided practice
   * @return OK
   */
  getPathologyReports(practiceId: string): Observable<PathologyReportDto[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReports(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReports(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportDto[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportDto[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReports(response: HttpResponseBase): Observable<PathologyReportDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportDto[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportDto[]>(<any>null);
  }

  /**
   * Get PathologyReports based on specified reports date range and status
   * @param practiceId practice id for which pathology reports belongs too
   * @param fromDate start report date
   * @param toDate end report date
   * @param status workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden
   * @return OK
   */
  getPathologyReportWorkflowsBasedOnDatesAndStatus(
    practiceId: string,
    fromDate: string,
    toDate: string,
    status: Status
  ): Observable<PathologyReportWorkflowVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/fromdate/{fromDate}/todate/{toDate}/status/{status}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (fromDate === undefined || fromDate === null) throw new Error("The parameter 'fromDate' must be defined.");
    url_ = url_.replace('{fromDate}', encodeURIComponent('' + fromDate));
    if (toDate === undefined || toDate === null) throw new Error("The parameter 'toDate' must be defined.");
    url_ = url_.replace('{toDate}', encodeURIComponent('' + toDate));
    if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace('{status}', encodeURIComponent('' + status));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsBasedOnDatesAndStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsBasedOnDatesAndStatus(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsBasedOnDatesAndStatus(response: HttpResponseBase): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get paged PathologyReports based on specified reports date range and status
   * @param practiceId practice id for which pathology reports belongs too
   * @param fromDate start report date
   * @param toDate end report date
   * @param status workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden
   * @return OK
   */
  getPathologyReportWorkflowsBasedOnDatesAndStatusPaged(
    practiceId: string,
    fromDate: string,
    toDate: string,
    status: Status2,
    pageSize: number,
    pageNumber: number
  ): Observable<PathologyReportWorkflowVo[]> {
    let url_ =
      this.baseUrl +
      '/api/v1/{practiceId}/clinical/pathologyreportworkflows/fromdate/{fromDate}/todate/{toDate}/status/{status}/pageSize/{pageSize}/pageNumber/{pageNumber}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (fromDate === undefined || fromDate === null) throw new Error("The parameter 'fromDate' must be defined.");
    url_ = url_.replace('{fromDate}', encodeURIComponent('' + fromDate));
    if (toDate === undefined || toDate === null) throw new Error("The parameter 'toDate' must be defined.");
    url_ = url_.replace('{toDate}', encodeURIComponent('' + toDate));
    if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace('{status}', encodeURIComponent('' + status));
    if (pageSize === undefined || pageSize === null) throw new Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace('{pageSize}', encodeURIComponent('' + pageSize));
    if (pageNumber === undefined || pageNumber === null) throw new Error("The parameter 'pageNumber' must be defined.");
    url_ = url_.replace('{pageNumber}', encodeURIComponent('' + pageNumber));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsBasedOnDatesAndStatusPaged(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsBasedOnDatesAndStatusPaged(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsBasedOnDatesAndStatusPaged(
    response: HttpResponseBase
  ): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get PathologyReports based on specified reports date range
   * @param practiceId practice id for which pathology reports belongs too
   * @param fromDate start report date
   * @param toDate end report date
   * @return OK
   */
  getPathologyReportWorkflowsBasedOnDate(practiceId: string, fromDate: string, toDate: string): Observable<PathologyReportWorkflowVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/fromdate/{fromDate}/todate/{toDate}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (fromDate === undefined || fromDate === null) throw new Error("The parameter 'fromDate' must be defined.");
    url_ = url_.replace('{fromDate}', encodeURIComponent('' + fromDate));
    if (toDate === undefined || toDate === null) throw new Error("The parameter 'toDate' must be defined.");
    url_ = url_.replace('{toDate}', encodeURIComponent('' + toDate));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsBasedOnDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsBasedOnDate(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsBasedOnDate(response: HttpResponseBase): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get PathologyReports based on specified report status
   * @param practiceId practice id for which pathology reports belongs too
   * @param status workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden
   * @return OK
   */
  getPathologyReportWorkflowsAll(practiceId: string, status: Status2): Observable<PathologyReportWorkflowVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/status/{status}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace('{status}', encodeURIComponent('' + status));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsAll(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsAll(response: HttpResponseBase): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get PathologyReportWorflows matched by search criteria (patient name, received from, etc)
   * @param practiceId practice id for which pathology reports belongs too
   * @param searchText search text
   * @return OK
   */
  getPathologyReportWorkflows(practiceId: string, searchText: string): Observable<PathologyReportWorkflowVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/{searchText}/search';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (searchText === undefined || searchText === null) throw new Error("The parameter 'searchText' must be defined.");
    url_ = url_.replace('{searchText}', encodeURIComponent('' + searchText));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflows(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflows(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflows(response: HttpResponseBase): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get linked patients list for specific pathology report
   * @param pathologyReportId pathology report id
   * @return OK
   */
  getLinkedPatientDashboards(practiceId: string, pathologyReportId: string): Observable<PatientDashboardVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyReportId}/linkedpatients';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLinkedPatientDashboards(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLinkedPatientDashboards(<any>response_);
            } catch (e) {
              return <Observable<PatientDashboardVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDashboardVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetLinkedPatientDashboards(response: HttpResponseBase): Observable<PatientDashboardVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDashboardVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDashboardVo[]>(<any>null);
  }

  /**
   * Get patient details parsed from specified pathology report
   * @param pathologyReportId pathology report id
   * @return OK
   */
  getPathologyReportPatient(practiceId: string, pathologyReportId: string): Observable<PatientVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyReportId}/patient';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportPatient(<any>response_);
            } catch (e) {
              return <Observable<PatientVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportPatient(response: HttpResponseBase): Observable<PatientVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo>(<any>null);
  }

  /**
   * Return original pathology report xml for specified path result
   * @return OK
   */
  getPathologyReportXml(practiceId: string, pathologyReportId: string): Observable<string> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyReportId}/xml';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportXml(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportXml(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportXml(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Get PathologyReports count based on specified report status
   * @param practiceId practice id for which pathology reports belongs too
   * @param status workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden
   * @return OK
   */
  getPathologyReportWorkflowsCount(practiceId: string, status: Status3): Observable<number> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/status/{status}/count';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace('{status}', encodeURIComponent('' + status));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * Get PathologyReportWorkflows assigned to specific provider
   * @param practiceId practice id for which pathology reports belongs too
   * @return OK
   */
  getPathologyReportWorkflowsForProvider(practiceId: string): Observable<PathologyReportWorkflowVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/linkedpatients';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportWorkflowsForProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportWorkflowsForProvider(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportWorkflowVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportWorkflowsForProvider(response: HttpResponseBase): Observable<PathologyReportWorkflowVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportWorkflowVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportWorkflowVo[]>(<any>null);
  }

  /**
   * Get PathologyReports matched by search criteria (patient name, received from, etc)
   * @param practiceId practice id for which pathology reports belongs too
   * @param searchText search text
   * @return OK
   */
  getPathologyReport(practiceId: string, searchText: string): Observable<PatientPathologyResultsIndexVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{searchText}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (searchText === undefined || searchText === null) throw new Error("The parameter 'searchText' must be defined.");
    url_ = url_.replace('{searchText}', encodeURIComponent('' + searchText));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReport(<any>response_);
            } catch (e) {
              return <Observable<PatientPathologyResultsIndexVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientPathologyResultsIndexVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReport(response: HttpResponseBase): Observable<PatientPathologyResultsIndexVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientPathologyResultsIndexVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientPathologyResultsIndexVo[]>(<any>null);
  }

  /**
   * Get PathologyReports which wasn't delivered
   * @param practiceId practice id for which pathology reports belongs too
   * @return OK
   */
  getUndeliveredPathologyReports(practiceId: string): Observable<PathologyReportDeliveryVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/status/undelivered';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUndeliveredPathologyReports(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUndeliveredPathologyReports(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportDeliveryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportDeliveryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetUndeliveredPathologyReports(response: HttpResponseBase): Observable<PathologyReportDeliveryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportDeliveryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportDeliveryVo[]>(<any>null);
  }

  /**
   * Get PathologyReports which wasn't delivered by date range
   * @param practiceId practice id for which pathology reports belongs too
   * @param fromDate from date
   * @param toDate to date
   * @return OK
   */
  getUndeliveredPathologyReportsByDateRange(
    practiceId: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageNumber: number
  ): Observable<PathologyReportDeliveryVo[]> {
    let url_ =
      this.baseUrl +
      '/api/v1/{practiceId}/clinical/pathologyreports/status/undelivered/fromdate/{fromDate}/todate/{toDate}/pageSize/{pageSize}/pageNumber/{pageNumber}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (fromDate === undefined || fromDate === null) throw new Error("The parameter 'fromDate' must be defined.");
    url_ = url_.replace('{fromDate}', encodeURIComponent('' + fromDate));
    if (toDate === undefined || toDate === null) throw new Error("The parameter 'toDate' must be defined.");
    url_ = url_.replace('{toDate}', encodeURIComponent('' + toDate));
    if (pageSize === undefined || pageSize === null) throw new Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace('{pageSize}', encodeURIComponent('' + pageSize));
    if (pageNumber === undefined || pageNumber === null) throw new Error("The parameter 'pageNumber' must be defined.");
    url_ = url_.replace('{pageNumber}', encodeURIComponent('' + pageNumber));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUndeliveredPathologyReportsByDateRange(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUndeliveredPathologyReportsByDateRange(<any>response_);
            } catch (e) {
              return <Observable<PathologyReportDeliveryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PathologyReportDeliveryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetUndeliveredPathologyReportsByDateRange(response: HttpResponseBase): Observable<PathologyReportDeliveryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PathologyReportDeliveryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PathologyReportDeliveryVo[]>(<any>null);
  }

  /**
   * Get pathology report workflow in html format.
   * @param practiceId practice id
   * @param pathologyreportId pathology report id
   * @return OK
   */
  getPathologyReportHtml(practiceId: string, pathologyreportId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyreportId}/html';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyreportId === undefined || pathologyreportId === null)
      throw new Error("The parameter 'pathologyreportId' must be defined.");
    url_ = url_.replace('{pathologyreportId}', encodeURIComponent('' + pathologyreportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportHtml(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportHtml(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportHtml(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get pathology report workflow in pdf format.
   * @param practiceId practice id
   * @param pathologyreportId pathology report id
   * @return OK
   */
  getPathologyReportPdf(practiceId: string, pathologyreportId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyreportId}/pdf';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyreportId === undefined || pathologyreportId === null)
      throw new Error("The parameter 'pathologyreportId' must be defined.");
    url_ = url_.replace('{pathologyreportId}', encodeURIComponent('' + pathologyreportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPathologyReportPdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPathologyReportPdf(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPathologyReportPdf(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
     * Ignore existing pathology report which we failed to deliver in the past due to missed patient,
    and hide it from showing to the doctor
     * @param pathologyReportId pathology report id
     * @return OK
     */
  ignorePathResult(practiceId: string, pathologyReportId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyReportId}/ignore';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIgnorePathResult(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIgnorePathResult(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processIgnorePathResult(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Re-submit existing pathology report which we failed to deliver in the past due to missed patient
   * @param pathologyReportId pathology report id
   * @return OK
   */
  redeliverPathResult(
    practiceId: string,
    pathologyReportId: string,
    pathologyReport: DeliverPathologyReport
  ): Observable<RestApiResultOfNullableOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreports/{pathologyReportId}/redeliver';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(pathologyReport);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRedeliverPathResult(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRedeliverPathResult(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfNullableOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfNullableOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRedeliverPathResult(response: HttpResponseBase): Observable<RestApiResultOfNullableOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfNullableOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfNullableOfGuid>(<any>null);
  }

  /**
   * Receive pathology report
   * @return OK
   */
  receivePathologyReport(receivePathologyReport: RequestReceivePathologyReport): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/clinical/pathologyreports/receive';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(receivePathologyReport);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReceivePathologyReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReceivePathologyReport(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReceivePathologyReport(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
     * Used to copy templates (all or only specific type) from one doctor context to another,
    type can be (all, diagnosis, procedure, medicine, consumable, mytemplate, etc)
     * @param providerIdFrom doctor id from where take templates
     * @param providerIdTo doctor id to where copy templater
     * @param type type of templates to copy
     * @return OK
     */
  copyTemplatesToAnotherDoctor(providerIdFrom: string, providerIdTo: string, type: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{providerIdFrom}/clinical/encountertemplates/{type}/copy/{providerIdTo}';
    if (providerIdFrom === undefined || providerIdFrom === null) throw new Error("The parameter 'providerIdFrom' must be defined.");
    url_ = url_.replace('{providerIdFrom}', encodeURIComponent('' + providerIdFrom));
    if (providerIdTo === undefined || providerIdTo === null) throw new Error("The parameter 'providerIdTo' must be defined.");
    url_ = url_.replace('{providerIdTo}', encodeURIComponent('' + providerIdTo));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCopyTemplatesToAnotherDoctor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCopyTemplatesToAnotherDoctor(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCopyTemplatesToAnotherDoctor(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do delete all templates for specific practice
   * @return OK
   */
  deleteAllTemplates(practiceid: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/bulkdelete';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAllTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAllTemplates(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteAllTemplates(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do bulk update of templates for specific practice
   * @return OK
   */
  bulkCreate(practiceid: string, encounterTemplates: EncounterTemplateVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/encountertemplates/bulkcreate';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterTemplates);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkCreate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkCreate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Mark PathologyReports As Read
   * @return OK
   */
  markPathologyReportAsRead(practiceid: string, workflowId: string, command: MarkPathologyReportAsRead): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/pathologyreportworkflows/{workflowId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (workflowId === undefined || workflowId === null) throw new Error("The parameter 'workflowId' must be defined.");
    url_ = url_.replace('{workflowId}', encodeURIComponent('' + workflowId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMarkPathologyReportAsRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMarkPathologyReportAsRead(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMarkPathologyReportAsRead(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Mark PathologyReports As Read
   * @return OK
   */
  removePathologyReport(practiceId: string, pathologyReportId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/pathologyreportworkflows/{pathologyReportId}/remove';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePathologyReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePathologyReport(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePathologyReport(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Mark PathologyReports As Read
   * @return OK
   */
  markPathologyReportsAsRead(practiceid: string, workflowIds: string[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/pathologyreportworkflows';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(workflowIds);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMarkPathologyReportsAsRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMarkPathologyReportsAsRead(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMarkPathologyReportsAsRead(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get AddressBook, OData filtering can be applied ($top, $skip, etc)
   * @return OK
   */
  getAddressBookAll(practiceId: string): Observable<AddressBookEntryVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAddressBookAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAddressBookAll(<any>response_);
            } catch (e) {
              return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAddressBookAll(response: HttpResponseBase): Observable<AddressBookEntryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AddressBookEntryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddressBookEntryVo[]>(<any>null);
  }

  /**
   * Add address book entry
   * @return OK
   */
  addAddressBook(practiceId: string, addressBookEntry: UpdateAddressBookEntry): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(addressBookEntry);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddAddressBook(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddAddressBook(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddAddressBook(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update address book entry
   * @return OK
   */
  updateAddressBook(
    practiceId: string,
    addressBookEntryId: string,
    addressBookEntry: UpdateAddressBookEntry
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook/{addressBookEntryId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (addressBookEntryId === undefined || addressBookEntryId === null)
      throw new Error("The parameter 'addressBookEntryId' must be defined.");
    url_ = url_.replace('{addressBookEntryId}', encodeURIComponent('' + addressBookEntryId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(addressBookEntry);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAddressBook(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAddressBook(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateAddressBook(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Remove address book entry
   * @return OK
   */
  removeAddressBook(practiceId: string, addressBookEntryId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook/{addressBookEntryId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (addressBookEntryId === undefined || addressBookEntryId === null)
      throw new Error("The parameter 'addressBookEntryId' must be defined.");
    url_ = url_.replace('{addressBookEntryId}', encodeURIComponent('' + addressBookEntryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveAddressBook(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveAddressBook(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveAddressBook(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get Address Book Entry By Id
   * @param practiceid Unique identifier of practice
   * @param addressBookEntryId Unique identifier of AddressBook Entry
   * @return OK
   */
  getAddressBookEntryById(practiceid: string, addressBookEntryId: string): Observable<AddressBookEntryVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/addressbook/byId/{addressBookEntryId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (addressBookEntryId === undefined || addressBookEntryId === null)
      throw new Error("The parameter 'addressBookEntryId' must be defined.");
    url_ = url_.replace('{addressBookEntryId}', encodeURIComponent('' + addressBookEntryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAddressBookEntryById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAddressBookEntryById(<any>response_);
            } catch (e) {
              return <Observable<AddressBookEntryVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<AddressBookEntryVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAddressBookEntryById(response: HttpResponseBase): Observable<AddressBookEntryVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AddressBookEntryVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddressBookEntryVo>(<any>null);
  }

  /**
   * Get AddressBook with additional lookup logic, OData filtering can be applied ($top, $skip, etc)
   * @return OK
   */
  getAddressBook(practiceId: string, lookupfilter: string): Observable<AddressBookEntryVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook/{lookupfilter}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAddressBook(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAddressBook(<any>response_);
            } catch (e) {
              return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAddressBook(response: HttpResponseBase): Observable<AddressBookEntryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AddressBookEntryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddressBookEntryVo[]>(<any>null);
  }

  /**
   * Get AddressBook favourites
   * @return OK
   */
  getFavouriteAddressBook(practiceId: string): Observable<AddressBookEntryVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/addressbook/favourite';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFavouriteAddressBook(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFavouriteAddressBook(<any>response_);
            } catch (e) {
              return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<AddressBookEntryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFavouriteAddressBook(response: HttpResponseBase): Observable<AddressBookEntryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AddressBookEntryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddressBookEntryVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClinicalAdminClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Reimport all encounters from one tenant to another
   * @param practiceTenantId to which tenant import
   * @param providerId from where to import
   * @return OK
   */
  reimportEncounters(practiceTenantId: string, providerId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/encounters/reimport/{practiceTenantId}';
    if (practiceTenantId === undefined || practiceTenantId === null) throw new Error("The parameter 'practiceTenantId' must be defined.");
    url_ = url_.replace('{practiceTenantId}', encodeURIComponent('' + practiceTenantId));
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReimportEncounters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReimportEncounters(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReimportEncounters(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Allow to correct (update) encounter which was already completed
   * @param encounter command with encounter state
   * @return OK
   */
  correctEncounter(practiceId: string, encounterId: string, encounter: CorrectEncounter): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/encounter/{encounterId}/correct';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCorrectEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCorrectEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCorrectEncounter(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Import a historical encounter into a new providerTenantId
   * @param providerTenantId destination tenant
   * @param encounter historical encounter to import
   * @return OK
   */
  importHistoricalEncounter(providerTenantId: string, encounter: EncounterVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerTenantId}/clinical/encounters/import';
    if (providerTenantId === undefined || providerTenantId === null) throw new Error("The parameter 'providerTenantId' must be defined.");
    url_ = url_.replace('{providerTenantId}', encodeURIComponent('' + providerTenantId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImportHistoricalEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImportHistoricalEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processImportHistoricalEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Used to import multiple single-item templates with a types(diagnosis, procedure, medicine, consumable)
   * @param providerId doctor id from where take templates
   * @return OK
   */
  templatesBulkImport(providerId: string, bulkImport: TemplateBulkImportVo): Observable<RestApiResultOfStringOf> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/encountertemplates/import/bulk';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(bulkImport);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTemplatesBulkImport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTemplatesBulkImport(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfStringOf>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfStringOf>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processTemplatesBulkImport(response: HttpResponseBase): Observable<RestApiResultOfStringOf> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfStringOf>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfStringOf>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClinicalNewClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Returns the encounter by visit Id
   * @param practiceId Unique identifier of practice
   * @param patientVisitId Unique identifier of patient visit
   * @return OK
   * @deprecated
   */
  getClinicalEncounterByVisit(practiceId: string, patientVisitId: string): Observable<ClinicalEncounterVo> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/byVisitId/{patientVisitId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientVisitId === undefined || patientVisitId === null) throw new Error("The parameter 'patientVisitId' must be defined.");
    url_ = url_.replace('{patientVisitId}', encodeURIComponent('' + patientVisitId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClinicalEncounterByVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClinicalEncounterByVisit(<any>response_);
            } catch (e) {
              return <Observable<ClinicalEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClinicalEncounterByVisit(response: HttpResponseBase): Observable<ClinicalEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalEncounterVo>(<any>null);
  }

  /**
   * @return OK
   */
  pathXmlToHtml(practiceId: string, originalMessage: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/pathologyreport/xmltohtml';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(originalMessage);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPathXmlToHtml(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPathXmlToHtml(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processPathXmlToHtml(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }
  /**
   * Render encounter communication
   * @return OK
   */
  renderEncounterCommunicationPUT(
    practiceId: string,
    encounterId: string,
    communicationId: string,
    request: CommunicationRenderRequest
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/communications/{communicationId}/render';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRenderEncounterCommunicationPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRenderEncounterCommunicationPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processRenderEncounterCommunicationPUT(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }

  /**
   * Render encounter communication
   * @return OK
   */
  renderEncounterCommunicationPOST(
    practiceId: string,
    encounterId: string,
    communicationId: string,
    request: CommunicationRenderRequest
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/communications/{communicationId}/render';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    if (communicationId === undefined || communicationId === null) throw new Error("The parameter 'communicationId' must be defined.");
    url_ = url_.replace('{communicationId}', encodeURIComponent('' + communicationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRenderEncounterCommunicationPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRenderEncounterCommunicationPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processRenderEncounterCommunicationPOST(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }
  /**
   * Returns active encounter by visit Id
   * @param practiceId Unique identifier of practice
   * @param patientVisitId Unique identifier of patient visit
   * @return OK
   */
  getActiveEncounterByVisitId(practiceId: string, patientVisitId: string): Observable<EncounterStatusVo> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/byVisitId/{patientVisitId}/active';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientVisitId === undefined || patientVisitId === null) throw new Error("The parameter 'patientVisitId' must be defined.");
    url_ = url_.replace('{patientVisitId}', encodeURIComponent('' + patientVisitId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetActiveEncounterByVisitId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetActiveEncounterByVisitId(<any>response_);
            } catch (e) {
              return <Observable<EncounterStatusVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterStatusVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetActiveEncounterByVisitId(response: HttpResponseBase): Observable<EncounterStatusVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterStatusVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterStatusVo>(<any>null);
  }

  /**
   * Remove patient file notes previously captured (will be removed from timeline)
   * @param providerId from where to import
   * @return OK
   */
  removePatientFileNote(providerId: string, patientId: string, patientFileNoteId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/note/{patientFileNoteId}';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (patientFileNoteId === undefined || patientFileNoteId === null)
      throw new Error("The parameter 'patientFileNoteId' must be defined.");
    url_ = url_.replace('{patientFileNoteId}', encodeURIComponent('' + patientFileNoteId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientFileNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientFileNote(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientFileNote(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Capture patient file notes to be shown on patient timeline
   * @param providerId from where to import
   * @param note note object
   * @return OK
   */
  capturePatientFileNote(providerId: string, patientId: string, note: PatientFileNoteVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/note';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(note);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCapturePatientFileNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCapturePatientFileNote(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCapturePatientFileNote(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Add to patient dashboard directly any history event (mostly to handle edge cases when we need to merge duplicates, remove mistakenly added data)
   * @param providerId from where to import
   * @param entries object
   * @return OK
   */
  addPatientTimelineEntries(
    providerId: string,
    patientId: string,
    entries: PatientDashboardHistoryEventDto[]
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/timeline/add';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(entries);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddPatientTimelineEntries(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddPatientTimelineEntries(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddPatientTimelineEntries(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Remove patient dashboard directly any history event (mostly to handle edge cases when we need to merge duplicates, remove mistakenly added data)
   * @param providerId from where to import
   * @param entries object
   * @return OK
   */
  removePatientTimelineEntries(
    providerId: string,
    patientId: string,
    entries: PatientDashboardHistoryEventDto[]
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/timeline/delete';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(entries);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientTimelineEntries(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientTimelineEntries(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientTimelineEntries(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
     * Render adhoc prescription
     (stateless/pure function, dependency: on myPatientFiles)
     * @return OK
     */
  renderAdhocPrescriptionPOST(
    practiceId: string,
    patientId: string,
    prescriptionId: string,
    renderRequest: PrescriptionRenderRequest
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patient/{patientId}/prescription/{prescriptionId}/render';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (prescriptionId === undefined || prescriptionId === null) throw new Error("The parameter 'prescriptionId' must be defined.");
    url_ = url_.replace('{prescriptionId}', encodeURIComponent('' + prescriptionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(renderRequest);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRenderAdhocPrescriptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRenderAdhocPrescriptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processRenderAdhocPrescriptionPOST(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }

  /**
   * Add prescription to be shown on patient timeline
   * @return OK
   */
  addPatientPrescription(
    providerId: string,
    patientId: string,
    adhocPrescription: MedicationPrescription
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/prescription';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(adhocPrescription);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddPatientPrescription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddPatientPrescription(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddPatientPrescription(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Get prescription html body
   * @return OK
   */
  getPatientMedicationPrescriptionBody(practiceId: string, patientId: string, prescriptionId: string): Observable<string> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patient/{patientId}/prescription/{prescriptionId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (prescriptionId === undefined || prescriptionId === null) throw new Error("The parameter 'prescriptionId' must be defined.");
    url_ = url_.replace('{prescriptionId}', encodeURIComponent('' + prescriptionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientMedicationPrescriptionBody(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientMedicationPrescriptionBody(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientMedicationPrescriptionBody(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Remove prescription previously added (will be removed from timeline)
   * @return OK
   */
  removePatientPrescription(providerId: string, patientId: string, prescriptionId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/{patientId}/{prescriptionId}';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (prescriptionId === undefined || prescriptionId === null) throw new Error("The parameter 'prescriptionId' must be defined.");
    url_ = url_.replace('{prescriptionId}', encodeURIComponent('' + prescriptionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientPrescription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientPrescription(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientPrescription(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Returns the encounter by Id
   * @param practiceId Unique identifier of practice
   * @param encounterId Unique identifier of patient visit
   * @return OK
   * @deprecated
   */
  getEncounter(practiceId: string, encounterId: string): Observable<ClinicalEncounterVo> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncounter(<any>response_);
            } catch (e) {
              return <Observable<ClinicalEncounterVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalEncounterVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncounter(response: HttpResponseBase): Observable<ClinicalEncounterVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalEncounterVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalEncounterVo>(<any>null);
  }

  /**
   * Save encounter
   * @param practiceId Unique identifier of practice
   * @param clinicalEncounter public domain model = UpdateClinicalEncounter
   * @return OK
   * @deprecated
   */
  updateEncounter(practiceId: string, encounterId: string, clinicalEncounter: UpdateClinicalEncounter): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clinicalEncounter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateEncounter(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get information about patients which were updated since specific datetime in the past
   * @param practiceId doctor id
   * @param since datetime in UTC format, e.g. 2019-05-06T08:17:00Z
   * @return OK
   */
  getPatientsLastChangeTime(practiceId: string, since: Date): Observable<RestApiResultOfPatientUpdateTrackingVoOf> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patients/updated?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (since === undefined || since === null) throw new Error("The parameter 'since' must be defined and cannot be null.");
    else url_ += 'since=' + encodeURIComponent(since ? '' + since.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientsLastChangeTime(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientsLastChangeTime(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfPatientUpdateTrackingVoOf>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfPatientUpdateTrackingVoOf>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientsLastChangeTime(response: HttpResponseBase): Observable<RestApiResultOfPatientUpdateTrackingVoOf> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfPatientUpdateTrackingVoOf>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfPatientUpdateTrackingVoOf>(<any>null);
  }

  /**
   * Get list of available allergens possible to select on UI for a patient
   * @param practiceId doctor id
   * @return OK
   */
  getAllergens(practiceId: string): Observable<RestApiResultOfAllergenVoOf> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/allergens';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllergens(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllergens(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfAllergenVoOf>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfAllergenVoOf>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllergens(response: HttpResponseBase): Observable<RestApiResultOfAllergenVoOf> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfAllergenVoOf>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfAllergenVoOf>(<any>null);
  }

  /**
   * Get datetime when patient was updated last time
   * @param practiceId doctor id
   * @param patientId patient id
   * @return OK
   */
  getPatientLastChangeTime(practiceId: string, patientId: string): Observable<RestApiResultOfNullableOfDateTime> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patients/{patientId}/updated';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientLastChangeTime(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientLastChangeTime(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfNullableOfDateTime>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfNullableOfDateTime>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientLastChangeTime(response: HttpResponseBase): Observable<RestApiResultOfNullableOfDateTime> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfNullableOfDateTime>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfNullableOfDateTime>(<any>null);
  }

  /**
   * Get all patient clinical info in one call (dashboard, allergies, conditions, documents, avatar, lifestyle, family members, surgical history, last updated)
   * @param practiceId doctor id
   * @param patientId patient id
   * @return OK
   */
  getAllPatientClinicalInfo(practiceId: string, patientId: string): Observable<RestApiResultOfPatientClinicalDetailsVo> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patients/{patientId}/all';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatientClinicalInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatientClinicalInfo(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfPatientClinicalDetailsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfPatientClinicalDetailsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatientClinicalInfo(response: HttpResponseBase): Observable<RestApiResultOfPatientClinicalDetailsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfPatientClinicalDetailsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfPatientClinicalDetailsVo>(<any>null);
  }

  /**
   * Update only one specific billing provider option
   * @return OK
   */
  updateProviderPreferences(practiceId: string, configurationOption: ChangeProviderConfigurationOptions): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/billing/providers/preferences';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configurationOption);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProviderPreferences(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProviderPreferences(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProviderPreferences(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get generic patient information
   * @return OK
   */
  getPatientGenericInformation(practiceId: string, patientId: string): Observable<PatientFileGenericInformationVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patient/genericinformation/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientGenericInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientGenericInformation(<any>response_);
            } catch (e) {
              return <Observable<PatientFileGenericInformationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientFileGenericInformationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientGenericInformation(response: HttpResponseBase): Observable<PatientFileGenericInformationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientFileGenericInformationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientFileGenericInformationVo[]>(<any>null);
  }

  /**
   * Search smart templates by token
   * @return OK
   */
  searchSmartTemplates(practiceId: string, token: string): Observable<SmartCategories2> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/smarttemplates?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (token === undefined || token === null) throw new Error("The parameter 'token' must be defined and cannot be null.");
    else url_ += 'token=' + encodeURIComponent('' + token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchSmartTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchSmartTemplates(<any>response_);
            } catch (e) {
              return <Observable<SmartCategories2>>(<any>_observableThrow(e));
            }
          } else return <Observable<SmartCategories2>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchSmartTemplates(response: HttpResponseBase): Observable<SmartCategories2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SmartCategories2>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SmartCategories2>(<any>null);
  }

  /**
   * Get Smart Templates "Static Categories" List
   * @return OK
   */
  getSmartTemplatesStaticCategories(practiceId: string): Observable<StaticCategory[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/smarttemplates/staticcategories';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSmartTemplatesStaticCategories(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSmartTemplatesStaticCategories(<any>response_);
            } catch (e) {
              return <Observable<StaticCategory[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<StaticCategory[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSmartTemplatesStaticCategories(response: HttpResponseBase): Observable<StaticCategory[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <StaticCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<StaticCategory[]>(<any>null);
  }

  /**
   * Get Smart Templates "Static Categories" medicines for provided tokens
   * @param tokens Comma delimetered list of tokens
   * @return OK
   */
  getSmartTemplatesStaticCategoryMedicines(practiceId: string, tokens: string): Observable<Medicines[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/smarttemplates/staticcategorymedicines?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (tokens === undefined || tokens === null) throw new Error("The parameter 'tokens' must be defined and cannot be null.");
    else url_ += 'tokens=' + encodeURIComponent('' + tokens) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSmartTemplatesStaticCategoryMedicines(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSmartTemplatesStaticCategoryMedicines(<any>response_);
            } catch (e) {
              return <Observable<Medicines[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Medicines[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSmartTemplatesStaticCategoryMedicines(response: HttpResponseBase): Observable<Medicines[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Medicines[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Medicines[]>(<any>null);
  }

  /**
   * Get Smart Templates "Static Categories" consumables for provided tokens
   * @param tokens Comma delimetered list of tokens
   * @return OK
   */
  getSmartTemplatesStaticCategoryConsumables(practiceId: string, tokens: string): Observable<Consumables[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/smarttemplates/staticcategoryconsumables?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (tokens === undefined || tokens === null) throw new Error("The parameter 'tokens' must be defined and cannot be null.");
    else url_ += 'tokens=' + encodeURIComponent('' + tokens) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSmartTemplatesStaticCategoryConsumables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSmartTemplatesStaticCategoryConsumables(<any>response_);
            } catch (e) {
              return <Observable<Consumables[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Consumables[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetSmartTemplatesStaticCategoryConsumables(response: HttpResponseBase): Observable<Consumables[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Consumables[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Consumables[]>(<any>null);
  }

  /**
   * Get medicine information by ingredient ATC5 code
   * @return OK
   */
  getMedicineInforByATC5(practiceId: string, token: string): Observable<DrugInfo> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/druginfobyatc5?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (token === undefined || token === null) throw new Error("The parameter 'token' must be defined and cannot be null.");
    else url_ += 'token=' + encodeURIComponent('' + token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicineInforByATC5(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicineInforByATC5(<any>response_);
            } catch (e) {
              return <Observable<DrugInfo>>(<any>_observableThrow(e));
            }
          } else return <Observable<DrugInfo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicineInforByATC5(response: HttpResponseBase): Observable<DrugInfo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <DrugInfo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DrugInfo>(<any>null);
  }

  /**
   * Get dosage information for medicine
   * @return OK
   */
  getMedicineDosages(practiceId: string, atc5: string, productForm: string, strength: string): Observable<Dosages> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/dosages/{atc5}/{productForm}/{strength}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (atc5 === undefined || atc5 === null) throw new Error("The parameter 'atc5' must be defined.");
    url_ = url_.replace('{atc5}', encodeURIComponent('' + atc5));
    if (productForm === undefined || productForm === null) throw new Error("The parameter 'productForm' must be defined.");
    url_ = url_.replace('{productForm}', encodeURIComponent('' + productForm));
    if (strength === undefined || strength === null) throw new Error("The parameter 'strength' must be defined.");
    url_ = url_.replace('{strength}', encodeURIComponent('' + strength));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicineDosages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicineDosages(<any>response_);
            } catch (e) {
              return <Observable<Dosages>>(<any>_observableThrow(e));
            }
          } else return <Observable<Dosages>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicineDosages(response: HttpResponseBase): Observable<Dosages> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Dosages>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Dosages>(<any>null);
  }

  /**
   * Get dosage information for medicine by Medprax Generic Identification Code (MGIC)
   * @return OK
   */
  getMedicineDosagesByMGIC(practiceId: string, mgic: string): Observable<Dosages> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/dosages/{mgic}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (mgic === undefined || mgic === null) throw new Error("The parameter 'mgic' must be defined.");
    url_ = url_.replace('{mgic}', encodeURIComponent('' + mgic));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicineDosagesByMGIC(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicineDosagesByMGIC(<any>response_);
            } catch (e) {
              return <Observable<Dosages>>(<any>_observableThrow(e));
            }
          } else return <Observable<Dosages>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicineDosagesByMGIC(response: HttpResponseBase): Observable<Dosages> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Dosages>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Dosages>(<any>null);
  }

  /**
   * Get The ICD Predictions
   * @return OK
   */
  predictionIcd(practiceId: string, request: ICDPredictionRequest): Observable<ICDPredictions> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/icdpredictions';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPredictionIcd(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPredictionIcd(<any>response_);
            } catch (e) {
              return <Observable<ICDPredictions>>(<any>_observableThrow(e));
            }
          } else return <Observable<ICDPredictions>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPredictionIcd(response: HttpResponseBase): Observable<ICDPredictions> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ICDPredictions>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ICDPredictions>(<any>null);
  }

  /**
   * Search Smart Templates and receive combined response with medicine information
   * @return OK
   */
  searchSmartTemplatesWithMedicines(practiceId: string, token: string): Observable<SmartCategories> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/smarttemplateswithmedicines?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (token === undefined || token === null) throw new Error("The parameter 'token' must be defined and cannot be null.");
    else url_ += 'token=' + encodeURIComponent('' + token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchSmartTemplatesWithMedicines(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchSmartTemplatesWithMedicines(<any>response_);
            } catch (e) {
              return <Observable<SmartCategories>>(<any>_observableThrow(e));
            }
          } else return <Observable<SmartCategories>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchSmartTemplatesWithMedicines(response: HttpResponseBase): Observable<SmartCategories> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <SmartCategories>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SmartCategories>(<any>null);
  }

  /**
   * Search medicine codes
   * @return OK
   */
  searchMedicine(practiceId: string, code: string): Observable<Medicines> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/medicines?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined and cannot be null.");
    else url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchMedicine(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchMedicine(<any>response_);
            } catch (e) {
              return <Observable<Medicines>>(<any>_observableThrow(e));
            }
          } else return <Observable<Medicines>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchMedicine(response: HttpResponseBase): Observable<Medicines> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Medicines>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Medicines>(<any>null);
  }

  /**
   * Search consumable codes
   * @return OK
   */
  searchConsumable(practiceId: string, code: string): Observable<Consumables> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/consumables?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (code === undefined || code === null) throw new Error("The parameter 'code' must be defined and cannot be null.");
    else url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchConsumable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchConsumable(<any>response_);
            } catch (e) {
              return <Observable<Consumables>>(<any>_observableThrow(e));
            }
          } else return <Observable<Consumables>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchConsumable(response: HttpResponseBase): Observable<Consumables> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <Consumables>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Consumables>(<any>null);
  }

  /**
   * Get all historical encounters with prescription or medicines for provided patient
   * @param practiceId Unique identifier of practice
   * @param type (optional) prescribed/dispensed values available to get prescription/dispensing or both (set null)
   * @return OK
   */
  getEncountersRxHistory(practiceId: string, patientId: string, type?: string | null | undefined): Observable<EncounterStatusVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patient/{patientId}/encounters/rxhistory?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (type !== undefined && type !== null) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEncountersRxHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEncountersRxHistory(<any>response_);
            } catch (e) {
              return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterStatusVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetEncountersRxHistory(response: HttpResponseBase): Observable<EncounterStatusVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterStatusVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterStatusVo[]>(<any>null);
  }

  /**
   * Get specific conditions by provided ICD codes
   * @return OK
   */
  getTrackingConditions(practiceId: string, conditions: RequestTrackingConditions): Observable<PatientChronicConditionsVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patientchronicconditions/tracking';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(conditions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTrackingConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTrackingConditions(<any>response_);
            } catch (e) {
              return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTrackingConditions(response: HttpResponseBase): Observable<PatientChronicConditionsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientChronicConditionsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientChronicConditionsVo[]>(<any>null);
  }

  /**
   * Filter conditions by Icd10 codes, age (from/to), gender
   * @return OK
   */
  filterTrackingConditions(practiceId: string, conditions: ConditionFilterVo): Observable<PatientChronicConditionsVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patientchronicconditions/tracking/filter';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(conditions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFilterTrackingConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFilterTrackingConditions(<any>response_);
            } catch (e) {
              return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processFilterTrackingConditions(response: HttpResponseBase): Observable<PatientChronicConditionsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientChronicConditionsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientChronicConditionsVo[]>(<any>null);
  }

  /**
   * Remove conditions from tracking dashboard based on provided ICD codes
   * @return OK
   */
  removeTrackingConditions(
    practiceId: string,
    patientId: string,
    request: RequestTrackingConditions
  ): Observable<PatientChronicConditionsVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patientchronicconditions/tracking/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveTrackingConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveTrackingConditions(<any>response_);
            } catch (e) {
              return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveTrackingConditions(response: HttpResponseBase): Observable<PatientChronicConditionsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientChronicConditionsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientChronicConditionsVo[]>(<any>null);
  }

  /**
   * Allow to send communication to patient via SMS or email
   * @return OK
   */
  sendPatientCommunication(practiceId: string, patientId: string, request: TriggerPatientCommunication): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patientcommunication/{patientId}/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendPatientCommunication(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendPatientCommunication(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendPatientCommunication(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
     * Endpoint to send script to Dischem, implementation done to overcome limitations of using dischem only via static IP
    (new solution via cloud funciton is hectic to apply + extra cost).
    This impl build with mind of all business logic keep on caller side, so here it's just very simple http call a trigger to send script to Dischem
     * @return OK
     */
  sendDischemScript(
    practiceId: string,
    encounterId: string,
    request: SendDischemScript
  ): Observable<RestApiResultOfSendDischemScriptResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/dischem/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendDischemScript(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendDischemScript(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfSendDischemScriptResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfSendDischemScriptResponse>;
        })
      );
  }

  protected processSendDischemScript(response: HttpResponseBase): Observable<RestApiResultOfSendDischemScriptResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfSendDischemScriptResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfSendDischemScriptResponse>(null as any);
  }

  /**
     * Endpoint to send update order in Dischem system, specifically to cancel it

    Please Note:
    implementation done to overcome limitations of using dischem only via static IP
    (new solution via cloud function is hectic to apply + extra cost).
    This impl build with mind of all business logic keep on caller side, so here it's just very simple http call a trigger to send script to Dischem
     * @return OK
     */
  updateDischemOrder(practiceId: string, encounterId: string, request: UpdateDischemScript): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/dischem/update';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDischemOrder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDischemOrder(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfString>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfString>;
        })
      );
  }

  protected processUpdateDischemOrder(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfString);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(null as any);
  }

  /**
   * @return OK
   */
  getDischemPharmaciesList(): Observable<RestApiResultOfDischemPharmaciesListResponse> {
    let url_ = this.baseUrl + '/api/v2/clinical/dischem/pharmacies-list';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDischemPharmaciesList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDischemPharmaciesList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfDischemPharmaciesListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfDischemPharmaciesListResponse>;
        })
      );
  }

  protected processGetDischemPharmaciesList(response: HttpResponseBase): Observable<RestApiResultOfDischemPharmaciesListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfDischemPharmaciesListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfDischemPharmaciesListResponse>(null as any);
  }

  /**
   * Endpoint to send a prescription to the ComputAssist SmartSwitch eScripting platform.
   * Follows the Dischem proxy pattern to overcome static IP whitelist limitation.
   * Single-call submission (unlike Dischem's two-step new-order + med-lines).
   * @return OK
   */
  sendComputAssistScript(
    practiceId: string,
    encounterId: string,
    request: SendComputAssistScript
  ): Observable<RestApiResultOfSendComputAssistScriptResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/computassist/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendComputAssistScript(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendComputAssistScript(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfSendComputAssistScriptResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfSendComputAssistScriptResponse>;
        })
      );
  }

  protected processSendComputAssistScript(response: HttpResponseBase): Observable<RestApiResultOfSendComputAssistScriptResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfSendComputAssistScriptResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfSendComputAssistScriptResponse>(null as any);
  }

  /**
   * Endpoint to send a prescription to EasyRx (Modifly) via the Florence proxy. Mirrors the
   * ComputAssist proxy pattern; the order number is CLIENT-generated (shared HBC-…ER format) —
   * EasyRx validates it on receive and echoes it back in the response.
   * @return OK
   */
  sendEasyRxScript(
    practiceId: string,
    encounterId: string,
    request: SendEasyRxScript
  ): Observable<RestApiResultOfSendEasyRxScriptResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/easyrx/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendEasyRxScript(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendEasyRxScript(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfSendEasyRxScriptResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfSendEasyRxScriptResponse>;
        })
      );
  }

  protected processSendEasyRxScript(response: HttpResponseBase): Observable<RestApiResultOfSendEasyRxScriptResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfSendEasyRxScriptResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfSendEasyRxScriptResponse>(null as any);
  }

  /**
   * Endpoint to fetch an EasyRx order status via the Florence proxy (doctor-triggered).
   * @return OK
   */
  getEasyRxPrescriptionStatus(practiceId: string, orderNumber: string): Observable<RestApiResultOfEasyRxPrescriptionStatusResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/easyrx/prescriptions/{orderNumber}/status';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (orderNumber === undefined || orderNumber === null) throw new Error("The parameter 'orderNumber' must be defined.");
    url_ = url_.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEasyRxPrescriptionStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEasyRxPrescriptionStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfEasyRxPrescriptionStatusResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfEasyRxPrescriptionStatusResponse>;
        })
      );
  }

  protected processGetEasyRxPrescriptionStatus(response: HttpResponseBase): Observable<RestApiResultOfEasyRxPrescriptionStatusResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfEasyRxPrescriptionStatusResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEasyRxPrescriptionStatusResponse>(null as any);
  }

  /**
   * Endpoint to list EasyRx pharmacies via the Florence proxy (paged; used by the admin catalogue refresh).
   * @return OK
   */
  getEasyRxPharmacies(practiceId: string, limit: number, offset: number): Observable<RestApiResultOfEasyRxPharmaciesResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/easyrx/pharmacies?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (limit !== undefined && limit !== null) url_ += 'limit=' + encodeURIComponent('' + limit) + '&';
    if (offset !== undefined && offset !== null) url_ += 'offset=' + encodeURIComponent('' + offset) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEasyRxPharmacies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEasyRxPharmacies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfEasyRxPharmaciesResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfEasyRxPharmaciesResponse>;
        })
      );
  }

  protected processGetEasyRxPharmacies(response: HttpResponseBase): Observable<RestApiResultOfEasyRxPharmaciesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfEasyRxPharmaciesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfEasyRxPharmaciesResponse>(null as any);
  }

  /**
   * @return OK
   */
  getAmpathResultsByPatient(practiceId: string, request: AmpathResultsRequest): Observable<RestApiResultOfAmpathResultsResponse> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/ampath/results-by-patient';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAmpathResultsByPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAmpathResultsByPatient(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfAmpathResultsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfAmpathResultsResponse>;
        })
      );
  }

  protected processGetAmpathResultsByPatient(response: HttpResponseBase): Observable<RestApiResultOfAmpathResultsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfAmpathResultsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfAmpathResultsResponse>(null as any);
  }
  /**
   * @return OK
   */
  sendEncounterRequireFollowupPatientSms(
    practiceId: string,
    encounterId: string,
    request: SendEncounterRequireFollowupPatientSms
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/encounters/{encounterId}/followup/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (encounterId === undefined || encounterId === null) throw new Error("The parameter 'encounterId' must be defined.");
    url_ = url_.replace('{encounterId}', encodeURIComponent('' + encounterId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendEncounterRequireFollowupPatientSms(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendEncounterRequireFollowupPatientSms(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfGuid>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfGuid>;
        })
      );
  }

  protected processSendEncounterRequireFollowupPatientSms(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfGuid);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(null as any);
  }
  /**
   * Sends user feedback to a predefined email address
   * @return OK
   */
  sendUserFeedback(practiceId: string, request: UserFeedbackVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/userfeedback/send';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendUserFeedback(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendUserFeedback(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendUserFeedback(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Trigger command to retry patient communication sending
   * @param practiceId Unique identifier of practice
   * @param id Unique identifier of patient communication
   * @return OK
   */
  retryPatientCommunication(practiceId: string, id: string, command: RetryPatientCommunication): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/patientcommunication/byId/{id}/retry';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRetryPatientCommunication(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRetryPatientCommunication(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRetryPatientCommunication(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Return list of patient communication which failed to send (available for admins)
   * @param since datetime in UTC format, e.g. 2019-05-06T08:17:00Z
   * @return OK
   */
  getFailedPatientCommunications(since: Date): Observable<PatientCommunicationFollowupVo[]> {
    let url_ = this.baseUrl + '/api/v2/clinical/patientcommunication/failed?';
    if (since === undefined || since === null) throw new Error("The parameter 'since' must be defined and cannot be null.");
    else url_ += 'since=' + encodeURIComponent(since ? '' + since.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFailedPatientCommunications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFailedPatientCommunications(<any>response_);
            } catch (e) {
              return <Observable<PatientCommunicationFollowupVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientCommunicationFollowupVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFailedPatientCommunications(response: HttpResponseBase): Observable<PatientCommunicationFollowupVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientCommunicationFollowupVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientCommunicationFollowupVo[]>(<any>null);
  }

  /**
   * Add/Update patient file generic information
   * @return OK
   */
  revisePatientFileGenericInformation(
    providerId: string,
    patientId: string,
    genericInformation: PatientFileGenericInformationVo
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/genericinformation/{patientId}/revise';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(genericInformation);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientFileGenericInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientFileGenericInformation(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientFileGenericInformation(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Remove patient file generic information
   * @return OK
   */
  removePatientGenericInformation(providerId: string, patientId: string, genericInformationId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v2/{providerId}/clinical/patient/genericinformation/{patientId}/{genericInformationId}/remove';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (genericInformationId === undefined || genericInformationId === null)
      throw new Error("The parameter 'genericInformationId' must be defined.");
    url_ = url_.replace('{genericInformationId}', encodeURIComponent('' + genericInformationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientGenericInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientGenericInformation(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientGenericInformation(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Parse pathology report and extract general screening
   * @param practiceId practice id
   * @param pathologyReportId pathology report id
   * @return OK
   */
  parseGeneralScreening(practiceId: string, pathologyReportId: string): Observable<ClinicalMetricVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/pathologyreports/{pathologyReportId}/parsescreening';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (pathologyReportId === undefined || pathologyReportId === null)
      throw new Error("The parameter 'pathologyReportId' must be defined.");
    url_ = url_.replace('{pathologyReportId}', encodeURIComponent('' + pathologyReportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processParseGeneralScreening(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processParseGeneralScreening(<any>response_);
            } catch (e) {
              return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processParseGeneralScreening(response: HttpResponseBase): Observable<ClinicalMetricVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalMetricVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalMetricVo[]>(<any>null);
  }

  /**
   * Get Medicine interactions from integration
   * @param practiceId Id for the provider
   * @param nappiCodes List of nappiCodes to check for interactions
   * @return OK
   */
  getMedicineInteractions(practiceId: string, nappiCodes: string[]): Observable<MedicineInteractionVo[]> {
    let url_ = this.baseUrl + '/api/v2/{practiceId}/clinical/medicineinteractions';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nappiCodes);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMedicineInteractions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMedicineInteractions(<any>response_);
            } catch (e) {
              return <Observable<MedicineInteractionVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<MedicineInteractionVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetMedicineInteractions(response: HttpResponseBase): Observable<MedicineInteractionVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <MedicineInteractionVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MedicineInteractionVo[]>(<any>null);
  }

  /**
   * Retrieve formulary information for medicines where we have formulary data stored, for display to the doctor.
   * @param practiceId Id for the provider
   * @param formularyType Acute = 0, Chronic = 10 = Acute, 1 = Chronic
   * @param nappiCode Short NAPPI code (6/7 digit)
   * @return OK
   */
  getFormularyInfo(
    practiceId: string,
    formularyType: FormularyType,
    nappiCode: string,
    schemeCode: string,
    planCode: string,
    optionCode: string
  ): Observable<FormularyInfo> {
    let url_ = this.baseUrl + '/api/ClinicalNew?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined and cannot be null.");
    else url_ += 'practiceId=' + encodeURIComponent('' + practiceId) + '&';
    if (formularyType === undefined || formularyType === null)
      throw new Error("The parameter 'formularyType' must be defined and cannot be null.");
    else url_ += 'formularyType=' + encodeURIComponent('' + formularyType) + '&';
    if (nappiCode === undefined || nappiCode === null) throw new Error("The parameter 'nappiCode' must be defined and cannot be null.");
    else url_ += 'nappiCode=' + encodeURIComponent('' + nappiCode) + '&';
    if (schemeCode === undefined || schemeCode === null) throw new Error("The parameter 'schemeCode' must be defined and cannot be null.");
    else url_ += 'schemeCode=' + encodeURIComponent('' + schemeCode) + '&';
    if (planCode === undefined || planCode === null) throw new Error("The parameter 'planCode' must be defined and cannot be null.");
    else url_ += 'planCode=' + encodeURIComponent('' + planCode) + '&';
    if (optionCode === undefined || optionCode === null) throw new Error("The parameter 'optionCode' must be defined and cannot be null.");
    else url_ += 'optionCode=' + encodeURIComponent('' + optionCode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFormularyInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFormularyInfo(<any>response_);
            } catch (e) {
              return <Observable<FormularyInfo>>(<any>_observableThrow(e));
            }
          } else return <Observable<FormularyInfo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFormularyInfo(response: HttpResponseBase): Observable<FormularyInfo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <FormularyInfo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FormularyInfo>(<any>null);
  }

  /**
   * Search for diagnosis
   * @return OK
   */
  searchDiagnosisWithFormulary(practiceId: string, patientId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/ClinicalNew?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined and cannot be null.");
    else url_ += 'practiceId=' + encodeURIComponent('' + practiceId) + '&';
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined and cannot be null.");
    else url_ += 'patientId=' + encodeURIComponent('' + patientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchDiagnosisWithFormulary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchDiagnosisWithFormulary(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchDiagnosisWithFormulary(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClinicalPatientClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get patient dashboard details
   * @return OK
   */
  getPatientDashboard(practiceId: string, patientId: string): Observable<PatientDashboardVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdashboards/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDashboard(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDashboard(<any>response_);
            } catch (e) {
              return <Observable<PatientDashboardVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDashboardVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDashboard(response: HttpResponseBase): Observable<PatientDashboardVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDashboardVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDashboardVo>(<any>null);
  }

  /**
     * Get list of patientIds which has any clinical data (lifestyle, allergies, conditions, metrics, etc)
    possible source values (all/timeline/clinical)
     * @param source possible types: all, timeline, clinical
     * @return OK
     */
  getPatientIdsWithData(practiceId: string, source: string): Observable<string[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdashboards/ids?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (source === undefined || source === null) throw new Error("The parameter 'source' must be defined and cannot be null.");
    else url_ += 'source=' + encodeURIComponent('' + source) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientIdsWithData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientIdsWithData(<any>response_);
            } catch (e) {
              return <Observable<string[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<string[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientIdsWithData(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(<any>null);
  }

  /**
   * Get patient dashboard header details - summary care record (allergies, notes, chronic condtions, etc)
   * @return OK
   */
  getPatientDashboardHeader(practiceId: string, patientId: string): Observable<PatientDashboardVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdashboards/{patientId}/header';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDashboardHeader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDashboardHeader(<any>response_);
            } catch (e) {
              return <Observable<PatientDashboardVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDashboardVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDashboardHeader(response: HttpResponseBase): Observable<PatientDashboardVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDashboardVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDashboardVo>(<any>null);
  }

  /**
   * Get specific by type events from patient dashboard
   * @return OK
   */
  getPatientDashboardEvents(practiceId: string, patientId: string, eventType: string): Observable<PatientDashboardHistoryEventDto[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdashboards/{patientId}/{eventType}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (eventType === undefined || eventType === null) throw new Error("The parameter 'eventType' must be defined.");
    url_ = url_.replace('{eventType}', encodeURIComponent('' + eventType));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDashboardEvents(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDashboardEvents(<any>response_);
            } catch (e) {
              return <Observable<PatientDashboardHistoryEventDto[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDashboardHistoryEventDto[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDashboardEvents(response: HttpResponseBase): Observable<PatientDashboardHistoryEventDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDashboardHistoryEventDto[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDashboardHistoryEventDto[]>(<any>null);
  }

  /**
   * Get latest clinical metrics for specific patient
   * @return OK
   */
  getPatientClinicalMetrics(practiceId: string, patientId: string): Observable<ClinicalMetricVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/metrics';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientClinicalMetrics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientClinicalMetrics(<any>response_);
            } catch (e) {
              return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientClinicalMetrics(response: HttpResponseBase): Observable<ClinicalMetricVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalMetricVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalMetricVo[]>(<any>null);
  }

  /**
   * Get all clinical metrics for specific patient
   * @param patientId patient id
   * @return OK
   */
  getAllPatientClinicalMetrics(practiceId: string, patientId: string): Observable<ClinicalMetricVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/metrics/all';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatientClinicalMetrics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatientClinicalMetrics(<any>response_);
            } catch (e) {
              return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatientClinicalMetrics(response: HttpResponseBase): Observable<ClinicalMetricVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalMetricVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalMetricVo[]>(<any>null);
  }

  /**
   * Get history for specific clinical metric per patient
   * @param practiceId doctor id (not tenant id)
   * @param patientId patient id
   * @param name metric name
   * @return OK
   */
  getPatientClinicalMetricsByName(practiceId: string, patientId: string, name: string): Observable<ClinicalMetricVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/metrics/{name}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace('{name}', encodeURIComponent('' + name));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientClinicalMetricsByName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientClinicalMetricsByName(<any>response_);
            } catch (e) {
              return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClinicalMetricVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientClinicalMetricsByName(response: HttpResponseBase): Observable<ClinicalMetricVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ClinicalMetricVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClinicalMetricVo[]>(<any>null);
  }

  /**
   * Get patient allergies details
   * @return OK
   */
  getPatientAllergies(practiceId: string, patientId: string): Observable<PatientAllergiesVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientallergies/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientAllergies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientAllergies(<any>response_);
            } catch (e) {
              return <Observable<PatientAllergiesVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientAllergiesVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientAllergies(response: HttpResponseBase): Observable<PatientAllergiesVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientAllergiesVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientAllergiesVo>(<any>null);
  }

  /**
   * Get patient lifestyle information
   * @return OK
   */
  getPatientLifestyle(practiceId: string, patientId: string): Observable<PatientLifestyleVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/lifestyle';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientLifestyle(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientLifestyle(<any>response_);
            } catch (e) {
              return <Observable<PatientLifestyleVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientLifestyleVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientLifestyle(response: HttpResponseBase): Observable<PatientLifestyleVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientLifestyleVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientLifestyleVo>(<any>null);
  }

  /**
   * Get patient hospitalization details
   * @return OK
   */
  getPatientHospitalization(practiceId: string, patientId: string): Observable<PatientSurgicalHistoryVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/hospitalization';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientHospitalization(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientHospitalization(<any>response_);
            } catch (e) {
              return <Observable<PatientSurgicalHistoryVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientSurgicalHistoryVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientHospitalization(response: HttpResponseBase): Observable<PatientSurgicalHistoryVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientSurgicalHistoryVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientSurgicalHistoryVo>(<any>null);
  }

  /**
   * Get patient allergies details for the tenant.  Admin only endpoint.
   * @return OK
   */
  getAllPatientAllergies(providerId: string): Observable<PatientAllergiesVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patientallergies';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatientAllergies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatientAllergies(<any>response_);
            } catch (e) {
              return <Observable<PatientAllergiesVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientAllergiesVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatientAllergies(response: HttpResponseBase): Observable<PatientAllergiesVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientAllergiesVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientAllergiesVo[]>(<any>null);
  }

  /**
   * Get patient clinical notes details
   * @return OK
   */
  getPatientClinicalNotes(practiceId: string, patientId: string): Observable<PatientClinicalNotesVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientclinicalnotes/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientClinicalNotes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientClinicalNotes(<any>response_);
            } catch (e) {
              return <Observable<PatientClinicalNotesVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientClinicalNotesVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientClinicalNotes(response: HttpResponseBase): Observable<PatientClinicalNotesVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientClinicalNotesVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientClinicalNotesVo>(<any>null);
  }

  /**
   * Get patient clinical notes details for all patients for a tenant.  Admin only endpoint.
   * @return OK
   */
  getAllPatientsClinicalNotes(providerId: string): Observable<PatientClinicalNotesVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patientclinicalnotes';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatientsClinicalNotes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatientsClinicalNotes(<any>response_);
            } catch (e) {
              return <Observable<PatientClinicalNotesVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientClinicalNotesVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatientsClinicalNotes(response: HttpResponseBase): Observable<PatientClinicalNotesVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientClinicalNotesVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientClinicalNotesVo[]>(<any>null);
  }

  /**
   * Reimport clinical data (all allergies, clinical notes, conditions, lifestyle, hospitalization) from one tenant to another
   * @param practiceTenantId to which tenant import
   * @param providerId from where to import
   * @return OK
   */
  reimportPatientClinicalInfo(practiceTenantId: string, providerId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patients/reimport/{practiceTenantId}';
    if (practiceTenantId === undefined || practiceTenantId === null) throw new Error("The parameter 'practiceTenantId' must be defined.");
    url_ = url_.replace('{practiceTenantId}', encodeURIComponent('' + practiceTenantId));
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReimportPatientClinicalInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReimportPatientClinicalInfo(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReimportPatientClinicalInfo(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Get patient chronic conditions
   * @return OK
   */
  getPatientChronicConditions(practiceId: string, patientId: string): Observable<PatientChronicConditionsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientchronicconditions/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientChronicConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientChronicConditions(<any>response_);
            } catch (e) {
              return <Observable<PatientChronicConditionsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientChronicConditionsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientChronicConditions(response: HttpResponseBase): Observable<PatientChronicConditionsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientChronicConditionsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientChronicConditionsVo>(<any>null);
  }

  /**
   * Get all patient chronic conditions
   * @return OK
   */
  getAllPatientChronicConditions(practiceId: string): Observable<PatientChronicConditionsVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientchronicconditions';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatientChronicConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatientChronicConditions(<any>response_);
            } catch (e) {
              return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientChronicConditionsVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatientChronicConditions(response: HttpResponseBase): Observable<PatientChronicConditionsVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientChronicConditionsVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientChronicConditionsVo[]>(<any>null);
  }

  /**
   * @return OK
   */
  removePatientClinicalMetrics(practiceId: string, patientId: string, metrics: ClinicalMetricVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/metrics/patient/{patientId}/metrics/delete';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(metrics);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientClinicalMetrics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientClinicalMetrics(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientClinicalMetrics(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Capture clinical metrics for provided patient
   * @return OK
   */
  capturePatientClinicalMetrics(practiceId: string, patientId: string, metrics: ClinicalMetricVo[]): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/metrics/capture';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(metrics);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCapturePatientClinicalMetrics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCapturePatientClinicalMetrics(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCapturePatientClinicalMetrics(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Revise allergies
   * @return OK
   */
  revisePatientAllergies(practiceId: string, patientId: string, allergies: RevisePatientAllergies): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientallergies/{patientId}/revise';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(allergies);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientAllergies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientAllergies(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientAllergies(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Revise patient lifestyle
   * @return OK
   */
  revisePatientLifestyle(practiceid: string, patientId: string, lifestyle: RevisePatientLifestyle): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patient/{patientId}/lifestyle/revise';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(lifestyle);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientLifestyle(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientLifestyle(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientLifestyle(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Revise patient hospitalization
   * @return OK
   */
  revisePatientHospitalization(practiceId: string, patientId: string, body: RevisePatientHospitalization): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientId}/hospitalization/revise';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientHospitalization(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientHospitalization(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientHospitalization(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Revise patient clinical notes
   * @return OK
   */
  revisePatientNotes(practiceid: string, patientId: string, clinicalNotes: RevisePatientClinicalNotes): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patientclinicalnotes/{patientId}/revise';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(clinicalNotes);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientNotes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientNotes(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientNotes(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Revise patient сhronic conditions
   * @return OK
   */
  revisePatientChronicConditions(
    practiceid: string,
    patientId: string,
    patientChronicConditions: RevisePatientChronicConditions
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patientchronicconditions/{patientId}/revise';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(patientChronicConditions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientChronicConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientChronicConditions(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientChronicConditions(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Helps send to patient via email medical certificate/prescription/referral
   * @return OK
   */
  sendCommunication(providerId: string, patientId: string, email: ProviderCommunicationEmailVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patient/{patientId}/sendcommunication';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(email);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendCommunication(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendCommunication(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendCommunication(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get quote report for specified patient by his xref
   * @param practiceId practice id
   * @param patientXref external reference of patient in iHealth system
   * @return OK
   */
  getQuoteReport(practiceId: string, patientXref: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patient/{patientXref}/quote/pdf';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientXref === undefined || patientXref === null) throw new Error("The parameter 'patientXref' must be defined.");
    url_ = url_.replace('{patientXref}', encodeURIComponent('' + patientXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetQuoteReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetQuoteReport(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetQuoteReport(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Get all chronic conditions
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getChronicConditionsAll(practiceid: string): Observable<ChronicConditionVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/chroniccondition';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetChronicConditionsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetChronicConditionsAll(<any>response_);
            } catch (e) {
              return <Observable<ChronicConditionVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ChronicConditionVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetChronicConditionsAll(response: HttpResponseBase): Observable<ChronicConditionVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ChronicConditionVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ChronicConditionVo[]>(<any>null);
  }

  /**
   * Get chronic conditions by search text
   * @param practiceid Unique identifier of practice
   * @return OK
   */
  getChronicConditions(practiceid: string, searchText: string): Observable<ChronicConditionVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/chroniccondition/{searchText}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (searchText === undefined || searchText === null) throw new Error("The parameter 'searchText' must be defined.");
    url_ = url_.replace('{searchText}', encodeURIComponent('' + searchText));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetChronicConditions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetChronicConditions(<any>response_);
            } catch (e) {
              return <Observable<ChronicConditionVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ChronicConditionVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetChronicConditions(response: HttpResponseBase): Observable<ChronicConditionVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ChronicConditionVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ChronicConditionVo[]>(<any>null);
  }

  /**
   * Update chronic condition
   * @return OK
   */
  update(practiceId: string, chronicCondition: ChronicConditionVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/chroniccondition/update';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(chronicCondition);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Deactivate chronic condition
   * @return OK
   */
  deactivateCondition(practiceId: string, conditionId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/chroniccondition/{conditionId}/deactivate';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (conditionId === undefined || conditionId === null) throw new Error("The parameter 'conditionId' must be defined.");
    url_ = url_.replace('{conditionId}', encodeURIComponent('' + conditionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivateCondition(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivateCondition(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivateCondition(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Bulk Update chronic condition
   * @param chronicConditions array of conditions
   * @return OK
   */
  bulkUpdate(practiceId: string, chronicConditions: ChronicConditionVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/chroniccondition/bulkupdate';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(chronicConditions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class CommunicationTemplateClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get template list
   * @return OK
   */
  getAllTemplates(): Observable<CommunicationTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/communicationtemplates';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllTemplates(<any>response_);
            } catch (e) {
              return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllTemplates(response: HttpResponseBase): Observable<CommunicationTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CommunicationTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CommunicationTemplateVo[]>(<any>null);
  }

  /**
   * Use to create new template in system
   * @param updateCommunicationTemplate all required template data
   * @return OK
   */
  create(updateCommunicationTemplate: CommunicationTemplateVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/communicationtemplates';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCommunicationTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Use to create new template in system
   * @param updateCommunicationTemplate all required template data
   * @return OK
   */
  create2(updateCommunicationTemplate: CommunicationTemplateVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/communicationtemplates';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCommunicationTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get template list available for specific doctor
   * @return OK
   */
  getTemplatesForDoctorByType(practiceId: string): Observable<CommunicationTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/infrastructure/communicationtemplates';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplatesForDoctorByType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplatesForDoctorByType(<any>response_);
            } catch (e) {
              return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplatesForDoctorByType(response: HttpResponseBase): Observable<CommunicationTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CommunicationTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CommunicationTemplateVo[]>(<any>null);
  }

  /**
   * Get template list available for all providers in practice
   * @return OK
   */
  getTemplatesForPractice(practiceId: string): Observable<CommunicationTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/infrastructure/communicationtemplates/templatesforpractice';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplatesForPractice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplatesForPractice(<any>response_);
            } catch (e) {
              return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplatesForPractice(response: HttpResponseBase): Observable<CommunicationTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CommunicationTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CommunicationTemplateVo[]>(<any>null);
  }

  /**
   * Get template list available for all providers in practice by template types
   * @return OK
   */
  getTemplatesForPracticeByTypes(practiceId: string, templateTypes: string[]): Observable<CommunicationTemplateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/infrastructure/communicationtemplates/templatesforpracticebytypes?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateTypes === undefined || templateTypes === null)
      throw new Error("The parameter 'templateTypes' must be defined and cannot be null.");
    else
      templateTypes &&
        templateTypes.forEach(item => {
          url_ += 'templateTypes=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplatesForPracticeByTypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplatesForPracticeByTypes(<any>response_);
            } catch (e) {
              return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CommunicationTemplateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplatesForPracticeByTypes(response: HttpResponseBase): Observable<CommunicationTemplateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CommunicationTemplateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CommunicationTemplateVo[]>(<any>null);
  }

  /**
   * Use to update specific template based on provided id
   * @param templateid template id which should be changed
   * @return OK
   */
  update(templateid: string, updateCommunicationTemplate: CommunicationTemplateVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/communicationtemplates/{templateid}';
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCommunicationTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Use to update specific template based on provided id
   * @param templateid template id which should be changed
   * @return OK
   */
  update2(templateid: string, updateCommunicationTemplate: CommunicationTemplateVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/communicationtemplates/{templateid}';
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCommunicationTemplate);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Use to remove specific template based on provided id
   * @param templateid template id which should be removed
   * @return OK
   */
  remove(practiceId: string, templateid: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/infrastructure/communicationtemplates/{templateid}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateid === undefined || templateid === null) throw new Error("The parameter 'templateid' must be defined.");
    url_ = url_.replace('{templateid}', encodeURIComponent('' + templateid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemove(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemove(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemove(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ExternalSystemsIntegrationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Creates a new patient for the practice (by business xref)
   * @param tenantXRef ref key of the practice that owns the patient data
   * @param createPatient The patient object
   * @return OK
   */
  createPatientForBusiness(tenantXRef: string, createPatient: CreatePatientRequest): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/patient/create';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePatientForBusiness(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePatientForBusiness(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreatePatientForBusiness(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates an existing patient in a practice (by business xref)
   * @param tenantXRef ref key of the practice that owns the patient data
   * @param changePatient The patient object
   * @return OK
   */
  updatePatientForBusiness(tenantXRef: string, changePatient: ChangePatientRequest): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/patient/update';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientForBusiness(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientForBusiness(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientForBusiness(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates an existing patient in a practice (by business xref)
   * @param tenantXRef ref key of the practice that owns the patient data
   * @param changePatient The patient object
   * @return OK
   */
  updatePatientForBusiness2(tenantXRef: string, changePatient: ChangePatientRequest): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/patient/update';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientForBusiness2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientForBusiness2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientForBusiness2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Delete an existing patient in a practice (by business xref)
   * @param tenantXRef ref key of the practice that owns the patient data
   * @param removePatient The patient object
   * @return OK
   */
  deletePatientForBusiness(tenantXRef: string, removePatient: RemovePatientRequest): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{tenantXRef}/patient/inactivate';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(removePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeletePatientForBusiness(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeletePatientForBusiness(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeletePatientForBusiness(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Creates a new patient for the practice
   * @param practiceXRef NodeId of the practice that owns the patient data
   * @param createPatient The patient object
   * @return OK
   * @deprecated
   */
  create(practiceXRef: string, createPatient: CreatePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patient/create';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates an existing patient in a practice
   * @param practiceXRef NodeId of the practice that owns the patient data
   * @param changePatient The patient object
   * @return OK
   * @deprecated
   */
  updatePatientForDoctor(practiceXRef: string, changePatient: ChangePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patient/update';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientForDoctor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientForDoctor(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientForDoctor(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates an existing patient in a practice
   * @param practiceXRef NodeId of the practice that owns the patient data
   * @param changePatient The patient object
   * @return OK
   * @deprecated
   */
  updatePatientForDoctor2(practiceXRef: string, changePatient: ChangePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patient/update';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientForDoctor2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientForDoctor2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientForDoctor2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Delete an existing patient in a practice
   * @param practiceXRef NodeId of the practice that owns the patient data
   * @param removePatient The patient object
   * @return OK
   * @deprecated
   */
  deletePatientForDoctor(practiceXRef: string, removePatient: RemovePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patient/inactivate';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(removePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeletePatientForDoctor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeletePatientForDoctor(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeletePatientForDoctor(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Schedule patient visit
   * @param practiceXRef practice external id
   * @param schedulePatientVisit public domain-model = SchedulePatientVisit
   * @return OK
   */
  schedulePatientVisit(
    practiceXRef: string,
    schedulePatientVisit: SchedulePatientVisit
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patientevent/patientevents/schedule';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(schedulePatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSchedulePatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSchedulePatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSchedulePatientVisit(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
   * Check in patient into the waiting room
   * @param practiceXRef practice external id
   * @param checkInPatientVisit public domain-model = CheckInPatientVisit
   * @return OK
   */
  checkinPatientVisit(
    practiceXRef: string,
    checkInPatientVisit: CheckInPatientVisit
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patientevent/patientevents/checkin';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(checkInPatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckinPatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckinPatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckinPatientVisit(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
   * Update patient visit details
   * @param practiceXRef practice external id
   * @param updatePatientVisit public domain-model = UpdatePatientVisit
   * @return OK
   */
  updatePatientVisit(practiceXRef: string, updatePatientVisit: UpdatePatientVisit): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patientevent/patientevents/update';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updatePatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientVisit(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
   * Cancel patient visit
   * @param practiceXRef Practice external id
   * @return OK
   */
  cancelPatientVisit(practiceXRef: string, cancelPatientVisit: CancelPatientVisit): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patientevent/patientevents/cancel';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cancelPatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelPatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelPatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCancelPatientVisit(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Complete patient visit
   * @param practiceXRef Practice external id
   * @return OK
   */
  completePatientVisit(practiceXRef: string, completePatientVisit: CompletePatientVisit): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceXRef}/patientevent/patientevents/complete';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(completePatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCompletePatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCompletePatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCompletePatientVisit(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get patient visit details
   * @param practiceXRef Practice external Id
   * @param patientEventXRef Patient Event external Id
   * @return OK
   */
  getPatientVisit(practiceXRef: string, patientEventXRef: string): Observable<PatientEventVo> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/patientevent/patientevents/xref/{patientEventXRef}';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    if (patientEventXRef === undefined || patientEventXRef === null) throw new Error("The parameter 'patientEventXRef' must be defined.");
    url_ = url_.replace('{patientEventXRef}', encodeURIComponent('' + patientEventXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientVisit(<any>response_);
            } catch (e) {
              return <Observable<PatientEventVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientVisit(response: HttpResponseBase): Observable<PatientEventVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventVo>(<any>null);
  }

  /**
   * Allow to accept chat room status changes and push them to client side via data push (SignalR)
   * @param bpn billing practice no.
   * @param tpn treating practice no.
   * @param status status (entered/exited)
   * @param id chat id (in our case patientEventXref)
   * @param name name for person who entered/exited chat
   * @return OK
   */
  updateChatStatus(bpn: string, tpn: string, status: string, id: string, name: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/video-chat/{bpn}/{tpn}/{id}/{status}/{name}';
    if (bpn === undefined || bpn === null) throw new Error("The parameter 'bpn' must be defined.");
    url_ = url_.replace('{bpn}', encodeURIComponent('' + bpn));
    if (tpn === undefined || tpn === null) throw new Error("The parameter 'tpn' must be defined.");
    url_ = url_.replace('{tpn}', encodeURIComponent('' + tpn));
    if (status === undefined || status === null) throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace('{status}', encodeURIComponent('' + status));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace('{name}', encodeURIComponent('' + name));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateChatStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateChatStatus(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateChatStatus(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FeatureUsageClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get all feature usage
   * @return OK
   */
  getAllFeatureUsedAll(): Observable<FeatureUsageVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFeatureUsedAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFeatureUsedAll(<any>response_);
            } catch (e) {
              return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFeatureUsedAll(response: HttpResponseBase): Observable<FeatureUsageVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <FeatureUsageVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FeatureUsageVo[]>(<any>null);
  }

  /**
   * Use to log new feature usage in system
   * @return OK
   */
  create(logFeatureUsed: LogFeatureUsed): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(logFeatureUsed);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Use to log new feature usage in system
   * @return OK
   */
  create2(logFeatureUsed: LogFeatureUsed): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(logFeatureUsed);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get feature usage by tenant
   * @return OK
   */
  getAllFeatureUsed(feature: string): Observable<FeatureUsageVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage/feature/{feature}';
    if (feature === undefined || feature === null) throw new Error("The parameter 'feature' must be defined.");
    url_ = url_.replace('{feature}', encodeURIComponent('' + feature));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFeatureUsed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFeatureUsed(<any>response_);
            } catch (e) {
              return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFeatureUsed(response: HttpResponseBase): Observable<FeatureUsageVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <FeatureUsageVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FeatureUsageVo[]>(<any>null);
  }

  /**
   * Get feature usage by tenant
   * @return OK
   */
  getAllFeatureUsed2(tenantId: string, feature: string): Observable<FeatureUsageVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage/tenant/{tenantId}/feature/{feature}';
    if (tenantId === undefined || tenantId === null) throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace('{tenantId}', encodeURIComponent('' + tenantId));
    if (feature === undefined || feature === null) throw new Error("The parameter 'feature' must be defined.");
    url_ = url_.replace('{feature}', encodeURIComponent('' + feature));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFeatureUsed2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFeatureUsed2(<any>response_);
            } catch (e) {
              return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFeatureUsed2(response: HttpResponseBase): Observable<FeatureUsageVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <FeatureUsageVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FeatureUsageVo[]>(<any>null);
  }

  /**
   * Get feature usage by tenant
   * @return OK
   */
  getFeatureUsedByTenant(tenantId: string): Observable<FeatureUsageVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/featureusage/tenant/{tenantId}';
    if (tenantId === undefined || tenantId === null) throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace('{tenantId}', encodeURIComponent('' + tenantId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFeatureUsedByTenant(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFeatureUsedByTenant(<any>response_);
            } catch (e) {
              return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<FeatureUsageVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFeatureUsedByTenant(response: HttpResponseBase): Observable<FeatureUsageVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <FeatureUsageVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FeatureUsageVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FunderConfigurationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get all medical aids
   * @return OK
   */
  getAllMedicalAids(): Observable<MedicalAidVo[]> {
    let url_ = this.baseUrl + '/api/v1/patient/medschemes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllMedicalAids(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllMedicalAids(<any>response_);
            } catch (e) {
              return <Observable<MedicalAidVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<MedicalAidVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllMedicalAids(response: HttpResponseBase): Observable<MedicalAidVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <MedicalAidVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MedicalAidVo[]>(<any>null);
  }

  /**
   * Get all specific rules
   * @return OK
   */
  getAllFunderSpecificRules(): Observable<RestApiResultOfFunderSpecificRuleVoOf> {
    let url_ = this.baseUrl + '/api/v1/patient/funderconfigurations/specificrules';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFunderSpecificRules(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFunderSpecificRules(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfFunderSpecificRuleVoOf>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfFunderSpecificRuleVoOf>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFunderSpecificRules(response: HttpResponseBase): Observable<RestApiResultOfFunderSpecificRuleVoOf> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfFunderSpecificRuleVoOf>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfFunderSpecificRuleVoOf>(<any>null);
  }

  /**
   * Update all specific rules in the system
   * @return OK
   */
  updateSpecificRules(specificRules: FunderSpecificRuleVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/patient/funderconfigurations/specificrules';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(specificRules);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSpecificRules(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSpecificRules(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateSpecificRules(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get specific rules for provided patient
   * @param dateOfService encounter date of service
   * @return OK
   */
  getFunderSpecificRulesByCode(
    practiceid: string,
    patientId: string,
    dateOfService: Date
  ): Observable<RestApiResultOfFunderSpecificRuleVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/funderconfigurations/specificrules/{patientId}/{dateOfService}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (dateOfService === undefined || dateOfService === null) throw new Error("The parameter 'dateOfService' must be defined.");
    url_ = url_.replace('{dateOfService}', encodeURIComponent(dateOfService ? '' + dateOfService.toJSON() : 'null'));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFunderSpecificRulesByCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFunderSpecificRulesByCode(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfFunderSpecificRuleVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfFunderSpecificRuleVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetFunderSpecificRulesByCode(response: HttpResponseBase): Observable<RestApiResultOfFunderSpecificRuleVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfFunderSpecificRuleVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfFunderSpecificRuleVo>(<any>null);
  }

  /**
   * Update medical aids
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  updateFunderConfigurations(practiceid: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/updatefunderconfiguration';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFunderConfigurations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFunderConfigurations(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateFunderConfigurations(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Update medical aids
   * @return OK
   */
  updateFunderConfigurations2(medicalAids: MedicalAidVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/patient/updatefunderconfiguration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(medicalAids);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFunderConfigurations2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFunderConfigurations2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateFunderConfigurations2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class HealthIntegrationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get url pointed to healthID system for provided patient
   * @param practiceId provider id in mps system
   * @param patientId patient id in mps system
   * @return OK
   */
  getPatientSpecificHealthIdUrl(practiceId: string, patientId: string): Observable<TokenResponse> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/healthid/patient/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientSpecificHealthIdUrl(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientSpecificHealthIdUrl(<any>response_);
            } catch (e) {
              return <Observable<TokenResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<TokenResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientSpecificHealthIdUrl(response: HttpResponseBase): Observable<TokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TokenResponse>(<any>null);
  }

  /**
   * Get url pointed to healthID system for provided patient payload
   * @param practiceId provider id in mps system
   * @param patientId patient id in mps system
   * @return OK
   */
  getPatientSpecificHealthIdUrlForPatient(practiceId: string, patientId: string, patientDetails: PatientVo): Observable<TokenResponse> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/healthid/patient/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(patientDetails);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientSpecificHealthIdUrlForPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientSpecificHealthIdUrlForPatient(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TokenResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TokenResponse>;
        })
      );
  }

  protected processGetPatientSpecificHealthIdUrlForPatient(response: HttpResponseBase): Observable<TokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TokenResponse>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class InfrastructureClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * @return OK
   */
  getConnectivityState(practiceid: string): Observable<RestApiResultOfInt32> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/infrastructure/network/state';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConnectivityState(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConnectivityState(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInt32>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInt32>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetConnectivityState(response: HttpResponseBase): Observable<RestApiResultOfInt32> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInt32>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInt32>(<any>null);
  }

  /**
   * Get list of all REST endpoints
   * @return OK
   */
  getRoutes(): Observable<RestEndpointVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/api/routes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoutes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoutes(<any>response_);
            } catch (e) {
              return <Observable<RestEndpointVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestEndpointVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRoutes(response: HttpResponseBase): Observable<RestEndpointVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestEndpointVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestEndpointVo[]>(<any>null);
  }

  /**
   * Collect memory to specific generation level
   * @return OK
   */
  collect(level: number): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/memory/collect/{level}';
    if (level === undefined || level === null) throw new Error("The parameter 'level' must be defined.");
    url_ = url_.replace('{level}', encodeURIComponent('' + level));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCollect(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCollect(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCollect(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Collect Large Object Heap
   * @return OK
   */
  collectLoh(): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/memory/collect/loh';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCollectLoh(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCollectLoh(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCollectLoh(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Download messages which stuck currently in .commands dlq
   * @return OK
   */
  getDlqCommands(): Observable<{ [key: string]: any }> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/processing/commands/dlq';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDlqCommands(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDlqCommands(<any>response_);
            } catch (e) {
              return <Observable<{ [key: string]: any }>>(<any>_observableThrow(e));
            }
          } else return <Observable<{ [key: string]: any }>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDlqCommands(response: HttpResponseBase): Observable<{ [key: string]: any }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <{ [key: string]: any }>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: any }>(<any>null);
  }

  /**
   * Get specified no. of messages from dlq and return them back to original queue
   * @return OK
   */
  retryDlqCommands(count: number): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/processing/commands/dlq/retry/{count}';
    if (count === undefined || count === null) throw new Error("The parameter 'count' must be defined.");
    url_ = url_.replace('{count}', encodeURIComponent('' + count));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRetryDlqCommands(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRetryDlqCommands(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRetryDlqCommands(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Receive any AR command as json string and fire into CQRS infrastructure
   * @return OK
   */
  sendCommand(request: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/command/send';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendCommand(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendCommand(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendCommand(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Make snapshot for in-memory projections, as result return checkpoint token
   * @return OK
   */
  makeSnapshot(): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/projections/snapshot';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMakeSnapshot(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMakeSnapshot(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMakeSnapshot(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Setup doctor environment (create ProviderConfiguration, register user, insert default templates, etc)
   * @param provider Command object with provider configuration and other fields needed
   * @param sendUserCredentialsToProvider indicate whether we need to user credentials via email directly to doctor
   * @param tenantXRef the tenant for the provider (i.e. the Xref for the practice/business)
   * @return OK
   */
  createProvider(
    provider: ProviderConfigurationVo,
    sendUserCredentialsToProvider: boolean,
    tenantXRef: string
  ): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/providers/{tenantXRef}/add?';
    if (tenantXRef === undefined || tenantXRef === null) throw new Error("The parameter 'tenantXRef' must be defined.");
    url_ = url_.replace('{tenantXRef}', encodeURIComponent('' + tenantXRef));
    if (sendUserCredentialsToProvider === undefined || sendUserCredentialsToProvider === null)
      throw new Error("The parameter 'sendUserCredentialsToProvider' must be defined and cannot be null.");
    else url_ += 'sendUserCredentialsToProvider=' + encodeURIComponent('' + sendUserCredentialsToProvider) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(provider);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateProvider(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateProvider(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Temporal endpoint for performance testing (creates practices based on provided)
   * @return OK
   */
  createNewPractice(practiceId: string, count: number): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/testing/create/{practiceId}/counts/{count}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (count === undefined || count === null) throw new Error("The parameter 'count' must be defined.");
    url_ = url_.replace('{count}', encodeURIComponent('' + count));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateNewPractice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateNewPractice(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateNewPractice(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Create new provider context including all data inside based on provided tenantId
   * @param tenantId tenantId of practice from where we need to copy data
   * @param username username to access newly created provider
   * @param password password to access newly created provider
   * @return OK
   */
  setupSandboxContext(tenantId: string, username: string, password: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{tenantId}/clinical/all/setup?';
    if (tenantId === undefined || tenantId === null) throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace('{tenantId}', encodeURIComponent('' + tenantId));
    if (username === undefined || username === null) throw new Error("The parameter 'username' must be defined and cannot be null.");
    else url_ += 'username=' + encodeURIComponent('' + username) + '&';
    if (password === undefined || password === null) throw new Error("The parameter 'password' must be defined and cannot be null.");
    else url_ += 'password=' + encodeURIComponent('' + password) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetupSandboxContext(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetupSandboxContext(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetupSandboxContext(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class MyMpsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get calendar information from mymps system ( etc)
   * @param practiceId doctor id in DrApp system
   * @param days (optional)
   * @return OK
   */
  getCalendarAppointments(practiceId: string, from: Date, days?: number | null | undefined): Observable<CalendarEventVo[]> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/calendar?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (from === undefined || from === null) throw new Error("The parameter 'from' must be defined and cannot be null.");
    else url_ += 'from=' + encodeURIComponent(from ? '' + from.toJSON() : '') + '&';
    if (days !== undefined && days !== null) url_ += 'days=' + encodeURIComponent('' + days) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCalendarAppointments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCalendarAppointments(<any>response_);
            } catch (e) {
              return <Observable<CalendarEventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CalendarEventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCalendarAppointments(response: HttpResponseBase): Observable<CalendarEventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CalendarEventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CalendarEventVo[]>(<any>null);
  }

  /**
   * Get calendar information from mymps system ( etc)
   * @param practiceId doctor id in DrApp system
   * @param providerIds comma delimited string of provider Ids
   * @param days (optional)
   * @return OK
   */
  getPracticeCalendarAppointments(
    practiceId: string,
    providerIds: string,
    from: Date,
    days?: number | null | undefined
  ): Observable<CalendarEventVo[]> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/practicecalendar?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (providerIds === undefined || providerIds === null)
      throw new Error("The parameter 'providerIds' must be defined and cannot be null.");
    else url_ += 'providerIds=' + encodeURIComponent('' + providerIds) + '&';
    if (from === undefined || from === null) throw new Error("The parameter 'from' must be defined and cannot be null.");
    else url_ += 'from=' + encodeURIComponent(from ? '' + from.toJSON() : '') + '&';
    if (days !== undefined && days !== null) url_ += 'days=' + encodeURIComponent('' + days) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPracticeCalendarAppointments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPracticeCalendarAppointments(<any>response_);
            } catch (e) {
              return <Observable<CalendarEventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<CalendarEventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPracticeCalendarAppointments(response: HttpResponseBase): Observable<CalendarEventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <CalendarEventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CalendarEventVo[]>(<any>null);
  }

  /**
   * Get appointment details from mymps system.
   * @param appointmentXRef Mps AppointmentId, could also be CalendarEventXRef
   * @return OK
   */
  getAppointmentDetails(practiceId: string, appointmentXRef: string): Observable<AppointmentDetailsVo> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/calendar/details/{appointmentXRef}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (appointmentXRef === undefined || appointmentXRef === null) throw new Error("The parameter 'appointmentXRef' must be defined.");
    url_ = url_.replace('{appointmentXRef}', encodeURIComponent('' + appointmentXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAppointmentDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAppointmentDetails(<any>response_);
            } catch (e) {
              return <Observable<AppointmentDetailsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<AppointmentDetailsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAppointmentDetails(response: HttpResponseBase): Observable<AppointmentDetailsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AppointmentDetailsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AppointmentDetailsVo>(<any>null);
  }

  /**
   * Load templates page for specific template type
   * @param practiceId doctor id in DrApp system
   * @param sortingOrder 0 = CAPTION_ASC, 1 = CAPTION_DESC, 2 = SORT_ORDER_ASC, 3 = SORT_ORDER_DESC
   * @param search (optional)
   * @return OK
   */
  getTemplatePage(
    practiceId: string,
    templateType: string,
    pageSize: number,
    pageNo: number,
    sortingOrder: SortingOrder,
    search?: string | null | undefined
  ): Observable<TemplateSummaryVo[]> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/{templateType}?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateType === undefined || templateType === null) throw new Error("The parameter 'templateType' must be defined.");
    url_ = url_.replace('{templateType}', encodeURIComponent('' + templateType));
    if (pageSize === undefined || pageSize === null) throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
    else url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (pageNo === undefined || pageNo === null) throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
    else url_ += 'pageNo=' + encodeURIComponent('' + pageNo) + '&';
    if (sortingOrder === undefined || sortingOrder === null)
      throw new Error("The parameter 'sortingOrder' must be defined and cannot be null.");
    else url_ += 'sortingOrder=' + encodeURIComponent('' + sortingOrder) + '&';
    if (search !== undefined && search !== null) url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplatePage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplatePage(<any>response_);
            } catch (e) {
              return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplatePage(response: HttpResponseBase): Observable<TemplateSummaryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TemplateSummaryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TemplateSummaryVo[]>(<any>null);
  }

  /**
   * Load templates page for specific template type
   * @param practiceId doctor id in DrApp system
   * @return OK
   */
  getTemplateGroups(practiceId: string, templateType: string): Observable<TemplateSummaryVo[]> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/{templateType}/group';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateType === undefined || templateType === null) throw new Error("The parameter 'templateType' must be defined.");
    url_ = url_.replace('{templateType}', encodeURIComponent('' + templateType));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplateGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplateGroups(<any>response_);
            } catch (e) {
              return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplateGroups(response: HttpResponseBase): Observable<TemplateSummaryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TemplateSummaryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TemplateSummaryVo[]>(<any>null);
  }

  /**
   * Create new category group
   * @param practiceId doctor id in DrApp system
   * @param request group details
   * @return OK
   */
  createTemplateGroup(practiceId: string, templateType: string, request: TemplateSummaryVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/{templateType}/group';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateType === undefined || templateType === null) throw new Error("The parameter 'templateType' must be defined.");
    url_ = url_.replace('{templateType}', encodeURIComponent('' + templateType));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateTemplateGroup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateTemplateGroup(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateTemplateGroup(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Save template (create new or update existing)
   * @return OK
   */
  updateTemplate(practiceId: string, templateVo: EncounterTemplateVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(templateVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTemplate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateTemplate(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Load template's group within specific template type
   * @param practiceId doctor id in DrApp system
   * @param sortingOrder 0 = CAPTION_ASC, 1 = CAPTION_DESC, 2 = SORT_ORDER_ASC, 3 = SORT_ORDER_DESC
   * @return OK
   */
  getTemplateGroup(practiceId: string, xref: string, sortingOrder: SortingOrder2): Observable<TemplateSummaryVo[]> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/group/{xref}?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (xref === undefined || xref === null) throw new Error("The parameter 'xref' must be defined.");
    url_ = url_.replace('{xref}', encodeURIComponent('' + xref));
    if (sortingOrder === undefined || sortingOrder === null)
      throw new Error("The parameter 'sortingOrder' must be defined and cannot be null.");
    else url_ += 'sortingOrder=' + encodeURIComponent('' + sortingOrder) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplateGroup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplateGroup(<any>response_);
            } catch (e) {
              return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TemplateSummaryVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplateGroup(response: HttpResponseBase): Observable<TemplateSummaryVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TemplateSummaryVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TemplateSummaryVo[]>(<any>null);
  }

  /**
   * Load template details
   * @param practiceId doctor id in DrApp system
   * @return OK
   */
  getTemplateDetails(practiceId: string, templateXRef: string): Observable<EncounterTemplateVo> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/{templateXRef}/details';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateXRef === undefined || templateXRef === null) throw new Error("The parameter 'templateXRef' must be defined.");
    url_ = url_.replace('{templateXRef}', encodeURIComponent('' + templateXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplateDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTemplateDetails(<any>response_);
            } catch (e) {
              return <Observable<EncounterTemplateVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<EncounterTemplateVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTemplateDetails(response: HttpResponseBase): Observable<EncounterTemplateVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <EncounterTemplateVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<EncounterTemplateVo>(<any>null);
  }

  /**
   * Load template details
   * @param practiceId doctor id in DrApp system
   * @return OK
   */
  deleteTemplate(practiceId: string, templateXRef: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/template/{templateXRef}/delete';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (templateXRef === undefined || templateXRef === null) throw new Error("The parameter 'templateXRef' must be defined.");
    url_ = url_.replace('{templateXRef}', encodeURIComponent('' + templateXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteTemplate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteTemplate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteTemplate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get account financial information from mymps system (BC status, account liable, account notes, etc)
   * @param practiceId doctor id in DrApp system
   * @param patientId patient id in DrApp system
   * @return OK
   */
  getAccountFinancialInformation(practiceId: string, patientId: string): Observable<AccountInfoVo> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/patient/{patientId}/account/info';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountFinancialInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountFinancialInformation(<any>response_);
            } catch (e) {
              return <Observable<AccountInfoVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<AccountInfoVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAccountFinancialInformation(response: HttpResponseBase): Observable<AccountInfoVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AccountInfoVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AccountInfoVo>(<any>null);
  }

  /**
   * Clear external data from patient timeline (which was loaded from mymps system)
   * @return OK
   */
  clearExternalDataFromTimeline(practiceId: string, patientId: string): Observable<RestApiResultOfInt64> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/patient/{patientId}/externaldata/clear';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearExternalDataFromTimeline(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearExternalDataFromTimeline(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfInt64>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfInt64>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processClearExternalDataFromTimeline(response: HttpResponseBase): Observable<RestApiResultOfInt64> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfInt64>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfInt64>(<any>null);
  }

  /**
   * Load missed encounters on patient timeline (from mymps system)
   * @return OK
   */
  loadEncountersOnTimeline(practiceId: string, patientId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/patient/{patientId}/externaldata/load';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLoadEncountersOnTimeline(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLoadEncountersOnTimeline(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processLoadEncountersOnTimeline(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Test loading missed encounters on patient timeline (from mymps system)
   * @return OK
   */
  testLoadEncountersOnTimeline(practiceId: string, patientId: string, encounterVos: EncounterVo[]): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/support/{practiceId}/clinical/patientdashboards/{patientId}/externaldata/test';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(encounterVos);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestLoadEncountersOnTimeline(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestLoadEncountersOnTimeline(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processTestLoadEncountersOnTimeline(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class NodeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get public keys
   * @return OK
   */
  getPubilcKeyList(): Observable<NodePublicKeyVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/publickeylist';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPubilcKeyList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPubilcKeyList(<any>response_);
            } catch (e) {
              return <Observable<NodePublicKeyVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NodePublicKeyVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPubilcKeyList(response: HttpResponseBase): Observable<NodePublicKeyVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NodePublicKeyVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NodePublicKeyVo[]>(<any>null);
  }

  /**
   * Mark as validated public key for node
   * @return OK
   */
  validatePublicKey(nodeId: string, nodePublicKeyVo: NodePublicKeyVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/validate';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nodePublicKeyVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidatePublicKey(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidatePublicKey(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidatePublicKey(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Mark as validated public key for node
   * @return OK
   */
  validatePublicKey2(nodeId: string, nodePublicKeyVo: NodePublicKeyVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/validate';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nodePublicKeyVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidatePublicKey2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidatePublicKey2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidatePublicKey2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Mark as revoked public key for node
   * @return OK
   */
  revokePublicKey(nodeId: string, nodePublicKeyVo: NodePublicKeyVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/revoke';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nodePublicKeyVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevokePublicKey(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevokePublicKey(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevokePublicKey(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Mark as revoked public key for node
   * @return OK
   */
  revokePublicKey2(nodeId: string, nodePublicKeyVo: NodePublicKeyVo): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/revoke';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nodePublicKeyVo);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevokePublicKey2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevokePublicKey2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevokePublicKey2(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do initial setup for node
   * @param configureNode command with required informatin (tenantIds, numericNodeId, description, policy, etc)
   * @return OK
   */
  configureNode(configureNode: ConfigureNode): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configureNode);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConfigureNode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConfigureNode(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processConfigureNode(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Assign policy for specific node
   * @return OK
   */
  assignNodePolicy(nodeId: string, nodePolicy: AssignNodePolicy): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/policy';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(nodePolicy);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAssignNodePolicy(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAssignNodePolicy(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAssignNodePolicy(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to accept outbound events produced by untrusted(installed on client machine) external nodes
   * @param nodeId node id in our system
   * @param eventStream event message as zipped bytearray
   * @return OK
   */
  receiveEvent(nodeId: string, eventStream: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/event';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(eventStream);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReceiveEvent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReceiveEvent(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReceiveEvent(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get node details based on provided pairing key
   * @param pairingKey 8 digits key
   * @return OK
   */
  pairNode(pairingKey: string): Observable<RestApiResultOfNodeVo> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/pair';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(pairingKey);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPairNode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPairNode(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfNodeVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfNodeVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPairNode(response: HttpResponseBase): Observable<RestApiResultOfNodeVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfNodeVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfNodeVo>(<any>null);
  }

  /**
   * Generate pairing key for provided node
   * @param nodeId id of node
   * @return OK
   */
  generatePairingKey(nodeId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}/generatepairingkey';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeneratePairingKey(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeneratePairingKey(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGeneratePairingKey(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Get details for specific node
   * @return OK
   */
  getNodeDetails(nodeId: string): Observable<NodeVo> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/node/{nodeId}';
    if (nodeId === undefined || nodeId === null) throw new Error("The parameter 'nodeId' must be defined.");
    url_ = url_.replace('{nodeId}', encodeURIComponent('' + nodeId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNodeDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNodeDetails(<any>response_);
            } catch (e) {
              return <Observable<NodeVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<NodeVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNodeDetails(response: HttpResponseBase): Observable<NodeVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NodeVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NodeVo>(<any>null);
  }

  /**
   * Get list of all nodes
   * @return OK
   */
  getNodes(): Observable<NodeVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/nodes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNodes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNodes(<any>response_);
            } catch (e) {
              return <Observable<NodeVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NodeVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNodes(response: HttpResponseBase): Observable<NodeVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NodeVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NodeVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class NotificationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get top 5 notifications for provider
   * @return OK
   */
  getTopNotifications(providerId: string): Observable<NotificationStatusView[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/topnotifications';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTopNotifications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTopNotifications(<any>response_);
            } catch (e) {
              return <Observable<NotificationStatusView[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NotificationStatusView[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTopNotifications(response: HttpResponseBase): Observable<NotificationStatusView[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NotificationStatusView[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NotificationStatusView[]>(<any>null);
  }

  /**
   * Get active notifications for provider
   * @return OK
   */
  getNotifications(providerId: string): Observable<NotificationVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/notifications';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotifications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotifications(<any>response_);
            } catch (e) {
              return <Observable<NotificationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NotificationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNotifications(response: HttpResponseBase): Observable<NotificationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NotificationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NotificationVo[]>(<any>null);
  }

  /**
   * Raise new notification for provider
   * @return OK
   */
  raiseNotification(providerId: string, notification: RaiseNotification): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/notifications';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notification);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRaiseNotification(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRaiseNotification(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRaiseNotification(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get active notifications for provider
   * @return OK
   */
  getNotificationsByXRefs(practiceXRef: string): Observable<NotificationVo[]> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/infrastructure/notifications';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotificationsByXRefs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotificationsByXRefs(<any>response_);
            } catch (e) {
              return <Observable<NotificationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NotificationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNotificationsByXRefs(response: HttpResponseBase): Observable<NotificationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NotificationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NotificationVo[]>(<any>null);
  }

  /**
   * Get active notifications for provider and context
   * @return OK
   */
  getNotificationsForContext(providerId: string, context: string): Observable<NotificationVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/notifications/bycontext/{context}';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (context === undefined || context === null) throw new Error("The parameter 'context' must be defined.");
    url_ = url_.replace('{context}', encodeURIComponent('' + context));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotificationsForContext(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotificationsForContext(<any>response_);
            } catch (e) {
              return <Observable<NotificationVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NotificationVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetNotificationsForContext(response: HttpResponseBase): Observable<NotificationVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <NotificationVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NotificationVo[]>(<any>null);
  }

  /**
   * Raise multiple notifications in one go
   * @param notifications array of notifications
   * @return OK
   */
  bulkNotificationsRaise(notifications: NotificationVo[]): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/notifications/bulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notifications);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkNotificationsRaise(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkNotificationsRaise(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkNotificationsRaise(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Raise multiple notifications in one go
   * @return OK
   */
  bulkNotificationsRaiseFromFile(): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/notifications/bulkfromfile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkNotificationsRaiseFromFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkNotificationsRaiseFromFile(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkNotificationsRaiseFromFile(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Raise new notification for provider
   * @return OK
   */
  raiseNotification2(providerXRef: string, notification: RaiseNotification): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{providerXRef}/infrastructure/notifications';
    if (providerXRef === undefined || providerXRef === null) throw new Error("The parameter 'providerXRef' must be defined.");
    url_ = url_.replace('{providerXRef}', encodeURIComponent('' + providerXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notification);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRaiseNotification2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRaiseNotification2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRaiseNotification2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Mark notification as viewed
   * @return OK
   */
  viewNotification(providerId: string, notificationId: string, notification: MarkNotificationAsViewed): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/notifications/{notificationId}/view';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (notificationId === undefined || notificationId === null) throw new Error("The parameter 'notificationId' must be defined.");
    url_ = url_.replace('{notificationId}', encodeURIComponent('' + notificationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notification);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processViewNotification(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processViewNotification(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processViewNotification(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Mark notification as viewed
   * @return OK
   */
  viewNotification2(providerXRef: string, notificationXRef: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{providerXRef}/infrastructure/notifications/xref/{notificationXRef}/view';
    if (providerXRef === undefined || providerXRef === null) throw new Error("The parameter 'providerXRef' must be defined.");
    url_ = url_.replace('{providerXRef}', encodeURIComponent('' + providerXRef));
    if (notificationXRef === undefined || notificationXRef === null) throw new Error("The parameter 'notificationXRef' must be defined.");
    url_ = url_.replace('{notificationXRef}', encodeURIComponent('' + notificationXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processViewNotification2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processViewNotification2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processViewNotification2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Action notification
   * @return OK
   */
  actionNotification(
    providerId: string,
    notificationId: string,
    notificationAction: NotificationActionVo
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/notifications/{notificationId}/action';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (notificationId === undefined || notificationId === null) throw new Error("The parameter 'notificationId' must be defined.");
    url_ = url_.replace('{notificationId}', encodeURIComponent('' + notificationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notificationAction);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionNotification(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionNotification(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActionNotification(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Action notification
   * @return OK
   */
  actionNotification2(
    providerXRef: string,
    notificationXRef: string,
    notificationAction: NotificationActionVo
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/xref/{providerXRef}/infrastructure/notifications/xref/{notificationXRef}/action';
    if (providerXRef === undefined || providerXRef === null) throw new Error("The parameter 'providerXRef' must be defined.");
    url_ = url_.replace('{providerXRef}', encodeURIComponent('' + providerXRef));
    if (notificationXRef === undefined || notificationXRef === null) throw new Error("The parameter 'notificationXRef' must be defined.");
    url_ = url_.replace('{notificationXRef}', encodeURIComponent('' + notificationXRef));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notificationAction);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionNotification2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionNotification2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActionNotification2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PatientClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get all patients in the practice
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getAllPatients(practiceid: string): Observable<PatientVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patientslist';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPatients(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPatients(<any>response_);
            } catch (e) {
              return <Observable<PatientVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllPatients(response: HttpResponseBase): Observable<PatientVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo[]>(<any>null);
  }

  /**
   * Get all medical aids
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getAllMedicalAids(practiceid: string): Observable<MedicalAidVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/medschemes';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllMedicalAids(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllMedicalAids(<any>response_);
            } catch (e) {
              return <Observable<MedicalAidVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<MedicalAidVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllMedicalAids(response: HttpResponseBase): Observable<MedicalAidVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <MedicalAidVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MedicalAidVo[]>(<any>null);
  }

  /**
   * Get relevant account no. details
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param accountNo account number search by
   * @return OK
   */
  getAccountDetails(practiceid: string, accountNo: string): Observable<AccountDetailsVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/account/{accountNo}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (accountNo === undefined || accountNo === null) throw new Error("The parameter 'accountNo' must be defined.");
    url_ = url_.replace('{accountNo}', encodeURIComponent('' + accountNo));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountDetails(<any>response_);
            } catch (e) {
              return <Observable<AccountDetailsVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<AccountDetailsVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAccountDetails(response: HttpResponseBase): Observable<AccountDetailsVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <AccountDetailsVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AccountDetailsVo>(<any>null);
  }

  /**
   * Get patient in the practice
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param patientid Patient id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  get(practiceid: string, patientid: string): Observable<PatientVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/{patientid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientid === undefined || patientid === null) throw new Error("The parameter 'patientid' must be defined.");
    url_ = url_.replace('{patientid}', encodeURIComponent('' + patientid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<PatientVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<PatientVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo>(<any>null);
  }

  /**
   * Updates an existing patient in a practice
   * @param practiceid NodeId of the practice that owns the patient data
   * @param patientid NodeId of the patient to be updated
   * @param changePatient The patient object
   * @return OK
   */
  changePatient(practiceid: string, patientid: string, changePatient: ChangePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/{patientid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientid === undefined || patientid === null) throw new Error("The parameter 'patientid' must be defined.");
    url_ = url_.replace('{patientid}', encodeURIComponent('' + patientid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePatient(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePatient(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates an existing patient in a practice
   * @param practiceid NodeId of the practice that owns the patient data
   * @param patientid NodeId of the patient to be updated
   * @param changePatient The patient object
   * @return OK
   */
  changePatient2(practiceid: string, patientid: string, changePatient: ChangePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/{patientid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientid === undefined || patientid === null) throw new Error("The parameter 'patientid' must be defined.");
    url_ = url_.replace('{patientid}', encodeURIComponent('' + patientid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(changePatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePatient2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePatient2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePatient2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Deletes a patient in the practice
   * @param practiceid NodeId of the practice that owns the patient data
   * @param patientid NodeId of the patient to be updated
   * @return OK
   */
  removePatient(practiceid: string, patientid: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/{patientid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientid === undefined || patientid === null) throw new Error("The parameter 'patientid' must be defined.");
    url_ = url_.replace('{patientid}', encodeURIComponent('' + patientid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatient(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatient(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get filtered patients in the practice
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param lookupfilter chars for filtering by patient information
   * @return OK
   */
  getAll(practiceid: string, lookupfilter: string): Observable<PatientVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<PatientVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PatientVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo[]>(<any>null);
  }

  /**
   * Get filtered patients in the practice
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param patientXref Patient Xref
   * @return OK
   */
  getByXref(practiceid: string, patientXref: string): Observable<PatientVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients/xref/{patientXref}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientXref === undefined || patientXref === null) throw new Error("The parameter 'patientXref' must be defined.");
    url_ = url_.replace('{patientXref}', encodeURIComponent('' + patientXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByXref(<any>response_);
            } catch (e) {
              return <Observable<PatientVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetByXref(response: HttpResponseBase): Observable<PatientVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo>(<any>null);
  }

  /**
   * Get family members details for provided patient
   * @return OK
   */
  getAccountMembers(practiceId: string, patientId: string): Observable<PatientVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patient/patients/{patientId}/members';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountMembers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountMembers(<any>response_);
            } catch (e) {
              return <Observable<PatientVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAccountMembers(response: HttpResponseBase): Observable<PatientVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientVo[]>(<any>null);
  }

  /**
   * Get filtered patients in the practice
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param lookupfilter chars for filtering by patient information
   * @return OK
   */
  searchInNationalDatabase(practiceid: string, lookupfilter: string): Observable<RestApiResultOfPatientVoOf> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientmaster/patients/{lookupfilter}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (lookupfilter === undefined || lookupfilter === null) throw new Error("The parameter 'lookupfilter' must be defined.");
    url_ = url_.replace('{lookupfilter}', encodeURIComponent('' + lookupfilter));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchInNationalDatabase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchInNationalDatabase(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfPatientVoOf>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfPatientVoOf>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearchInNationalDatabase(response: HttpResponseBase): Observable<RestApiResultOfPatientVoOf> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfPatientVoOf>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfPatientVoOf>(<any>null);
  }

  /**
   * Get account number of main member
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param accountDetails Account details of dependent
   * @return OK
   */
  getAccountNumber(practiceid: string, accountDetails: AccountDetailsVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/account';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(accountDetails);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountNumber(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountNumber(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAccountNumber(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Get account number of main member
   * @param practiceid Practice NodeId, default value 00000000-0000-0000-0000-000000000000
   * @param accountDetails Account details of dependent
   * @return OK
   */
  getAccountNumber2(practiceid: string, accountDetails: AccountDetailsVo): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/account';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(accountDetails);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountNumber2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountNumber2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAccountNumber2(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Creates a new patient for the practice
   * @param practiceid NodeId of the practice that owns the patient data
   * @param createPatient The patient object
   * @return OK
   */
  createPatient(practiceid: string, createPatient: CreatePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePatient(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreatePatient(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Creates a new patient for the practice
   * @param practiceid NodeId of the practice that owns the patient data
   * @param createPatient The patient object
   * @return OK
   */
  createPatient2(practiceid: string, createPatient: CreatePatient): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patient/patients';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createPatient);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePatient2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePatient2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreatePatient2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Reimport all patients from one tenant to another
   * @param providerId from where to import
   * @param practiceTenantId to which tenant import
   * @return OK
   */
  reimportPatients(providerId: string, practiceTenantId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/patient/patients/reimport/{practiceTenantId}';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (practiceTenantId === undefined || practiceTenantId === null) throw new Error("The parameter 'practiceTenantId' must be defined.");
    url_ = url_.replace('{practiceTenantId}', encodeURIComponent('' + practiceTenantId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReimportPatients(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReimportPatients(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReimportPatients(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Add/Update patient configration
   * @return OK
   */
  revisePatientConfiguration(
    providerId: string,
    patientId: string,
    configuration: PatientConfigurationVo
  ): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patient/configuration/{patientId}/revise';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(configuration);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevisePatientConfiguration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevisePatientConfiguration(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevisePatientConfiguration(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Remove patient configration
   * @return OK
   */
  removePatientConfiguration(providerId: string, patientId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patient/configuration/{patientId}/remove';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemovePatientConfiguration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemovePatientConfiguration(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemovePatientConfiguration(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PatientDocumentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get patient documents
   * @param practiceId Unique identifier of practice
   * @param patientId Unique identifier of patient
   * @return OK
   */
  getPatientDocuments(practiceId: string, patientId: string): Observable<PatientDocumentVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocuments(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocuments(response: HttpResponseBase): Observable<PatientDocumentVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo[]>(<any>null);
  }

  /**
     * Capture patient document

    header['payload'] - serialized in json PatientDocumentVo object
    header['ReplaceExistingDocument'] - 'true', 'false', indicate if existing should replaced (like avatars)
     * @return OK
     */
  captureDocument(practiceId: string, patientId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaptureDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaptureDocument(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCaptureDocument(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Update PatientDocument Note
   * @return OK
   */
  sendPatientDocument(practiceId: string, documentId: string, email: SendPatientDocumentEmail): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{documentId}/email';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(email);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendPatientDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendPatientDocument(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSendPatientDocument(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get PatientDocuments Count
   * @return OK
   */
  getPatientDocumentsCount(practiceId: string, patientId: string): Observable<number> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}/count';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocumentsCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocumentsCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocumentsCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
     * Reimport all patient documents from one tenant to another only for existing patients
    (should be used for migration from single-doctor context to multi-tenant)
     * @param providerId from where to import
     * @param practiceTenantId to which tenant import
     * @return OK
     */
  reimportPatientDocuments(providerId: string, practiceTenantId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/clinical/patientdocuments/reimport/{practiceTenantId}';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (practiceTenantId === undefined || practiceTenantId === null) throw new Error("The parameter 'practiceTenantId' must be defined.");
    url_ = url_.replace('{practiceTenantId}', encodeURIComponent('' + practiceTenantId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReimportPatientDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReimportPatientDocuments(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReimportPatientDocuments(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }

  /**
   * Update PatientDocument Note
   * @return OK
   */
  updatePatientDocumentNote(
    practiceId: string,
    documentId: string,
    updateCmd: UpdatePatientDocumentNote
  ): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{documentId}/note';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCmd);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientDocumentNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientDocumentNote(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientDocumentNote(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Update PatientDocument (category or description)
   * @return OK
   */
  updatePatientDocument(practiceId: string, documentId: string, updateCmd: UpdatePatientDocument): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{documentId}/update';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCmd);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientDocument(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePatientDocument(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * remove document
   * @return OK
   */
  removeDocument(practiceId: string, documentId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{documentId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveDocument(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveDocument(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Loads the drawing templates for the practice
   * @param practiceId Unique identifier of practice
   * @param patientId Unique identifier of patient
   * @return OK
   */
  getDrawingTemplates(practiceId: string, patientId: string): Observable<PatientDocumentVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}/drawingtemplates';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDrawingTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDrawingTemplates(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDrawingTemplates(response: HttpResponseBase): Observable<PatientDocumentVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo[]>(<any>null);
  }

  /**
   * Get patient avatar
   * @param practiceId Unique identifier of practice
   * @param patientId Unique identifier of patient
   * @return OK
   */
  getPatientDocumentAvatar(practiceId: string, patientId: string): Observable<PatientDocumentVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}/avatar';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocumentAvatar(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocumentAvatar(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocumentAvatar(response: HttpResponseBase): Observable<PatientDocumentVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo>(<any>null);
  }

  /**
   * Get last uploaded patient document by category (single instance), specifically for documents per provider/practice level
   * @param practiceId Unique identifier of practice
   * @param patientId Unique identifier of patient
   * @return OK
   */
  getPatientDocumentByCategory(practiceId: string, patientId: string, category: string): Observable<PatientDocumentVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}/category/{category}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    if (category === undefined || category === null) throw new Error("The parameter 'category' must be defined.");
    url_ = url_.replace('{category}', encodeURIComponent('' + category));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocumentByCategory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocumentByCategory(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocumentByCategory(response: HttpResponseBase): Observable<PatientDocumentVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo>(<any>null);
  }

  /**
   * Get patient document info
   * @param practiceid Unique identifier of practice
   * @param documentId Unique identifier of file
   * @return OK
   */
  getPatientDocument(practiceid: string, documentId: string): Observable<PatientDocumentVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patientdocument/byId/{documentId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocument(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocument(response: HttpResponseBase): Observable<PatientDocumentVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo>(<any>null);
  }

  /**
   * Get patient document history
   * @param practiceid Unique identifier of practice
   * @param documentId Unique identifier of file
   * @return OK
   */
  getPatientDocumentHistory(practiceid: string, documentId: string): Observable<PatientDocumentHistoryVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/clinical/patientdocument/{documentId}/history';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (documentId === undefined || documentId === null) throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPatientDocumentHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPatientDocumentHistory(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentHistoryVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentHistoryVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPatientDocumentHistory(response: HttpResponseBase): Observable<PatientDocumentHistoryVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentHistoryVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentHistoryVo>(<any>null);
  }

  /**
   * Get doctor documents history
   * @param practiceId Unique identifier of practice
   * @param filter filter
   * @return OK
   */
  getClinicalDocuments(practiceId: string, filter: string): Observable<PatientDocumentVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientdocument?';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (filter === undefined || filter === null) throw new Error("The parameter 'filter' must be defined and cannot be null.");
    else url_ += 'filter=' + encodeURIComponent('' + filter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClinicalDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClinicalDocuments(<any>response_);
            } catch (e) {
              return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientDocumentVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClinicalDocuments(response: HttpResponseBase): Observable<PatientDocumentVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientDocumentVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientDocumentVo[]>(<any>null);
  }

  /**
   * Archive all my patient documents for specified patient
   * @param practiceId practice id
   * @param patientId patient id
   * @return OK
   */
  downloadPatientDocuments(practiceId: string, patientId: string): Observable<string> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocument/{patientId}/archive';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadPatientDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadPatientDocuments(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownloadPatientDocuments(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Archive all patient documents within practice
   * @param practiceId doctor id
   * @return OK
   */
  downloadAllPracticeDocuments(practiceId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/clinical/patientdocuments/archive';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadAllPracticeDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadAllPracticeDocuments(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownloadAllPracticeDocuments(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PatientDocumentResourceClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * @return OK
   */
  getDocument(url: string, practiceId: string): Observable<any> {
    let url_ = this.baseUrl + '/api/v1/document?';
    if (url === undefined || url === null) throw new Error("The parameter 'url' must be defined and cannot be null.");
    else url_ += 'url=' + encodeURIComponent('' + url) + '&';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined and cannot be null.");
    else url_ += 'practiceId=' + encodeURIComponent('' + practiceId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDocument(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>_observableThrow(e));
            }
          } else return <Observable<any>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetDocument(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<any>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PatientEventClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get all patient events in the practice
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getAll(practiceid: string): Observable<PatientEventsByDateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<PatientEventsByDateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventsByDateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PatientEventsByDateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventsByDateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventsByDateVo[]>(<any>null);
  }

  /**
   * Get all patient events in the practice based on filter
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  get(practiceid: string, filter: PatientEventFilterVo): Observable<PatientEventsByDateVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<PatientEventsByDateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventsByDateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<PatientEventsByDateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventsByDateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventsByDateVo[]>(<any>null);
  }

  /**
   * Get a specific patient event in the practice
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  get2(practiceid: string, patienteventid: string): Observable<PatientEventVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/{patienteventid}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patienteventid === undefined || patienteventid === null) throw new Error("The parameter 'patienteventid' must be defined.");
    url_ = url_.replace('{patienteventid}', encodeURIComponent('' + patienteventid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet2(<any>response_);
            } catch (e) {
              return <Observable<PatientEventVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet2(response: HttpResponseBase): Observable<PatientEventVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventVo>(<any>null);
  }

  /**
   * Get All Medical Insurers in the system
   * @return OK
   */
  getAllMedicalInsurer(practiceId: string): Observable<MedicalInsurerVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/medicalinsurer';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllMedicalInsurer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllMedicalInsurer(<any>response_);
            } catch (e) {
              return <Observable<MedicalInsurerVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<MedicalInsurerVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllMedicalInsurer(response: HttpResponseBase): Observable<MedicalInsurerVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <MedicalInsurerVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MedicalInsurerVo[]>(<any>null);
  }

  /**
   * Used to do update medical insurer
   * @return OK
   */
  medicalUpdate(medicalInsurer: UpdateMedicalInsurer, practiceId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/medicalinsurer';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(medicalInsurer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedicalUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedicalUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMedicalUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Get a specific patient event in the practice by patient id
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getByPatient(practiceid: string, patientId: string): Observable<PatientEventVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/bypatient/{patientId}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByPatient(<any>response_);
            } catch (e) {
              return <Observable<PatientEventVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetByPatient(response: HttpResponseBase): Observable<PatientEventVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventVo>(<any>null);
  }

  /**
   * Get a specific patient event in the practice by xref
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getByXref(practiceid: string, patientEventXref: string): Observable<PatientEventVo> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/xref/{patientEventXref}';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    if (patientEventXref === undefined || patientEventXref === null) throw new Error("The parameter 'patientEventXref' must be defined.");
    url_ = url_.replace('{patientEventXref}', encodeURIComponent('' + patientEventXref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByXref(<any>response_);
            } catch (e) {
              return <Observable<PatientEventVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetByXref(response: HttpResponseBase): Observable<PatientEventVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventVo>(<any>null);
  }

  /**
   * Used to do add of medical insurer
   * @return OK
   */
  bulkUpdate(insurers: MedicalInsurerVo[], practiceId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/medicalinsurer/bulkupdate';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(insurers);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkUpdate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBulkUpdate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * Used to do deactivate of medical insurer
   * @return OK
   */
  deactivate(deactivateMedicalInsurer: DeactivateMedicalInsurer, practiceId: string): Observable<RestApiResultOfBoolean> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/medicalinsurer/deactivate';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deactivateMedicalInsurer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivate(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfBoolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactivate(response: HttpResponseBase): Observable<RestApiResultOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfBoolean>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfBoolean>(<any>null);
  }

  /**
   * check in patient visit to add patient to the waiting room
   * @param checkInPatientVisit public domain-model = CheckInPatientVisit
   * @return OK
   */
  checkinPatient(practiceid: string, checkInPatientVisit: CheckInPatientVisit): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/checkinpatientvisit';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(checkInPatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckinPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckinPatient(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckinPatient(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
   * @return OK
   */
  markInProgress(
    practiceId: string,
    visitId: string,
    request: MarkPatientVisitInProgress
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/patientevents/{visitId}/inprogress';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (visitId === undefined || visitId === null) throw new Error("The parameter 'visitId' must be defined.");
    url_ = url_.replace('{visitId}', encodeURIComponent('' + visitId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMarkInProgress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMarkInProgress(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfCheckinPatientVisitResult>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfCheckinPatientVisitResult>;
        })
      );
  }

  protected processMarkInProgress(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfCheckinPatientVisitResult);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(null as any);
  }
  /**
   * Update patient visit
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  updatePatientEvent(practiceid: string, updatePatientVisit: UpdatePatientVisit): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/updatevisit';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updatePatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientEvent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientEvent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RestApiResultOfGuid>;
            }
          } else return _observableThrow(response_) as any as Observable<RestApiResultOfGuid>;
        })
      );
  }

  protected processUpdatePatientEvent(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RestApiResultOfGuid);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(null as any);
  }
  /**
   * Cancel patient visit
   * @param practiceid Practice Id, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  cancelPatientVisit(practiceid: string, cancelPatientVisit: CancelPatientVisit): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/cancelpatientvisit';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cancelPatientVisit);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelPatientVisit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelPatientVisit(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCancelPatientVisit(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
     * Import patient to the local database and automatically
    add it to the waiting room
     * @param practiceid practice id
     * @param patientCommand patient details
     * @return OK
     */
  addPatientToWaitingRoomFromNationalSearch(
    practiceid: string,
    patientCommand: CreatePatient
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/patientevents/importpatientandcheckin';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(patientCommand);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddPatientToWaitingRoomFromNationalSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddPatientToWaitingRoomFromNationalSearch(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddPatientToWaitingRoomFromNationalSearch(
    response: HttpResponseBase
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PowerBIClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Try get report by id from available parctice reports.
   * @param practiceId provider id in mps system
   * @param reportId report id
   * @return OK
   */
  getReport(practiceId: string, reportId: string): Observable<PowerBIReport> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/powerbi/reports/{reportId}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (reportId === undefined || reportId === null) throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReport(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReport(response: HttpResponseBase): Observable<PowerBIReport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport>(<any>null);
  }

  /**
   * Try get report by id from available parctice reports.
   * @param practiceXRef provider xref in myps system
   * @param reportId report id
   * @return OK
   */
  getReportByXref(practiceXRef: string, reportId: string): Observable<PowerBIReport> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/powerbi/reports/{reportId}';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    if (reportId === undefined || reportId === null) throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportByXref(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReportByXref(response: HttpResponseBase): Observable<PowerBIReport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport>(<any>null);
  }

  /**
   * Generate a list of reports available.  This is useful for matching up between report names and Ids
   * @param practiceId provider id in mps system
   * @return OK
   */
  getReportList(practiceId: string): Observable<PowerBIReport[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/powerbi/reports';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportList(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReportList(response: HttpResponseBase): Observable<PowerBIReport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport[]>(<any>null);
  }

  /**
   * Generate a list of reports available.  This is useful for matching up between report names and Ids
   * @param practiceXRef provider xref in myps system
   * @return OK
   */
  getReportListByXref(practiceXRef: string): Observable<PowerBIReport[]> {
    let url_ = this.baseUrl + '/api/v1/xref/{practiceXRef}/powerbi/reports';
    if (practiceXRef === undefined || practiceXRef === null) throw new Error("The parameter 'practiceXRef' must be defined.");
    url_ = url_.replace('{practiceXRef}', encodeURIComponent('' + practiceXRef));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportListByXref(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportListByXref(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReportListByXref(response: HttpResponseBase): Observable<PowerBIReport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport[]>(<any>null);
  }

  /**
   * Get a list of reports within specific PowerBI Workspace
   * @param groupId powerbi groupId
   * @return OK
   */
  getReportListByGroup(groupId: string): Observable<PowerBIReport[]> {
    let url_ = this.baseUrl + '/api/v1/group/{groupId}/powerbi/reports';
    if (groupId === undefined || groupId === null) throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace('{groupId}', encodeURIComponent('' + groupId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportListByGroup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportListByGroup(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReportListByGroup(response: HttpResponseBase): Observable<PowerBIReport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport[]>(<any>null);
  }

  /**
   * Get report by id within specific workspace and generated accessToken for provided practiceNo
   * @param reportId powerbi reportId
   * @param practiceNo practiceNo
   * @return OK
   */
  getReportByIdGroup(groupId: string, reportId: string, practiceNo: string): Observable<PowerBIReport> {
    let url_ = this.baseUrl + '/api/v1/group/{groupId}/powerbi/reports/{reportId}?';
    if (groupId === undefined || groupId === null) throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace('{groupId}', encodeURIComponent('' + groupId));
    if (reportId === undefined || reportId === null) throw new Error("The parameter 'reportId' must be defined.");
    url_ = url_.replace('{reportId}', encodeURIComponent('' + reportId));
    if (practiceNo === undefined || practiceNo === null) throw new Error("The parameter 'practiceNo' must be defined and cannot be null.");
    else url_ += 'practiceNo=' + encodeURIComponent('' + practiceNo) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportByIdGroup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportByIdGroup(<any>response_);
            } catch (e) {
              return <Observable<PowerBIReport>>(<any>_observableThrow(e));
            }
          } else return <Observable<PowerBIReport>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReportByIdGroup(response: HttpResponseBase): Observable<PowerBIReport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PowerBIReport>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PowerBIReport>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ReminderClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get reminders for provider
   * @return OK
   */
  getReminders(providerId: string): Observable<ReminderVo[]> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/reminders';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReminders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReminders(<any>response_);
            } catch (e) {
              return <Observable<ReminderVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ReminderVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReminders(response: HttpResponseBase): Observable<ReminderVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <ReminderVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ReminderVo[]>(<any>null);
  }

  /**
   * Update/Create reminder
   * @return OK
   */
  updateReminder(providerId: string, reminderId: string, reminder: ReminderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/reminders/{reminderId}/update';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (reminderId === undefined || reminderId === null) throw new Error("The parameter 'reminderId' must be defined.");
    url_ = url_.replace('{reminderId}', encodeURIComponent('' + reminderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(reminder);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateReminder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateReminder(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateReminder(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Complete reminder
   * @return OK
   */
  completeReminder(providerId: string, reminderId: string, reminder: ReminderVo): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/reminders/{reminderId}/complete';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (reminderId === undefined || reminderId === null) throw new Error("The parameter 'reminderId' must be defined.");
    url_ = url_.replace('{reminderId}', encodeURIComponent('' + reminderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(reminder);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCompleteReminder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCompleteReminder(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCompleteReminder(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Delete reminder
   * @return OK
   */
  deleteReminder(providerId: string, reminderId: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/{providerId}/infrastructure/reminders/{reminderId}/delete';
    if (providerId === undefined || providerId === null) throw new Error("The parameter 'providerId' must be defined.");
    url_ = url_.replace('{providerId}', encodeURIComponent('' + providerId));
    if (reminderId === undefined || reminderId === null) throw new Error("The parameter 'reminderId' must be defined.");
    url_ = url_.replace('{reminderId}', encodeURIComponent('' + reminderId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteReminder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteReminder(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteReminder(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TenantClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get tenant list
   * @return OK
   */
  getTenantList(): Observable<TenantVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenantList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenantList(<any>response_);
            } catch (e) {
              return <Observable<TenantVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TenantVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTenantList(response: HttpResponseBase): Observable<TenantVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TenantVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TenantVo[]>(<any>null);
  }

  /**
   * Creates new Tenant
   * @param createTenant Create tenant object
   * @return OK
   */
  post(createTenant: UpdateTenant): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createTenant);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPost(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPost(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get tenant by id
   * @param tenantid Unique identifier of tenant
   * @return OK
   */
  getTenant(tenantid: string): Observable<TenantVo> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant/{tenantid}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenant(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenant(<any>response_);
            } catch (e) {
              return <Observable<TenantVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<TenantVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTenant(response: HttpResponseBase): Observable<TenantVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TenantVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TenantVo>(<any>null);
  }

  /**
   * Updates existing tenant
   * @param tenantid Unique identifier of tenant
   * @param updateTenant Update tenant command
   * @return OK
   */
  post2(tenantid: string, updateTenant: UpdateTenant): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant/{tenantid}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateTenant);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPost2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPost2(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPost2(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Updates existing tenant
   * @param tenantid Unique identifier of tenant
   * @param updateTenant Update tenant command
   * @return OK
   */
  post3(tenantid: string, updateTenant: UpdateTenant): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant/{tenantid}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateTenant);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPost3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPost3(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPost3(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Removes tenant
   * @param tenantid Unique identifier of tenant
   * @return OK
   */
  removeTenant(tenantid: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant/{tenantid}';
    if (tenantid === undefined || tenantid === null) throw new Error("The parameter 'tenantid' must be defined.");
    url_ = url_.replace('{tenantid}', encodeURIComponent('' + tenantid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveTenant(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveTenant(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRemoveTenant(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get tenant by xRef
   * @param xref Unique identifier of tenant in external system
   * @return OK
   */
  getTenant2(xref: string): Observable<TenantVo> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/tenant/xref/{xref}';
    if (xref === undefined || xref === null) throw new Error("The parameter 'xref' must be defined.");
    url_ = url_.replace('{xref}', encodeURIComponent('' + xref));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenant2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenant2(<any>response_);
            } catch (e) {
              return <Observable<TenantVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<TenantVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTenant2(response: HttpResponseBase): Observable<TenantVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TenantVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TenantVo>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TimerClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get timers list
   * @return OK
   */
  getAllRequests(): Observable<TimerVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/timer';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllRequests(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllRequests(<any>response_);
            } catch (e) {
              return <Observable<TimerVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TimerVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllRequests(response: HttpResponseBase): Observable<TimerVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TimerVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TimerVo[]>(<any>null);
  }

  /**
   * Sets timer
   * @param setTimer Command setTimer
   * @return OK
   */
  setTimer(setTimer: SetTimer): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/timer';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(setTimer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetTimer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetTimer(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetTimer(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }

  /**
   * Get timers list based on followup date range
   * @return OK
   */
  getRequestsByDate(from: Date, to: Date): Observable<TimerByDateVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/timer/fromdate/{from}/todate/{to}';
    if (from === undefined || from === null) throw new Error("The parameter 'from' must be defined.");
    url_ = url_.replace('{from}', encodeURIComponent(from ? '' + from.toJSON() : 'null'));
    if (to === undefined || to === null) throw new Error("The parameter 'to' must be defined.");
    url_ = url_.replace('{to}', encodeURIComponent(to ? '' + to.toJSON() : 'null'));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRequestsByDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRequestsByDate(<any>response_);
            } catch (e) {
              return <Observable<TimerByDateVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TimerByDateVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRequestsByDate(response: HttpResponseBase): Observable<TimerByDateVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TimerByDateVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TimerByDateVo[]>(<any>null);
  }

  /**
   * Get timers list for node
   * @param nodeid Integer identifier of node
   * @return OK
   */
  getRequestsForNode(nodeid: number): Observable<TimerVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/timer/{nodeid}';
    if (nodeid === undefined || nodeid === null) throw new Error("The parameter 'nodeid' must be defined.");
    url_ = url_.replace('{nodeid}', encodeURIComponent('' + nodeid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRequestsForNode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRequestsForNode(<any>response_);
            } catch (e) {
              return <Observable<TimerVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TimerVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetRequestsForNode(response: HttpResponseBase): Observable<TimerVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TimerVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TimerVo[]>(<any>null);
  }

  /**
   * Cancels timer
   * @param timerid Unic identifier of timer
   * @return OK
   */
  cancelTimer(timerid: string): Observable<RestApiResultOfGuid> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/timer/{timerid}';
    if (timerid === undefined || timerid === null) throw new Error("The parameter 'timerid' must be defined.");
    url_ = url_.replace('{timerid}', encodeURIComponent('' + timerid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancelTimer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancelTimer(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfGuid>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCancelTimer(response: HttpResponseBase): Observable<RestApiResultOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfGuid>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfGuid>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TokenProvidersClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get access token for specific provider (by provider name - signalr, practice_signalr, etc)
   * @return OK
   */
  getTokenByType(practiceId: string, type: string): Observable<TokenProviderVo> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/{practiceId}/tokenproviders/{type}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.");
    url_ = url_.replace('{type}', encodeURIComponent('' + type));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTokenByType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTokenByType(<any>response_);
            } catch (e) {
              return <Observable<TokenProviderVo>>(<any>_observableThrow(e));
            }
          } else return <Observable<TokenProviderVo>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTokenByType(response: HttpResponseBase): Observable<TokenProviderVo> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TokenProviderVo>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TokenProviderVo>(<any>null);
  }

  /**
   * Get bridgeIT access token for specific provider
   * @return OK
   */
  getTokenForBridgeit(practiceId: string, issuer: string): Observable<string> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/{practiceId}/tokenforbridgeit/{issuer}';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (issuer === undefined || issuer === null) throw new Error("The parameter 'issuer' must be defined.");
    url_ = url_.replace('{issuer}', encodeURIComponent('' + issuer));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTokenForBridgeit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTokenForBridgeit(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetTokenForBridgeit(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * Get all access tokens for different providers
   * @return OK
   */
  getAllTokens(practiceId: string): Observable<TokenProviderVo[]> {
    let url_ = this.baseUrl + '/api/v1/infrastructure/{practiceId}/tokenproviders';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllTokens(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllTokens(<any>response_);
            } catch (e) {
              return <Observable<TokenProviderVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<TokenProviderVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllTokens(response: HttpResponseBase): Observable<TokenProviderVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <TokenProviderVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TokenProviderVo[]>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class WaitingRoomClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://172.30.3.210/tablet/mps-api';
  }

  /**
   * Get list of patient visits in waiting room
   * @param practiceid Practice ID, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  get(practiceid: string): Observable<PatientEventVo[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/waitingroom';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<PatientEventVo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientEventVo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<PatientEventVo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientEventVo[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientEventVo[]>(<any>null);
  }

  /**
   * Get list of patient visits in waiting room with summary
   * @param practiceid Practice ID, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getWaitingRoom(practiceid: string): Observable<PatientInWaitingRoom[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/waitingroom/summary';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWaitingRoom(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWaitingRoom(<any>response_);
            } catch (e) {
              return <Observable<PatientInWaitingRoom[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientInWaitingRoom[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetWaitingRoom(response: HttpResponseBase): Observable<PatientInWaitingRoom[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientInWaitingRoom[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientInWaitingRoom[]>(<any>null);
  }

  /**
   * Get list of patient visits waiting room with summary for all providers within a practice
   * @param practiceid Practice ID, default value 00000000-0000-0000-0000-000000000000
   * @return OK
   */
  getWaitingRoomsForPractice(practiceid: string): Observable<PatientInWaitingRoom[]> {
    let url_ = this.baseUrl + '/api/v1/{practiceid}/patientevent/waitingroom/summaryforpractice';
    if (practiceid === undefined || practiceid === null) throw new Error("The parameter 'practiceid' must be defined.");
    url_ = url_.replace('{practiceid}', encodeURIComponent('' + practiceid));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWaitingRoomsForPractice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWaitingRoomsForPractice(<any>response_);
            } catch (e) {
              return <Observable<PatientInWaitingRoom[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PatientInWaitingRoom[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetWaitingRoomsForPractice(response: HttpResponseBase): Observable<PatientInWaitingRoom[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <PatientInWaitingRoom[]>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PatientInWaitingRoom[]>(<any>null);
  }

  /**
     * Initiate capturing encounter workflow (checkin visit if not created, mark as in progress
    and then encounter will be created)
     * @param practiceId practice unique identifier
     * @param patientId patient unique identifier
     * @return OK
     */
  startCapturingEncounter(
    practiceId: string,
    patientId: string,
    request: CaptureEncounterRequest
  ): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/waitingroom/{patientId}/capture';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStartCapturingEncounter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStartCapturingEncounter(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processStartCapturingEncounter(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
     * Use to checkin provided patient to waiting room, if patient already checked in do nothing and just
    return patientVisitId
     * @param practiceId practice unique identifier
     * @param patientId patient unique identifier
     * @return OK
     */
  addPatientToWaitingRoom(practiceId: string, patientId: string): Observable<RestApiResultOfCheckinPatientVisitResult> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/waitingroom/{patientId}/checkin';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddPatientToWaitingRoom(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddPatientToWaitingRoom(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfCheckinPatientVisitResult>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddPatientToWaitingRoom(response: HttpResponseBase): Observable<RestApiResultOfCheckinPatientVisitResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : <RestApiResultOfCheckinPatientVisitResult>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfCheckinPatientVisitResult>(<any>null);
  }

  /**
   * Use to clear whole waiting room at once
   * @param practiceId practice unique identifier
   * @return OK
   */
  clearWaitingRoom(practiceId: string): Observable<RestApiResultOfString> {
    let url_ = this.baseUrl + '/api/v1/{practiceId}/patientevent/waitingroom/clear';
    if (practiceId === undefined || practiceId === null) throw new Error("The parameter 'practiceId' must be defined.");
    url_ = url_.replace('{practiceId}', encodeURIComponent('' + practiceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearWaitingRoom(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearWaitingRoom(<any>response_);
            } catch (e) {
              return <Observable<RestApiResultOfString>>(<any>_observableThrow(e));
            }
          } else return <Observable<RestApiResultOfString>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processClearWaitingRoom(response: HttpResponseBase): Observable<RestApiResultOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          result200 = _responseText === '' ? null : <RestApiResultOfString>JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RestApiResultOfString>(<any>null);
  }
}

export interface UserVo {
  UserId?: string | null;
  Username?: string | null;
  Password?: string | null;
  PasswordHash?: string | null;
  FullName?: string | null;
  LockedUntil?: Date | null;
  ExpirationTime?: Date | null;
  Claims?: ClaimVo[] | null;
  RequirePasswordChange?: boolean | null;
}

export interface ClaimVo {
  ClaimType?: string | null;
  ClaimValue?: string | null;
  ClaimScope?: string | null;
}

export interface RestApiResultOfGuid {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: string | null;
  Links?: RestApiLink[] | null;
}

export interface RestApiLink {
  Rel?: string | null;
  HRef?: string | null;
}

export interface ChangeUserPassword {
  UserId?: string | null;
  OldPassword?: string | null;
  NewPassword?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface EventVo {
  EventDetails?: Event | null;
  CreatedAt?: Date | null;
  Type?: string | null;
}

export interface Event {
  EventId?: number | null;
  Version?: number | null;
  AggregateId?: string | null;
  NodeId?: number | null;
  InstanceId?: number | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
  BucketPrefix?: string | null;
}

export interface ExternalMessageSyncVo {
  ExternalSystemCreatedDateTime?: Date | null;
  SyncDelayInSeconds?: number | null;
  SyncDelayInMinutes?: number | null;
  EventDetails?: Event | null;
  CreatedAt?: Date | null;
  Type?: string | null;
}

export interface InvoiceVo {
  InvoiceId?: string | null;
  EncounterId?: string | null;
  BranchXRef?: string | null;
  PracticeId?: string | null;
  InvoiceType?: string | null;
  Provider?: ProviderVo | null;
  ReferringDoctorName?: string | null;
  ReferringDoctorPracticeNumber?: string | null;
  AssistingDoctorName?: string | null;
  AssistingDoctorPracticeNumber?: string | null;
  PatientEventDetails?: PatientEventVo | null;
  InvoiceLineItems?: InvoiceLineItemsVo | null;
  MedicalInsurance?: MedicalInsuranceVo | null;
  RequiresFollowUp?: boolean | null;
  Note?: string | null;
  PatientDocuments?: LinkedPatientDocument[] | null;
}

export interface ProviderVo {
  PracticeType?: string | null;
  PracticeName?: string | null;
  SpecialityCode?: string | null;
  SubSpecialityCode?: string | null;
  PracticeNumber?: string | null;
  TreatingDoctorName?: string | null;
  TreatingDoctorPracticeNumber?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicenseNumber?: string | null;
  HPCSANumber?: string | null;
}

export interface PatientEventVo {
  PatientEventId?: string | null;
  PatientEventXRef?: string | null;
  BranchXRef?: string | null;
  BranchName?: string | null;
  PracticeId?: string | null;
  Patient?: PatientVo | null;
  ScheduledTime?: Date | null;
  CheckInTime?: Date | null;
  /** 0 = Scheduled, 1 = CheckedIn, 2 = InProgress, 3 = Completed, 4 = Canceled, 5 = Deleted */
  Status?: PatientEventVoStatus | null;
  Type?: string | null;
  MedicalInsurance?: MedicalInsuranceVo | null;
  CompletedTime?: Date | null;
  Completed?: boolean | null;
  Cancelled?: boolean | null;
  CheckedIn?: boolean | null;
  BenefitCheckStatus?: string | null;
  VideoChatLink?: string | null;
  BenefitCheckPdfLink?: string | null;
  AccountBalance?: string | null;
  ProviderNote?: string | null;
  QuoteXRef?: string | null;
  IsClinicalVisit?: boolean | null; // please note extended locally to support nova integration, not part of backend model
  IsCashAccount?: boolean | null; // please note extended locally to support nova integration, not part of backend model
}

export interface InvoiceLineItemsVo {
  InvoiceHeader?: InvoiceHeaderVo | null;
  LineItems?: InvoiceLineItemVo[] | null;
}

export interface MedicalInsuranceVo {
  MedicalInsurer?: MedicalInsurerVo | null;
  Broker?: string | null;
  PolicyNo?: string | null;
  PatientIdentityNo?: string | null;
}

export interface LinkedPatientDocument {
  DocumentUrl?: string | null;
  Category?: string | null;
}

export interface PatientVo {
  PatientId?: string | null;
  PatientXRef?: string | null;
  PracticeId?: string | null;
  FileNo?: string | null;
  KnownAs?: string | null;
  Occupation?: string | null;
  Employer?: string | null;
  PreferredLanguage?: string | null;
  MaritalStatus?: string | null;
  PatientDetails?: PersonVo | null;
  PatientAccountDetails?: AccountDetailsVo | null;
  PhysicalAddress?: AddressVo | null;
  PostalAddress?: AddressVo | null;
  Deceased?: boolean | null;
}

export interface InvoiceHeaderVo {
  ClaimAuthorizationNumber?: string | null;
  AdmissionDateTime?: Date | null;
  DischargeDateTime?: Date | null;
  HospitalIndicator?: boolean | null;
  ClaimType?: string | null;
  TariffCode?: string | null;
  Diagnosis?: DiagnosisVo[] | null;
  DateOfService?: Date | null;
  /** 0 = Uknown, 2 = Telehealth, 11 = ConsultingRooms, 21 = InPatientHospital, 24 = DayClinic, 12 = Home */
  PlaceOfService?: InvoiceHeaderVoPlaceOfService | null;
  Ward?: string | null;
}

export interface InvoiceLineItemVo {
  DateOfService?: Date | null;
  LineNum?: number | null;
  LineType?: string | null;
  ChargeCode?: string | null;
  ChargeDesc?: string | null;
  NappiCode?: string | null;
  ChargeUnits?: string | null;
  DosageUnit?: number | null;
  DosageType?: string | null;
  FrequencyUnit?: number | null;
  FrequencyType?: string | null;
  PeriodUnit?: number | null;
  PeriodType?: string | null;
  DurationUnit?: number | null;
  DurationType?: string | null;
  Repeat?: number | null;
  ChronicIndicator?: boolean | null;
  ChargeQuan?: number | null;
  TotalExcVat?: number | null;
  VatAmount?: number | null;
  TotalIncVat?: number | null;
  UnitPrice?: number | null;
  PriceOverride?: boolean | null;
  SchemeRule?: string | null;
  Amount?: number | null;
  Parameters?: { [key: string]: string } | null;
  Responses?: { [key: string]: string } | null;
  ChargeStart?: Date | null;
  ChargeEnd?: Date | null;
  Diagnosis?: DiagnosisVo[] | null;
}

export interface MedicalInsurerVo {
  Id?: string | null;
  InsurerXRef?: string | null;
  Name?: string | null;
  AccountNo?: string | null;
  Email?: string | null;
  Phone1?: string | null;
  Phone2?: string | null;
  AddressLine1?: string | null;
  AddressLine2?: string | null;
  AddressLine3?: string | null;
  PostalCode?: string | null;
}

export interface PersonVo {
  Title?: string | null;
  FirstName?: string | null;
  Surname?: string | null;
  DateOfBirth?: Date | null;
  IdentityNo?: string | null;
  PassportNo?: string | null; //updated only on frontend, not represented on florence
  Country?: string | null; //updated only on frontend, not represented on florence
  Gender?: string | null;
  ContactNo?: string | null;
  EmailAddress?: string | null;
}

export interface AccountDetailsVo {
  AccountId?: string | null;
  MainMemberXRef?: string | null;
  AccountNo?: string | null;
  IsCashAccount?: boolean | null;
  MedicalAidName?: string | null;
  MedicalAidPlan?: string | null;
  MedicalAidPlanOption?: string | null;
  MedicalAidMembershipNumber?: string | null;
  MedicalAidDependentCode?: string | null;
  MedicalAidMainMemberDetails?: PersonVo | null;
  MedicalAidRoutingCode?: string | null;
  MedicalAidOptionCode?: string | null;
  MedicalAidSchemeCode?: string | null;
  MedicalAidPlanCode?: string | null;
}

export interface AddressVo {
  Line1?: string | null;
  Line2?: string | null;
  Line3?: string | null;
  Code?: string | null;
}

export interface DiagnosisVo {
  Id?: string | null;
  DiagnosisCode?: string | null;
  DiagnosisDescription?: string | null;
  SpecificCode?: boolean | null;
  PrimaryIndicator?: boolean | null;
  ValidPrimary?: boolean | null;
  ValidSequelae?: boolean | null;
  MaxSpecificity?: boolean | null;
  Gender?: string | null;
  AgeRangeStart?: number | null;
  AgeRangeEnd?: number | null;
}

export interface SpecialityRuleVo {
  Id?: string | null;
  SpecialityCode?: string | null;
  Speciality?: string | null;
  DefaultProcedureCode?: string | null;
  ConsumableProcedureCode?: string | null;
  PrefixChargeCodesOnClaim?: boolean | null;
  AvailableWards?: string[] | null;
  MutuallyExclusiveCodes?: string[][] | null;
  Options?: { [key: string]: string } | null;
}

export interface PatientConfigurationVo {
  PracticeId?: string | null;
  PatientId?: string | null;
  CapturedDate?: Date | null;
  Configuration?: { [key: string]: string } | null;
}

export interface InvoiceWithStatusVo {
  InvoiceLineItemsWithStatusVo?: InvoiceLineItemsWithStatusVo | null;
  ClaimId?: string | null;
  /** 0 = Created, 1 = Updated, 2 = Submitted, 3 = Priced, 4 = Finalized, 5 = ClaimSent, 6 = ClaimRejected, 7 = ResponseReceived, 8 = DeferredForManualProcessing, 9 = Cancelled, 10 = InvoiceForwardedToExternalSystem, 11 = ClaimReversalSent, 12 = InvoiceSendingFailed, 13 = InvoiceSendingManuallyAborted, 14 = InvoiceSuccessfullySent */
  Status?: InvoiceWithStatusVoStatus | null;
  UnprocessedEvents?: Event[] | null;
  InvoiceSubmittedDateTime?: Date | null;
  InvoiceFinalisedDateTime?: Date | null;
  InvoiceSentForManualInterventionDateTime?: Date | null;
  ClaimSentDateTime?: Date | null;
  FirstClaimResponseReceivedDateTime?: Date | null;
  LastClaimResponseReceivedDateTime?: Date | null;
  ClaimRejectedDateTime?: Date | null;
  ReasonForManualIntervention?: string | null;
  ReasonForClaimRejection?: string | null;
  System?: string | null;
  SendingAttempts?: number | null;
  InvoiceId?: string | null;
  EncounterId?: string | null;
  BranchXRef?: string | null;
  PracticeId?: string | null;
  InvoiceType?: string | null;
  Provider?: ProviderVo | null;
  ReferringDoctorName?: string | null;
  ReferringDoctorPracticeNumber?: string | null;
  AssistingDoctorName?: string | null;
  AssistingDoctorPracticeNumber?: string | null;
  PatientEventDetails?: PatientEventVo | null;
  InvoiceLineItems?: InvoiceLineItemsVo | null;
  MedicalInsurance?: MedicalInsuranceVo | null;
  RequiresFollowUp?: boolean | null;
  Note?: string | null;
  PatientDocuments?: LinkedPatientDocument[] | null;
}

export interface InvoiceLineItemsWithStatusVo {
  LineItemWithStatusVos?: InvoiceLineItemWithStatusVo[] | null;
  InvoiceNumber?: string | null;
  TotalBilledAmount?: number | null;
  PatientLiable?: number | null;
  MaPayableAmount?: number | null;
  ClaimResponse?: ClaimResponse | null;
  InvoiceHeader?: InvoiceHeaderVo | null;
  LineItems?: InvoiceLineItemVo[] | null;
}

export interface InvoiceLineItemWithStatusVo {
  MedicalAidPayableAmount?: number | null;
  PatientLiableAmount?: number | null;
  ClaimResponseLineItem?: ClaimResponseLineItem | null;
  DateOfService?: Date | null;
  LineNum?: number | null;
  LineType?: string | null;
  ChargeCode?: string | null;
  ChargeDesc?: string | null;
  NappiCode?: string | null;
  ChargeUnits?: string | null;
  DosageUnit?: number | null;
  DosageType?: string | null;
  FrequencyUnit?: number | null;
  FrequencyType?: string | null;
  PeriodUnit?: number | null;
  PeriodType?: string | null;
  DurationUnit?: number | null;
  DurationType?: string | null;
  Repeat?: number | null;
  ChronicIndicator?: boolean | null;
  ChargeQuan?: number | null;
  TotalExcVat?: number | null;
  VatAmount?: number | null;
  TotalIncVat?: number | null;
  UnitPrice?: number | null;
  PriceOverride?: boolean | null;
  SchemeRule?: string | null;
  Amount?: number | null;
  Parameters?: { [key: string]: string } | null;
  Responses?: { [key: string]: string } | null;
  ChargeStart?: Date | null;
  ChargeEnd?: Date | null;
  Diagnosis?: DiagnosisVo[] | null;
}

export interface ClaimResponse {
  Disclaimer?: string | null;
  Transaction?: ClaimResponseTransaction | null;
  Details?: ClaimResponseDetails | null;
}

export interface ClaimResponseLineItem {
  UniqueID?: string | null;
  StatusCode?: number | null;
  StatusDesc?: string | null;
  MALineRefNum?: string | null;
  HBBatchNum?: string | null;
  LineItemFinancials?: ClaimResponseLineItemFinancials | null;
  LineItemInfo?: ClaimResponseLineItemInfo | null;
  Responses?: Response[] | null;
  Editable?: string | null;
  Reversible?: string | null;
  GroupType?: string | null;
  PayWho?: string | null;
}

export interface ClaimResponseTransaction {
  ReferenceNum?: string | null;
  DataSet?: string | null;
  InvoiceNum?: string | null;
}

export interface ClaimResponseDetails {
  GroupItems?: ClaimResponseGroupItem[] | null;
  ClaimFinancials?: ClaimResponseFinancials | null;
  LineItems?: ClaimResponseLineItem[] | null;
  Responses?: Response[] | null;
}

export interface ClaimResponseLineItemFinancials {
  BilledAmt?: number | null;
  MAPayable?: number | null;
  PatPayable?: number | null;
  MAPatReimb?: number | null;
  Overcharge?: number | null;
  Discount?: number | null;
  MedicalAidRate?: number | null;
}

export interface ClaimResponseLineItemInfo {
  ContractAmt?: number | null;
  AboveBenefitAmt?: number | null;
  Levy?: number | null;
  BenOpt?: string | null;
  SavingsSur?: number | null;
  LineItemFees?: ClaimResponseItemFees | null;
  LineItemRef?: ClaimResponseLineItemRef | null;
  DURs?: ClaimResponseDrugUtilization[] | null;
}

export interface Response {
  Code?: number | null;
  Desc?: string | null;
  Type?: string | null;
}

export interface ClaimResponseGroupItem {}

export interface ClaimResponseFinancials {
  TotalClaimedAmt?: number | null;
  TotalPaidMemAmt?: number | null;
  TotalPaidProvAmt?: number | null;
  BalanceOutstanding?: number | null;
}

export interface ClaimResponseItemFees {
  ContainerFeePayable?: number | null;
  DispenseFeePayable?: number | null;
  ServiceFeePayable?: number | null;
  ProfFeePayable?: number | null;
}

export interface ClaimResponseLineItemRef {
  Sur?: number | null;
  Code?: number | null;
  Price?: number | null;
}

export interface ClaimResponseDrugUtilization {
  Details?: string | null;
  Summary?: string | null;
  Type?: string | null;
}

export interface InvoiceTemplateVo {
  TemplateId?: string | null;
  PracticeId?: string | null;
  TemplateType?: string | null;
  Caption?: string | null;
  Description?: string | null;
  SortOrder?: number | null;
  InvoiceLineItemsVo?: InvoiceLineItemsVo | null;
}

export interface InvoiceLineItemsRankingVo {
  Rank?: number | null;
  InvoiceHeader?: InvoiceHeaderVo | null;
  LineItems?: InvoiceLineItemVo[] | null;
}
export interface RequestDiagnosisRanking {
  DiagnosisCode?: string | null;
}
export interface ProviderConfigurationVo {
  PracticeId?: string | null;
  PracticeTenantId?: string | null;
  PracticeXRef?: string | null;
  BranchXRef?: string | null;
  PracticeName?: string | null;
  SpecialityCode?: string | null;
  SubSpecialityCode?: string | null;
  PracticeNumber?: string | null;
  BillingIdentifier?: string | null;
  BillingStatus?: string | null;
  BillingStartDate?: Date | null;
  BillingEndDate?: Date | null;
  TreatingPracticeNumber?: string | null;
  TreatingDoctorName?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicNum?: string | null;
  HPCSANumber?: string | null;
  Qualification?: string | null;
  SpecialityDescription?: string | null;
  TelephoneNumber?: string | null;
  FaxNumber?: string | null;
  CellphoneNumber?: string | null;
  EmailAddress?: string | null;
  PhysicalAddress?: string | null;
  PostalAddress?: string | null;
  ContactNumber?: string | null;
  NetworkedSchemes?: string[] | null;
  ManualPricingSchemes?: string[] | null;
  Options?: { [key: string]: string } | null;
  LastUpdatedDate?: Date | null;
  IsLocumProvider?: boolean | null;
  KnownAs?: string | null;
}

export interface CreateProviderConfiguration {
  ProviderConfiguration?: ProviderConfigurationVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ProviderBranchConfigurationVo {
  PracticeTenantId?: string | null;
  BranchId?: string | null;
  BranchXRef?: string | null;
  BranchName?: string | null;
  PhoneNumber?: string | null;
  PhysicalAddress?: string | null;
  PostalAddress?: string | null;
  IsMainBranch?: boolean | null;
  Enabled?: boolean | null;
  ProviderInfos?: BranchProviderInfoVo[] | null;
}

export interface BranchProviderInfoVo {
  ProviderXRef?: string | null;
  IsDispensing?: boolean | null;
  DispensingLicenseNumber?: string | null;
  IsDefaultBranch?: boolean | null;
}

export interface SupportingProviderVo {
  SupportingProviderXRef?: string | null;
  Type?: string | null;
  TreatingPracticeNumber?: string | null;
  Name?: string | null;
  Surname?: string | null;
  HpcsaNumber?: string | null;
  Title?: string | null;
  FriendlyName?: string | null;
}

export interface ProviderContractVo {
  ContractName?: string | null;
  ContractLevel?: string | null;
  ValidFrom?: Date | null;
  ValidTo?: Date | null;
  ZeroMedicine?: boolean | null;
  ZeroConsumable?: boolean | null;
  OptionCodes?: ProviderContractOptionCodeVo[] | null;
}

export interface ProviderContractOptionCodeVo {
  OptionCode?: string | null;
}

export interface DiagnosisRankingVo {
  Id?: string | null;
  DiagnosisCode?: string | null;
  SpecialityCode?: string | null;
  ClaimsCount?: number | null;
}

export interface SetProviderConfigurationOptions {
  ProviderId?: string | null;
  Options?: { [key: string]: string } | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ChangeProviderConfigurationOption {
  ProviderId?: string | null;
  OptionName?: string | null;
  OptionValue?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdateProviderConfiguration {
  ProviderConfiguration?: ProviderConfigurationVo | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RemoveProviderConfiguration {
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdateProviderConfigurationByExternalSystem {
  PracticeId?: string | null;
  PracticeXRef?: string | null;
  PracticeName?: string | null;
  PracticeNumber?: string | null;
  TreatingDoctorName?: string | null;
  TreatingPracticeNumber?: string | null;
  SpecialityCode?: string | null;
  SubSpecialityCode?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicNum?: string | null;
  HPCSANumber?: string | null;
  ContactNumber?: string | null;
  FaxNumber?: string | null;
  CellphoneNumber?: string | null;
  EmailAddress?: string | null;
  PhysicalAddress?: string | null;
  PostalAddress?: string | null;
  Qualification?: string | null;
  KnownAs?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfString {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: string | null;
  Links?: RestApiLink[] | null;
}

export interface BranchProviderRelatedInfo {
  BranchXRef?: string | null;
  IsDispensing?: boolean | null;
  DispensingLicenseNumber?: string | null;
  IsDefaultBranch?: boolean | null;
}

export interface SubmitInvoice {
  InvoiceVo?: InvoiceVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface InvoiceSendingStatusVo {
  PracticeId?: string | null;
  EncounterId?: string | null;
  InvoiceId?: string | null;
  Reason?: string | null;
  Status?: string | null;
  System?: string | null;
  SendingTime?: Date | null;
  SendingAttempts?: number | null;
  SendingType?: string | null;
}

export interface MoveInvoiceToManualProcessing {
  InvoiceId?: string | null;
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RetryInvoiceProcessing {
  InvoiceId?: string | null;
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfListOfInvoiceSendingStatusVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: InvoiceSendingStatusVo[] | null;
  Links?: RestApiLink[] | null;
}

export interface AbortInvoiceProcessing {
  InvoiceId?: string | null;
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface MergeInvoiceLineItems {
  InvoiceId?: string | null;
  PracticeId?: string | null;
  OriginalInstruction?: InvoiceLineItemsVo | null;
  NewInstruction?: InvoiceTemplateVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfInvoiceLineItemsVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: InvoiceLineItemsVo | null;
  Links?: RestApiLink[] | null;
}

export interface MergeInvoiceHospital {
  OriginalInstruction?: InvoiceLineItemsVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdateDiagnosis {
  DiagnosisVo?: DiagnosisVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfBoolean {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: boolean | null;
  Links?: RestApiLink[] | null;
}

export interface UpdateDiagnosisRanked {
  DiagnosisRankingVo?: DiagnosisRankingVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface DeactivateSpecialityRule {
  SpecialityRuleId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface DeactivateDiagnosis {
  DiagnosisVo?: DiagnosisVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface DeactivateDiagnosisRanked {
  DiagnosisRankingVo?: DiagnosisRankingVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdateProviderConfigurationContracts {
  ProviderId?: string | null;
  ProviderContracts?: ProviderContractVo[] | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface CardPaymentStatus {
  CardPayment?: CardPayment | null;
  /** 0 = Unknown, 1 = PaymentRequested, 2 = PaymentInitiated, 3 = PaymentInProgress, 4 = PaymentFailed, 5 = PaymentFinalised, 6 = PaymentTimeout */
  Status?: CardPaymentStatusStatus | null;
  DiagnosticsData?: { [key: string]: string }[] | null;
}

export interface CardPayment {
  CardPaymentId?: string | null;
  TenantId?: string | null;
  CardPaymentXRef?: string | null;
  CustomerReference?: string | null;
  PaymentDate?: Date | null;
  CardReader?: CardReaderVo | null;
  TransactionDetails?: TransactionDetails | null;
  TransactionResult?: TransactionResult | null;
}

export interface CardReaderVo {
  CardReaderId?: string | null;
  TenantId?: string | null;
  NodeId?: number | null;
  Identifier?: string | null;
  SerialNumber?: string | null;
  Address?: string | null;
  Port?: string | null;
  /** 1 = Bluetooth, 2 = USB, 5 = Simulator */
  ConnectionMethod?: CardReaderVoConnectionMethod | null;
  SharedSecret?: string | null;
  NodeVersion?: string | null;
}

export interface TransactionDetails {
  CustomerTransactionXRef?: string | null;
  Amount?: number | null;
  Currency?: string | null;
  BudgetMonths?: number | null;
}

export interface TransactionResult {
  /** 0 = Undefined, 1 = Authorised, 2 = Declined, 3 = Processed, 4 = Failed, 5 = Cancelled, 6 = Timeout */
  TransactionStatus?: TransactionResultTransactionStatus | null;
  AuthorisationCode?: string | null;
  BudgetNumber?: string | null;
  /** 0 = Undefined, 1 = MSR, 2 = ICC, 3 = CNP */
  CardEntryType?: TransactionResultCardEntryType | null;
  CardNumber?: string | null;
  CardSchemeName?: string | null;
  CardTypeId?: string | null;
  Currency?: string | null;
  CustomerReceipt?: string | null;
  CustomerReference?: string | null;
  EftTimestamp?: Date | null;
  EFtTransactionId?: string | null;
  ErrorMessage?: string | null;
  GratuityAmount?: number | null;
  GratuityPercentage?: number | null;
  MerchantReceipt?: string | null;
  SignatureReceipt?: string | null;
  OriginalEftTransactionId?: string | null;
  RecoveredTransaction?: boolean | null;
  RequestedAmount?: number | null;
  SignatureRequested?: boolean | null;
  StatusMessage?: string | null;
  StatusDate?: Date | null;
  TotalAmount?: number | null;
  TransactionId?: string | null;
  /** 0 = Undefined, 1 = Sale, 2 = SaleVoid, 3 = Refund, 4 = RefundVoid, 5 = SaleCancel, 6 = RefundCancel */
  Type?: TransactionResultType | null;
  /** 0 = Undefined, 1 = Signature, 2 = Pin, 3 = Pin_Signature, 4 = Failed, 5 = Not_Required */
  VerificationMethod?: TransactionResultVerificationMethod | null;
  DeviceLogs?: DeviceLogs | null;
}

export interface DeviceLogs {
  DeviceLogsId?: string | null;
  TenantId?: string | null;
  Device?: CardReaderVo | null;
  LogTimeStamp?: Date | null;
  Logs?: string | null;
}

export interface CardPaymentFilterVo {
  TenantId?: string | null;
  DateFrom?: Date | null;
  DateTo?: Date | null;
  IncludeAllTransactions?: boolean | null;
}

export interface CardPaymentsByDateVo {
  Date?: Date | null;
  CardPayments?: CardPaymentStatus[] | null;
}

export interface ChargeCodeVo {
  Id?: string | null;
  ChargeCode?: string | null;
  Description?: string | null;
  SpecialityCode?: string | null;
  Price?: number | null;
  CodeType?: string | null;
  MedicalAid?: string | null;
  Speciality?: string | null;
  PackSize?: number | null;
  DrugSchedule?: number | null;
  AllowedRecipients?: string[] | null;
}

export interface UpdateChargeCode {
  ChargeCode?: ChargeCodeVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface DeactivateChargeCode {
  ChargeCodeVo?: ChargeCodeVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface Claim {
  Transaction?: ClaimTransaction | null;
  Providers?: Provider[] | null;
  Member?: Member | null;
  Patient?: Patient | null;
  Details?: ClaimDetails | null;
}

export interface ClaimTransaction {
  RoutingCode?: string | null;
  DataSet?: string | null;
  InvoiceNum?: string | null;
  PMAName?: string | null;
  PMAVersion?: string | null;
  MedpraxVersion?: string | null;
  SavedDateTime?: Date | null;
}

export interface Provider {
  Type?: string | null;
  SpecialtyCode?: string | null;
  SubSpecialtyCode?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicNum?: string | null;
  PracticeName?: string | null;
  PracticeNum?: string | null;
  HPCSA?: string | null;
  Demographics?: Demographics | null;
}

export interface Member {
  Name?: string | null;
  Initials?: string | null;
  Surname?: string | null;
  DOB?: Date | null;
  ID?: string | null;
  MANum?: string | null;
  SchemeName?: string | null;
  SchemeReg?: string | null;
  Demographics?: Demographics | null;
  Gender?: string | null;
}

export interface Patient {
  Name?: string | null;
  Initials?: string | null;
  Surname?: string | null;
  DOB?: Date | null;
  ID?: string | null;
  DepCode?: string | null;
  Identifier?: string | null;
  AccNum?: string | null;
  Demographics?: Demographics | null;
  Gender?: string | null;
  NewBornInd?: string | null;
}

export interface ClaimDetails {
  AuthNum?: string | null;
  ReferralNum?: string | null;
  DiagnosisCodes?: ClaimDiagnosisCodes[] | null;
  AdmDateTime?: string | null;
  DisDateTime?: string | null;
  OptomScripts?: ClaimOptomScripts[] | null;
  ClaimFinancials?: ClaimFinancials | null;
  LineItems?: ClaimLineItem[] | null;
  PayWho?: string | null;
  HospInd?: string | null;
  RecInd?: string | null;
}

export interface Demographics {
  PostalAddress?: Address | null;
  PhysicalAddress?: Address | null;
  WkTelephone?: string | null;
  HMTelephone?: string | null;
  Fax?: string | null;
  Cellphone?: string | null;
  Email?: string | null;
}

export interface ClaimDiagnosisCodes {
  Version?: string | null;
  Value?: string | null;
  Description?: string | null;
  Set?: string | null;
}

export interface ClaimOptomScripts {
  Ref?: string | null;
  /** 0 = Spectacle, 1 = ContactLens, 2 = NotSpecified */
  Type?: ClaimOptomScriptsType | null;
  PowerSpher?: string | null;
  PowerCylin?: string | null;
  Axis?: number | null;
  Add?: string | null;
  Prism?: string | null;
  VisualAcuity?: string | null;
  InocularPressure?: string | null;
  VisualFieldInfo?: string | null;
  NVSTagNum?: string | null;
  Labref?: string | null;
  LabOrderNum?: string | null;
  Eye?: string | null;
  Status?: string | null;
}

export interface ClaimFinancials {
  TotalBilledAmt?: number | null;
  TotalDiscount?: number | null;
  NettBilledAmt?: number | null;
}

export interface ClaimLineItem {
  UniqueID?: string | null;
  OptomScriptRefs?: string[] | null;
  DOS?: Date | null;
  Labs?: Lab[] | null;
  AuthNum?: string | null;
  ScriptNum?: string | null;
  ChargeCode?: ChargeCodeType | null;
  StockCode?: StockCodeType | null;
  DiagnosisCodes?: ClaimDiagnosisCodes[] | null;
  ChargeStart?: Date | null;
  ChargeEnd?: Date | null;
  ChargeQuantity?: number | null;
  Dentals?: Dental[] | null;
  PlaceServiceCode?: string | null;
  Medicine?: MedicineType | null;
  LineItemFinancials?: LineItemFinancialsType | null;
  Type?: string | null;
  PricingInd?: string | null;
  ChargeUnit?: string | null;
  ContactLensChargeFreq?: string | null;
  HospInd?: string | null;
}

export interface Address {
  Suburb?: string | null;
  Town?: string | null;
  Code?: string | null;
  Address?: string | null;
}

export interface Lab {
  RefNum?: string | null;
  OrderNum?: string | null;
  Name?: string | null;
  RemakeInd?: string | null;
}

export interface ChargeCodeType {
  Version?: string | null;
  Value?: string | null;
  Description?: string | null;
  Type?: string | null;
  Set?: string | null;
}

export interface StockCodeType {
  Version?: string | null;
  Value?: string | null;
  Description?: string | null;
  Set?: string | null;
}

export interface Dental {
  ToothNum?: string | null;
  ToothSurface?: string | null;
}

export interface MedicineType {
  DailyDosage?: number | null;
  DaysSupply?: number | null;
  SupplyQuantity?: number | null;
  DosInstr?: string | null;
  MixIdNum?: number | null;
  MixIngNum?: number | null;
  Repeat?: RepeatType | null;
  DispLoc?: string | null;
  MixMed?: string | null;
  Type?: string | null;
}

export interface LineItemFinancialsType {
  BilledAmt?: number | null;
  GrossAmt?: number | null;
  Discount?: number | null;
  Levy?: number | null;
  ContainerFee?: number | null;
  DispenseFee?: number | null;
  ServiceFee?: number | null;
  ProfFee?: number | null;
  BalancedBilling?: BalancedBillingType | null;
}

export interface RepeatType {
  Number?: number | null;
  Total?: number | null;
}

export interface BalancedBillingType {
  MALiable?: number | null;
  PatLiable?: number | null;
}

export interface EncounterVo {
  EncounterId?: string | null;
  PatientId?: string | null;
  BranchXRef?: string | null;
  PracticeId?: string | null;
  EncounterType?: string | null;
  ConsultReason?: string | null;
  Provider?: ProviderVo2 | null;
  ReferringDoctorName?: string | null;
  ReferringDoctorPracticeNumber?: string | null;
  AssistingDoctorName?: string | null;
  AssistingDoctorPracticeNumber?: string | null;
  PatientEventDetails?: PatientEventVo | null;
  Diagnosis?: DiagnosisVo2[] | null;
  EncounterLineItems?: EncounterLineItemsVo | null;
  MedicationsAdministered?: MedicationPrescription | null;
  MedicationsDispensed?: MedicationPrescription | null;
  MedicationsPrescribed?: MedicationPrescription | null;
  MedicalCertificate?: MedicalCertificate | null;
  MedicalInsurance?: MedicalInsuranceVo | null;
  RequiresFollowUp?: boolean | null;
  Note?: string | null;
  ClinicalNote?: string | null;
  EncounterFollowUp?: EncounterFollowUpVo | null;
  Communications?: CommunicationVo[] | null;
  ClinicalMetrics?: ClinicalMetricVo[] | null;
  PatientDocuments?: LinkedPatientDocument[] | null;
  Symptoms?: Symptom[] | null;
  SymptomQuestions?: SymptomQuestion[] | null;
  SymptomQuestionAnswers?: SymptomQuestionAnswer[] | null;
  DiagnosisTokenItems?: EncounterDiagnosisTokenItemVo[] | null;
  EncounterPlanOutcomes?: EncounterPlanOutcomeVo[] | null;
  EncounterDiagrams?: EncounterDiagramVo[] | null;
  MedicationsPrescriptions?: MedicationPrescription[] | null;
  Questionnaires?: QuestionnaireVo[] | null;
}

export interface ProviderVo2 {
  PracticeType?: string | null;
  PracticeName?: string | null;
  SpecialityCode?: string | null;
  SubSpecialityCode?: string | null;
  PracticeNumber?: string | null;
  TreatingDoctorName?: string | null;
  TreatingDoctorPracticeNumber?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicenseNumber?: string | null;
  HPCSANumber?: string | null;
  ContactNumber?: string | null;
  Qualification?: string | null;
  SpecialityDescription?: string | null;
  TelephoneNumber?: string | null;
  FaxNumber?: string | null;
  CellphoneNumber?: string | null;
  EmailAddress?: string | null;
  PhysicalAddress?: string | null;
  PostalAddress?: string | null;
  IsLocumProvider?: boolean | null;
}

export interface DiagnosisVo2 {
  Id?: string | null;
  DiagnosisCode?: string | null;
  DiagnosisDescription?: string | null;
  SpecificCode?: boolean | null;
  PrimaryIndicator?: boolean | null;
  ValidPrimary?: boolean | null;
  ValidSequelae?: boolean | null;
  MaxSpecificity?: boolean | null;
  Gender?: string | null;
  AgeRangeStart?: number | null;
  AgeRangeEnd?: number | null;
  DiagnosisToken?: string | null;
  DiagnosisTokenDescription?: string | null;
  IcdSource?: string | null;
  OrderNo?: number | null;
}

export interface EncounterLineItemsVo {
  EncounterHeader?: EncounterHeaderVo | null;
  LineItems?: EncounterLineItemVo[] | null;
}

export interface MedicationPrescription {
  MedicationPrescriptionId?: string | null;
  IssuedDate?: Date | null;
  Name?: string | null;
  FutureDate?: Date | null;
  Provider?: ProviderVo2 | null;
  Patient?: PatientVo | null;
  MedicationPrescriptionLines?: MedicationPrescriptionLine[] | null;
  PracticeId?: string | null;
  HtmlBody?: string | null;
  IncludeSignature?: boolean | null;
  IsOriginalScript?: boolean | null;
  ExcludeReportDate?: boolean | null;
  AdditionalNotes?: string | null;
  PatientAllergies?: string[] | null;
  PatientWeight?: PatientDashboardHistoryEventDto | null;
  SentToDischem?: {
    Status: 'Sent' | 'Cancelled';
    Pharmacy?: DischemPharmacy;
    [key: string]: any;
  } | null;
  SentToComputAssist?: {
    scriptNumber: string;
    Status: 'Sent';
    pharmacy?: any;
    [key: string]: any;
  } | null;
  SentToEasyRx?: {
    orderNumber: string;
    Status: 'Sent';
    pharmacy?: any;
    [key: string]: any;
  } | null;
  ComputAssistScriptNumber?: string | null;
  EasyRxOrderNumber?: string | null;
  OrderNumber?: string | null;
}

export interface SendDischemScript {
  ScriptRequest?: string | null;
  MedLinesRequest?: string | null;
}

export interface RestApiResultOfSendDischemScriptResponse {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: SendDischemScriptResponse | null;
  Links?: RestApiLink[] | null;
}

export interface SendDischemScriptResponse {
  ScriptResponse?: string | null;
  MedLinesResponse?: string | null;
}

export interface UpdateDischemScript {
  Request?: string | null;
}

export interface RestApiResultOfDischemPharmaciesListResponse {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: DischemPharmaciesListResponse | null;
  Links?: RestApiLink[] | null;
}

export interface DischemPharmaciesListResponse {
  success?: boolean | null;
  sender_id?: string | null;
  message_id?: string | null;
  timestamp?: string | null;
  results?: DischemPharmacyStore[] | null;
}

export interface DischemPharmacyStore {
  store?: string | null;
  rams?: string | null;
}

export interface SendComputAssistScript {
  ScriptRequest?: string | null;
}

export interface RestApiResultOfSendComputAssistScriptResponse {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: SendComputAssistScriptResponse | null;
  Links?: RestApiLink[] | null;
}

export interface SendComputAssistScriptResponse {
  ScriptResponse?: string | null;
}

export interface AmpathResultsRequest {
  IdentificationNumber?: string | null;
  Surname?: string | null;
  ConsentGiven?: boolean | null;
  Doctor?: string | null;
  FromDate?: string | null;
  ToDate?: string | null;
  IncludePDF?: boolean | null;
  ReportType?: string | null;
}

export interface RestApiResultOfAmpathResultsResponse {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: AmpathResultsResponse | null;
  Links?: RestApiLink[] | null;
}

export interface AmpathResultsResponse {
  error?: string | null;
  batchNo?: string | null;
  latestResult?: string | null;
  hasMoreResults?: boolean | null;
  allSpecimensComplete?: boolean | null;
  pathologyReports?: AmpathPathologyReports | null;
  pathologyReportPDFs?: AmpathPdfReport[] | null;
}

export interface AmpathPathologyReports {
  Encoding?: string | null;
  xml?: string | null;
}

export interface AmpathPdfReport {
  messageId?: number | null;
  Encoding?: string | null;
  pdf?: string | null;
}

export interface MedicalCertificate {
  MedicalCertificateId?: string | null;
  CreatedDate?: Date | null;
  ExaminationDate?: Date | null;
  FromDate?: Date | null;
  ToDate?: Date | null;
  ReturnDate?: Date | null;
  FollowupDate?: Date | null;
  Patient?: PatientVo | null;
  Provider?: ProviderVo2 | null;
  Diagnoses?: DiagnosisVo2[] | null;
  AdditionalNotes?: string | null;
  AsInformed?: boolean | null;
  TelephonicConsultation?: boolean | null;
  IncludeSignature?: boolean | null;
  Accompanied?: boolean | null;
  AccompaniedBy?: string | null;
  AccompaniedFromDate?: Date | null;
  AccompaniedToDate?: Date | null;
}

export interface EncounterFollowUpVo {
  FollowUpReasons?: string[] | null;
  FollowUpRequired?: boolean | null;
  DueDateForFollowUp?: Date | null;
  FollowUpPatientCellphone?: string | null;
  FollowUpMessage?: string | null;
}

export interface CommunicationVo {
  CommunicationId?: string | null;
  PatientId?: string | null;
  EncounterId?: string | null;
  CommunicationTemplateId?: string | null;
  Type?: string | null;
  Title?: string | null;
  IncludeSignature?: boolean | null;
}

export interface ClinicalMetricVo {
  TestDate?: Date | null;
  Group?: string | null;
  Name?: string | null;
  Value?: string | null;
  Unit?: string | null;
  Type?: string | null;
  DatePrecision?: string | null;
  Interpretation?: string | null;
  OtherPerformer?: string | null;
  PathLab?: string | null;
  PathLOINC?: string | null;
  PathResultId?: string | null;
  ReferenceId?: string | null;
  Source?: string | null;
  Tag?: string | null;
  Notes?: string | null;
  NextScreeningDate?: Date | null;
}

export interface Symptom {
  SymptomId?: string | null;
  Name?: string | null;
  SpecialityCodes?: string[] | null;
  Type?: string | null;
}

export interface SymptomQuestion {
  SymptomId?: string | null;
  QuestionKey?: string | null;
  Section?: string | null;
  Question?: QuestionBase | null;
  Order?: number | null;
  Dependency?: Dependency | null;
  Questions?: SymptomQuestion[] | null;
}

export interface SymptomQuestionAnswer {
  QuestionKey?: string | null;
  SymptomId?: string | null;
  NoteValue?: string | null;
  AnswerValue?: string | null;
  Section?: string | null;
  Notes?: string | null;
}

export interface EncounterDiagnosisTokenItemVo {
  DiagnosisToken?: string | null;
  DiagnosisTokenDescription?: string | null;
  SpecificIcdProvided?: string | null;
}

export interface EncounterPlanOutcomeVo {
  Title?: string | null;
  Type?: string | null;
}

export interface EncounterDiagramVo {
  Description?: string | null;
  Category?: string | null;
  Type?: string | null;
  Data?: string | null;
}

export interface EncounterHeaderVo {
  ClaimAuthorizationNumber?: string | null;
  AdmissionDateTime?: Date | null;
  DischargeDateTime?: Date | null;
  HospitalIndicator?: boolean | null;
  ClaimType?: string | null;
  TariffCode?: string | null;
  Diagnosis?: DiagnosisVo2[] | null;
  DateOfService?: Date | null;
  /** 0 = Uknown, 2 = Telehealth, 11 = ConsultingRooms, 21 = InPatientHospital, 24 = DayClinic, 12 = Home */
  PlaceOfService?: EncounterHeaderVoPlaceOfService | null;
  Ward?: string | null;
}

export interface EncounterLineItemVo {
  DateOfService?: Date | null;
  LineNum?: number | null;
  LineType?: string | null;
  ChargeCode?: string | null;
  ChargeDesc?: string | null;
  NappiCode?: string | null;
  ChargeUnits?: string | null;
  DosageUnit?: number | null;
  DosageType?: string | null;
  FrequencyUnit?: number | null;
  FrequencyType?: string | null;
  PeriodUnit?: number | null;
  PeriodType?: string | null;
  DurationUnit?: number | null;
  DurationType?: string | null;
  Repeat?: number | null;
  ChronicIndicator?: boolean | null;
  ChargeQuan?: number | null;
  TotalExcVat?: number | null;
  VatAmount?: number | null;
  TotalIncVat?: number | null;
  Amount?: number | null;
  Parameters?: { [key: string]: string } | null;
  Responses?: { [key: string]: string } | null;
  ChargeStart?: Date | null;
  ChargeEnd?: Date | null;
  PriceOverride?: boolean | null;
  AccelerateLearning?: boolean | null;
  UnitPrice?: number | null;
  SchemeRule?: string | null;
  CreatedFrom?: string | null;
  Diagnosis?: DiagnosisVo[] | null;
}

export interface MedicationPrescriptionLine {
  Quantity?: number | null;
  LineNum?: number | null;
  MedicationDescription?: string | null;
  NappiCode?: string | null;
  NappiCode10?: string | null;
  DosageUnits?: number | null;
  DosageType?: string | null;
  FrequencyUnits?: number | null;
  FrequencyMax?: number | null;
  PeriodUnit?: number | null;
  PeriodType?: string | null;
  DurationUnit?: number | null;
  DurationType?: string | null;
  Repeat?: number | null;
  ChronicIndicator?: boolean | null;
  AllowGeneric?: boolean | null;
  Diagnosis?: DiagnosisVo2[] | null;
  DispensingInstructions?: string | null;
  AdministrationInstructions?: string | null;
  Description?: string | null;
  CreatedFrom?: string | null;
  AccelerateLearning?: boolean | null;
  Parameters?: { [key: string]: string } | null;
}

export interface QuestionBase {
  QuestionKey?: string | null;
  Answer?: string | null;
  Label?: string | null;
  PlaceholderText?: string | null;
  Required?: boolean | null;
  Order?: number | null;
  ControlType?: string | null;
  TextType?: string | null;
  Options?: QuestionOption[] | null;
  SharedValue?: boolean | null;
  RequiresNote?: boolean | null;
  Dependency?: Dependency | null;
  Notes?: string | null;
  Category?: string | null;
  Filter?: PatientFilterCriteria | null;
  Priority?: number | null;
}

export interface Dependency {
  DependencyKeyName?: string | null;
  DependencyKeyValue?: string | null;
  DependencyKeyValueMin?: number | null;
  DependencyKeyValueMax?: number | null;
}

export interface QuestionOption {
  AnswerValue?: string | null;
  NoteValue?: string | null;
}

export interface PatientFilterCriteria {
  Older?: number | null;
  Younger?: number | null;
  Gender?: string | null;
}

export interface CompleteEncounter {
  EncounterVo?: EncounterVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfCompleteEncounterResult {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: CompleteEncounterResult | null;
  Links?: RestApiLink[] | null;
}

export interface CompleteEncounterResult {
  EncounterId?: string | null;
  HealthIDViewed?: string | null;
}

export interface EncounterStatusVo {
  LastUpdated?: Date | null;
  Status?: string | null;
  EncounterId?: string | null;
  PatientId?: string | null;
  BranchXRef?: string | null;
  PracticeId?: string | null;
  EncounterType?: string | null;
  ConsultReason?: string | null;
  Provider?: ProviderVo2 | null;
  ReferringDoctorName?: string | null;
  ReferringDoctorPracticeNumber?: string | null;
  AssistingDoctorName?: string | null;
  AssistingDoctorPracticeNumber?: string | null;
  PatientEventDetails?: PatientEventVo | null;
  Diagnosis?: DiagnosisVo2[] | null;
  EncounterLineItems?: EncounterLineItemsVo | null;
  MedicationsAdministered?: MedicationPrescription | null;
  MedicationsDispensed?: MedicationPrescription | null;
  MedicationsPrescribed?: MedicationPrescription | null;
  MedicalCertificate?: MedicalCertificate | null;
  MedicalInsurance?: MedicalInsuranceVo | null;
  RequiresFollowUp?: boolean | null;
  Note?: string | null;
  ClinicalNote?: string | null;
  EncounterFollowUp?: EncounterFollowUpVo | null;
  Communications?: CommunicationVo[] | null;
  ClinicalMetrics?: ClinicalMetricVo[] | null;
  PatientDocuments?: LinkedPatientDocument[] | null;
  Symptoms?: Symptom[] | null;
  SymptomQuestions?: SymptomQuestion[] | null;
  SymptomQuestionAnswers?: SymptomQuestionAnswer[] | null;
  DiagnosisTokenItems?: EncounterDiagnosisTokenItemVo[] | null;
  EncounterPlanOutcomes?: EncounterPlanOutcomeVo[] | null;
  EncounterDiagrams?: EncounterDiagramVo[] | null;
  MedicationsPrescriptions?: MedicationPrescription[] | null;
  Questionnaires?: QuestionnaireVo[] | null;
}

export interface EncounterTemplateVo {
  TemplateId?: string | null;
  TemplateXref?: string | null;
  PracticeId?: string | null;
  TemplateType?: string | null;
  Caption?: string | null;
  Description?: string | null;
  SortOrder?: number | null;
  EncounterLineItems?: EncounterLineItemsVo | null;
  MedicationPrescriptionLines?: MedicationPrescriptionLine[] | null;
  Communications?: CommunicationVo[] | null;
}

export interface UpdateEncounterTemplate {
  EncounterTemplate?: EncounterTemplateVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfInt32 {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: number | null;
  Links?: RestApiLink[] | null;
}

export interface EncounterLineItemsRankingVo {
  Rank?: number | null;
  EncounterHeader?: EncounterHeaderVo | null;
  LineItems?: EncounterLineItemVo[] | null;
}

export interface CommunicationTemplateVo {
  PracticeId?: string | null;
  TemplateId?: string | null;
  TemplateName?: string | null;
  TemplateType?: string | null;
  TemplateMediaType?: string | null;
  TemplateIdentifier?: string | null;
  TemplateBody?: string | null;
  Locale?: string | null;
  LastUpdated?: Date | null;
  LastUpdatedBy?: string | null;
}

export interface SaveEncounter {
  EncounterVo?: EncounterVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RecordHistoricalEncounter {
  OriginalId?: string | null;
  EncounterVo?: EncounterVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ModifierRequiredParameter {
  FieldName?: string | null;
  Type?: string | null;
  Format?: string | null;
  Description?: string | null;
  Ordering?: number | null;
  IsHeaderLevel?: boolean | null;
  Required?: boolean | null;
}

export interface ModifierInformation {
  Name?: string | null;
  Code?: string | null;
  ImplementationStatus?: string | null;
  RequiredParameters?: ModifierRequiredParameter[] | null;
}

export interface ProviderConfigurationVo2 {
  PracticeId?: string | null;
  PracticeTenantId?: string | null;
  PracticeXRef?: string | null;
  BranchXRef?: string | null;
  BranchName?: string | null;
  PracticeName?: string | null;
  TreatingDoctorName?: string | null;
  SpecialityCode?: string | null;
  SubSpecialityCode?: string | null;
  PracticeNumber?: string | null;
  TreatingPracticeNumber?: string | null;
  DispensingDoctor?: string | null;
  DispensingLicNum?: string | null;
  HPCSANumber?: string | null;
  ContactNumber?: string | null;
  Qualification?: string | null;
  SpecialityDescription?: string | null;
  TelephoneNumber?: string | null;
  FaxNumber?: string | null;
  CellphoneNumber?: string | null;
  EmailAddress?: string | null;
  PhysicalAddress?: string | null;
  PostalAddress?: string | null;
  NetworkedSchemes?: string[] | null;
  ManualPricingSchemes?: string[] | null;
  IsEnabledForClinicalResults?: boolean | null;
  IsDisabledForSendingBillingInstructions?: boolean | null;
  IsLocumProvider?: boolean | null;
}

export interface BarcodeNappiMappingVo {
  Id?: string | null;
  NappiCode?: string | null;
  NappiDescription?: string | null;
  ShortName?: string | null;
  Barcode?: string | null;
}

/** Request model for capturing communication reports as a single PDF document */
export interface CommunicationPdfCaptureRequest {
  /** Array of HTML content to convert to PDF */
  Htmls?: string[] | null;
  /** Patient document metadata */
  Document?: PatientDocumentVo | null;
  /** Whether to replace existing document */
  ReplaceExistingDocument?: boolean | null;
}

export interface MigrateEncounter {
  Encounter?: EncounterVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface InviteDoctorVo {
  ContactNumber?: string | null;
  Name?: string | null;
  Email?: string | null;
}

export interface RefreshEncounter {
  Encounter?: EncounterVo | null;
  EncounterType?: string | null;
}

export interface RestApiResultOfEncounterVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: EncounterVo | null;
  Links?: RestApiLink[] | null;
}

export interface MergeEncounterLineItems {
  EncounterId?: string | null;
  PracticeId?: string | null;
  OriginalInstruction?: EncounterVo | null;
  NewInstruction?: EncounterTemplateVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfMergeEncounterResult {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: MergeEncounterResult | null;
  Links?: RestApiLink[] | null;
}

export interface MergeEncounterResult {
  MergedEncounter?: EncounterVo | null;
  Errors?: MergeEncounterValidationError[] | null;
}

export interface MergeEncounterValidationError {
  Code?: string | null;
  Description?: string | null;
}

export interface MergeEncounterTemplateLineItems {
  PracticeId?: string | null;
  OriginalInstruction?: EncounterTemplateVo | null;
  NewInstruction?: EncounterTemplateVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfEncounterTemplateVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: EncounterTemplateVo | null;
  Links?: RestApiLink[] | null;
}

export interface MergeEncounterHospital {
  OriginalInstruction?: EncounterLineItemsVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfEncounterLineItemsVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: EncounterLineItemsVo | null;
  Links?: RestApiLink[] | null;
}

export interface UpdateEncounterCommunication {
  PracticeId?: string | null;
  Content?: string | null;
  Title?: string | null;
  EncounterId?: string | null;
  CommunicationId?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface PathologyReportWorkflowVo {
  PathologyReportWorkflowId?: string | null;
  PathologyReportId?: string | null;
  /** 0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden */
  WorkflowStatusType?: PathologyReportWorkflowVoWorkflowStatusType | null;
  PatientName?: string | null;
  PatientContactNo?: string | null;
  Departments?: string | null;
  ReceivedDate?: Date | null;
  PatientDateOfBirth?: Date | null;
  OriginalMessage?: string | null;
  ReportLabName?: string | null;
  PatientIds?: string[] | null;
  PrimaryProviderId?: string | null;
  PracticeId?: string | null;
  DoctorName?: string | null;
}

export interface PathologyReportDto {
  PracticeId?: string | null;
  PathologyReportId?: string | null;
  TreatingProviderId?: string | null;
  MatchedPatientIds?: string[] | null;
  PathologyReport?: PathologyReport | null;
  PatientVo?: PatientVo | null;
}

export interface PathologyReport {
  Sender?: PathologyReportSender | null;
  Recipient?: PathologyReportRecipient | null;
  Patient?: PathologyReportPatient | null;
  Layout?: PathologyReportHeader[] | null;
  version?: string | null;
  batchNo?: string | null;
  batchDateTime?: Date | null;
  messageID?: string | null;
}

export interface PathologyReportSender {
  Address?: PathologyReportAddressType | null;
  ReportHeader?: PathologyReportCommentLocalization[] | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportRecipient {
  patientReference?: string | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  Address?: PathologyReportAddressType | null;
  language?: string | null;
  type?: string | null;
  email?: string | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportPatient {
  Account?: PathologyReportPatientAccount | null;
  Requisition?: PathologyReportPatientRequisition[] | null;
  RegisteringDoctor?: PathologyReportDoctorType | null;
  Location?: PathologyCodedElementType | null;
  database?: string | null;
  urn?: string | null;
  mri?: string | null;
  surname?: string | null;
  firstName?: string | null;
  title?: string | null;
  idNumber?: string | null;
  age?: string | null;
  /** 0 = F, 1 = M, 2 = U */
  sex?: PathologyReportPatientSex | null;
  dateOfBirth?: Date | null;
  serviceDate?: Date | null;
}

export interface PathologyReportHeader {
  Text?: PathologyReportCommentLocalization[] | null;
  Test?: PathologyReportLayoutTest[] | null;
  Header?: PathologyReportHeader[] | null;
}

export interface PathologyReportAddressType {
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  postalCode?: string | null;
}

export interface PathologyReportCommentLocalization {
  Text?: string | null;
  language?: string | null;
  default?: string | null;
}

export interface PathologyReportAdditionalCodeType {
  type?: string | null;
  version?: string | null;
  value?: string | null;
}

export interface PathologyReportCodedElementTypeLocalization {
  language?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportTelephoneType {
  /** 0 = home, 1 = work, 2 = mobile, 3 = fax */
  type?: PathologyReportTelephoneTypeType | null;
  number?: string | null;
}

export interface PathologyReportPatientAccount {
  Guarantor?: PathologyReportAccountGuarantor | null;
  urn?: string | null;
  number?: string | null;
}

export interface PathologyReportPatientRequisition {
  Orders?: PathologyCodedElementType[] | null;
  SubmittingDoctor?: PathologyReportDoctorType | null;
  OtherDoctor?: PathologyReportRequisitionOtherDoctor[] | null;
  Specimen?: PathologyReportSpecimen[] | null;
  database?: string | null;
  urn?: string | null;
  number?: string | null;
  priority?: string | null;
  orderNo?: string | null;
}

export interface PathologyReportDoctorType {
  Telephone?: PathologyReportTelephoneType[] | null;
  Address?: PathologyReportAddressType | null;
  language?: string | null;
  type?: string | null;
  email?: string | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyCodedElementType {
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportLayoutTest {
  code?: string | null;
}

export interface PathologyReportAccountGuarantor {
  Telephone?: PathologyReportTelephoneType[] | null;
  Insurance?: PathologyReportAccountGuarantorInsurance | null;
  gid?: string | null;
  surname?: string | null;
  firstName?: string | null;
  title?: string | null;
}

export interface PathologyReportRequisitionOtherDoctor {
  id?: string | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  Address?: PathologyReportAddressType | null;
  language?: string | null;
  type?: string | null;
  email?: string | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportSpecimen {
  EnteredBy?: PathologyReportEnteredBy | null;
  CollectedBy?: PathologyReportCollectedBy | null;
  ReceivedBy?: PathologyReportSpecimenReceivedBy | null;
  Orders?: PathologyCodedElementType[] | null;
  Comment?: PathologyReportCommentLocalization[] | null;
  Department?: PathologyCodedElementType | null;
  Source?: PathologyCodedElementType | null;
  Description?: PathologyCodedElementType | null;
  OrderSite?: PathologyReportSite | null;
  ReceivedSite?: PathologyReportSite | null;
  Procedure?: PathologyReportSpecimenProcedure[] | null;
  SignedOutBy?: PathologyReportSignedOutBy[] | null;
  SignOutComment?: PathologyReportCommentLocalization[] | null;
  Layout?: PathologyReportLayout | null;
  urn?: string | null;
  number?: string | null;
  /** 0 = LAB, 1 = MIC, 2 = PTH */
  type?: PathologyReportSpecimenType | null;
  reportDate?: Date | null;
  reportTime?: Date | null;
  reportType?: string | null;
  referenceAge?: string | null;
  status?: string | null;
}

export interface PathologyReportAccountGuarantorInsurance {
  code?: string | null;
  name?: string | null;
  plan?: string | null;
  policyNo?: string | null;
}

export interface PathologyReportEnteredBy {
  enteredDate?: Date | null;
  enteredTime?: Date | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportCollectedBy {
  collectionDate?: Date | null;
  collectionTime?: Date | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportSpecimenReceivedBy {
  receivedDate?: Date | null;
  receivedTime?: Date | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportSite {
  Address?: PathologyReportAddressType | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportSpecimenProcedure {
  Test?: PathologyReportTest[] | null;
  Comment?: PathologyReportCommentLocalization[] | null;
  confidential?: boolean | null;
  reportable?: boolean | null;
  status?: string | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportSignedOutBy {
  signedOutDate?: Date | null;
  signedOutTime?: Date | null;
  signOutType?: string | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportLayout {
  Test?: PathologyReportLayoutTest[] | null;
  Header?: PathologyReportHeader[] | null;
}

export interface PathologyReportTest {
  PerformSite?: PathologyReportSite | null;
  Group?: PathologyCodedElementType | null;
  Result?: PathologyReportResult[] | null;
  confidential?: boolean | null;
  reportable?: boolean | null;
  status?: string | null;
  Code?: PathologyReportAdditionalCodeType[] | null;
  Localization?: PathologyReportCodedElementTypeLocalization[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
}

export interface PathologyReportResult {
  Code?: PathologyReportCodedResult[] | null;
  Localization?: PathologyReportResultLocalization[] | null;
  Method?: PathologyReportMethod | null;
  DictatedBy?: PathologyReportDictatedBy[] | null;
  EnteredBy?: PathologyReportEnteredBy[] | null;
  VerifiedBy?: PathologyReportVerifiedBy[] | null;
  Comment?: PathologyReportCommentLocalization[] | null;
  Attachment?: PathologyReportResultAttachment[] | null;
  Diagnosis?: PathologyReportResultDiagnosis[] | null;
  Procedure?: PathologyReportSpecimenProcedure[] | null;
  code?: string | null;
  name?: string | null;
  abbreviatedName?: string | null;
  value?: string | null;
  type?: string | null;
  units?: string | null;
  range?: string | null;
  flag?: string | null;
  revisionNo?: string | null;
}

export interface PathologyReportCodedResult {
  Code?: PathologyReportCodedResult[] | null;
  type?: string | null;
  version?: string | null;
  value?: string | null;
  name?: string | null;
}

export interface PathologyReportResultLocalization {
  language?: string | null;
  value?: string | null;
  units?: string | null;
}

export interface PathologyReportMethod {
  code?: string | null;
  name?: string | null;
  analyser?: string | null;
}

export interface PathologyReportDictatedBy {
  dictatedDate?: Date | null;
  dictatedTime?: Date | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportVerifiedBy {
  dictatedDate?: Date | null;
  dictatedTime?: Date | null;
  Telephone?: PathologyReportTelephoneType[] | null;
  code?: string | null;
  name?: string | null;
}

export interface PathologyReportResultAttachment {
  mimeType?: string | null;
  encoding?: string | null;
  filename?: string | null;
}

export interface PathologyReportResultDiagnosis {
  sequence?: string | null;
  type?: string | null;
  code?: string | null;
  name?: string | null;
}

export interface PatientDashboardVo {
  PracticeId?: string | null;
  PatientId?: string | null;
  FirstName?: string | null;
  Surname?: string | null;
  MedicalAidName?: string | null;
  IdentityNo?: string | null;
  DateOfBirth?: Date | null;
  LastVisitDate?: Date | null;
  Age?: number | null;
  Created?: boolean | null;
  Allergies?: string[] | null;
  AllergiesNote?: string | null;
  NoAllergies?: boolean | null;
  ClinicalNotes?: string | null;
  ChronicConditions?: string[] | null;
  PatientDashboardEventsCount?: number | null;
  PatientDashboardEvents?: PatientDashboardHistoryEventDto[] | null;
}

export interface PatientDashboardHistoryEventDto {
  DateTime?: Date | null;
  PatientId?: string | null;
  PathologyReportId?: string | null;
  ParentReferenceId?: string | null;
  ParentDescription?: string | null;
  NotMatched?: boolean | null;
  Type?: string | null;
  ParentLineNum?: number | null;
  Code?: string | null;
  Description?: string | null;
  Value?: string | null;
  ValueUnits?: string | null;
  ValueFlag?: string | null;
  Narrative?: string | null;
  Thumbnail?: string | null;
}

export interface PatientPathologyResultsIndexVo {
  Id?: string | null;
  TenantId?: string | null;
  PatientFullName?: string | null;
  PatientDateOfBirth?: Date | null;
  Departments?: string | null;
  PatientReportId?: string | null;
  ReportDate?: Date | null;
  ReportType?: string | null;
  PathLab?: string | null;
  ReportXRef?: string | null;
}

export interface PathologyReportDeliveryVo {
  PracticeId?: string | null;
  PathologyReportId?: string | null;
  DeliveryDate?: Date | null;
  PathLab?: string | null;
  ReportXRef?: string | null;
  PatientFullName?: string | null;
  RecipientName?: string | null;
  RecipientNumber?: string | null;
  DeliveryStatus?: string | null;
  TreatingProviderId?: string | null;
  MatchedPatientIds?: string[] | null;
  OriginalMessagePayload?: string | null;
}

export interface DeliverPathologyReport {
  PracticeId?: string | null;
  PathologyReportId?: string | null;
  TreatingProviderId?: string | null;
  MatchedPatientIds?: string[] | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfNullableOfGuid {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: string | null;
  Links?: RestApiLink[] | null;
}

export interface RequestReceivePathologyReport {
  OriginalMessagePayload?: string | null;
  PathologyReportId?: string | null;
  ReportXRef?: string | null;
  HistoricalPathologyReport?: boolean | null;
}

export interface MarkPathologyReportAsRead {
  PracticeId?: string | null;
  PathologyReportWorkflowId?: string | null;
  HighPriority?: boolean | null;
  NotifyPatientThatResultsNormal?: boolean | null;
  FollowUpAppointmentRequired?: boolean | null;
  FollowUpPatientCellphone?: string | null;
  FollowUpText?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdateAddressBookEntry {
  AddressBookEntry?: AddressBookEntryVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface AddressBookEntryVo {
  AddressBookEntryId?: string | null;
  IsFavourite?: boolean | null;
  TenantId?: string | null;
  Category?: string | null;
  OrganizationName?: string | null;
  PracticeNumber?: string | null;
  Name?: string | null;
  Surname?: string | null;
  Speciality?: string | null;
  EmailAddress?: string | null;
  OfficeNumber?: string | null;
  MobileNumber?: string | null;
  ContactNumber?: string | null;
  PhysicalAddress?: AddressVo | null;
  PostalAddress?: AddressVo | null;
}

export interface CorrectEncounter {
  Encounter?: EncounterVo | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface TemplateBulkImportVo {
  RawData?: string | null;
  ImportType?: string | null;
  OnlyValidate?: boolean | null;
}

export interface RestApiResultOfStringOf {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: string[] | null;
  Links?: RestApiLink[] | null;
}

export interface ClinicalEncounterVo {
  ClinicalEncounterId?: string | null;
  PracticeTenantId?: string | null;
  PatientEventId?: string | null;
  PatientId?: string | null;
  PatientEventDetails?: PatientEventVo | null;
  Invoices?: InvoiceVo[] | null;
  MedicalCertificates?: MedicalCertificate[] | null;
  MedicationsPrescribed?: MedicationPrescription[] | null;
  ClinicalMetrics?: ClinicalMetricVo[] | null;
  PatientDocuments?: LinkedPatientDocument[] | null;
  Communications?: CommunicationVo[] | null;
  Allergies?: PatientAllergiesVo[] | null;
  ClinicalNotes?: PatientClinicalNotesVo[] | null;
  ChronicConditions?: PatientChronicConditionsVo[] | null;
}

export interface PatientAllergiesVo {
  PatientAllergiesId?: string | null;
  Patient?: PatientVo | null;
  Provider?: ProviderVo2 | null;
  PatientAllergies?: PatientAllergyVo[] | null;
  Other?: string | null;
  NoAllergies?: boolean | null;
}

export interface PatientClinicalNotesVo {
  PatientClinicalNotesId?: string | null;
  Patient?: PatientVo | null;
  PracticeId?: string | null;
  Note?: string | null;
  IsImportant?: boolean | null;
  Type?: string | null;
  Format?: string | null;
  CapturedDate?: Date | null;
}

export interface PatientChronicConditionsVo {
  Id?: string | null;
  Patient?: PatientVo | null;
  Provider?: ProviderVo2 | null;
  Conditions?: PatientChronicConditionVo[] | null;
  OtherMedications?: MedicationConditionVo[] | null;
  Note?: string | null;
  MedicineNote?: string | null;
}

export interface PatientAllergyVo {
  CapturedDate?: Date | null;
  Allergen?: AllergenVo | null;
  Criticality?: string | null;
  ClinicalStatus?: string | null;
  VerificationStatus?: string | null;
}

export interface PatientChronicConditionVo {
  CapturedDate?: Date | null;
  Condition?: ChronicConditionVo | null;
  Medications?: MedicationConditionVo[] | null;
}

export interface MedicationConditionVo {
  Name?: string | null;
  NappiCode?: string | null;
  DateStarted?: Date | null;
  DateEnded?: Date | null;
  Section?: string | null;
  Status?: string | null;
  IsRegistered?: boolean | null;
  Note?: string | null;
  Dosage?: string | null;
  Quantity?: number | null;
  DosageUnit?: number | null;
  DosageType?: string | null;
  FrequencyUnit?: number | null;
  PeriodUnit?: number | null;
  PeriodType?: string | null;
  DurationUnit?: number | null;
  DurationType?: string | null;
  Repeat?: number | null;
  Parameters?: { [key: string]: string } | null;
  ShowOnExecutiveSummary?: boolean | null;
}

export interface AllergenVo {
  Category?: string | null;
  Code?: string | null;
  Description?: string | null;
  CodingSource?: string | null;
}

export interface ChronicConditionVo {
  Id?: string | null;
  Name?: string | null;
  Note?: string | null;
  Notes?: string | null;
  Status?: string | null;
  DateOnset?: Date | null;
  IsRegistered?: boolean | null;
  IsUnsuredMedication?: boolean | null;
  DiagnosisCode?: string | null;
  DiagnosisDescription?: string | null;
  TreatmentStatus?: string | null;
  RiskLevel?: string | null;
  Severity?: string | null;
  TestType?: string | null;
  TestDate?: Date | null;
  TreatmentAction?: string | null;
  Controlled?: string | null;
  Compliant?: string | null;
}

export interface PatientFileNoteVo {
  PatientFileNoteId?: string | null;
  PracticeId?: string | null;
  PatientId?: string | null;
  ParentReferenceId?: string | null;
  Note?: string | null;
  Type?: string | null;
  Format?: string | null;
  CapturedDate?: Date | null;
}

export interface PrescriptionRenderRequest {
  MedicationPrescription?: MedicationPrescription | null;
  Template?: CommunicationTemplateVo | null;
  Branch?: ProviderBranchConfigurationVo | null;
}

export interface UpdateClinicalEncounter {
  Encounter?: ClinicalEncounterVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfPatientUpdateTrackingVoOf {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: PatientUpdateTrackingVo[] | null;
  Links?: RestApiLink[] | null;
}

export interface PatientUpdateTrackingVo {
  TenantId?: string | null;
  PatientId?: string | null;
  LastUpdated?: Date | null;
  IsClinical?: boolean | null;
}

export interface RestApiResultOfAllergenVoOf {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: AllergenVo[] | null;
  Links?: RestApiLink[] | null;
}

export interface RestApiResultOfNullableOfDateTime {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: Date | null;
  Links?: RestApiLink[] | null;
}

export interface RestApiResultOfPatientClinicalDetailsVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: PatientClinicalDetailsVo | null;
  Links?: RestApiLink[] | null;
}

export interface PatientClinicalDetailsVo {
  LastUpdated?: Date | null;
  MembersXRefs?: string[] | null;
  Details?: PatientVo | null;
  Dashboard?: PatientDashboardVo | null;
  Allergies?: PatientAllergiesVo | null;
  ChronicConditions?: PatientChronicConditionsVo | null;
  Avatar?: PatientDocumentVo | null;
  Documents?: PatientDocumentVo[] | null;
  Lifestyle?: PatientLifestyleVo | null;
  SurgicalHistory?: PatientSurgicalHistoryVo | null;
  FamilyMembers?: PatientVo[] | null;
  PatientGenericInformation?: PatientFileGenericInformationVo[] | null;
  PatientConfiguration?: PatientConfigurationVo | null;
  ActiveEncounter?: EncounterStatusVo | null;
}

export interface PatientDetailsDto {
  PatientName?: string;
  DisplayName?: string;
  FullName?: string;
  Name?: string;
  KnownAs?: string;
  FirstName?: string;
  Surname?: string;
  LastName?: string;
  PatientDetails?: {
    FirstName?: string;
    Surname?: string;
    LastName?: string;
  };
}

export interface PatientDocumentVo {
  DocumentId?: string | null;
  PracticeId?: string | null;
  PatientId?: string | null;
  CreatedBy?: string | null;
  FileName?: string | null;
  MimeType?: string | null;
  FileSize?: number | null;
  Category?: string | null;
  Description?: string | null;
  DocumentUrl?: string | null;
  ThumbnailUrl?: string | null;
  CapturedDate?: Date | null;
  DocumentDate?: Date | null;
  Notes?: string | null;
  AdditionalData?: { [key: string]: string } | null;
}

export interface FamilyHistoryType {
  Status?: boolean | number;
  Notes?: string | null;
  Mother?: boolean | null;
  Father?: boolean | null;
  MotherNote?: string | null;
  FatherNote?: string | null;
}

export interface PatientLifestyleVo {
  TenantId?: string | null;
  PatientId?: string | null;
  ExerciseNotes?: string | null;
  DietNotes?: string | null;
  Smoker?: PatientLifestyleType | null;
  HomeSmokingExposure?: PatientLifestyleType | null;
  Drugs?: PatientLifestyleType | null;
  Alcohol?: PatientLifestyleType | null;
  Stress?: PatientLifestyleType | null;
  FamilyHistory?: PatientLifestyleType | null;
  Parents?: PatientLifestyleType | null;
  SocialHistory?: PatientLifestyleType | null;
  BirthDetails?: PatientLifestyleType | null;
  Feeding?: PatientLifestyleType | null;
  Depression?: PatientLifestyleType | null;
  Bipolar?: PatientLifestyleType | null;
  Schizophrenia?: PatientLifestyleType | null;
  Anxiety?: PatientLifestyleType | null;
  Adhd?: PatientLifestyleType | null;
  SubstanceAbuse?: PatientLifestyleType | null;
  OtherFamilyHistoryNotes?: string | null;

  Diabetes?: FamilyHistoryType | null;
  Asthma?: FamilyHistoryType | null;
  HighBlood?: FamilyHistoryType | null;
  Arthritis?: FamilyHistoryType | null;
  Cancer?: FamilyHistoryType | null;
  KidneyDesease?: FamilyHistoryType | null;
  Dementia?: FamilyHistoryType | null;
  DepressionHistory?: FamilyHistoryType | null;
  Epilepsy?: FamilyHistoryType | null;
  Cholesterol?: FamilyHistoryType | null;
  hiv?: FamilyHistoryType | null;
  HeartDisease?: FamilyHistoryType | null;
  PsychiatricIllness?: FamilyHistoryType | null;
  Stroke?: FamilyHistoryType | null;
  Tuberculosis?: FamilyHistoryType | null;
}

export interface PatientSurgicalHistoryVo {
  TenantId?: string | null;
  PatientId?: string | null;
  SurgicalNotes?: string | null;
  NoSurgicalHistory?: boolean | null;
  Hospitalizations?: PatientHospitalizationVo[] | null;
}

export interface PatientFileGenericInformationVo {
  PatientFileGenericInformationId?: string | null;
  CapturedDate?: Date | null;
  PracticeId?: string | null;
  PatientId?: string | null;
  Category?: string | null;
  Answers?: SymptomQuestionAnswer[] | null;
}

export interface PatientLifestyleType {
  Notes?: string | null;
  Status?: string | null;
  Severity?: string | null;
  SinceYear?: number | null;
  StoppedYear?: number | null;
  YearsDuration?: number | null;
  AverageQuantity?: number | null;
}

export interface PatientHospitalizationVo {
  Surgery?: string | null;
  Notes?: string | null;
  SurgeryStatus?: string | null;
}

export interface ChangeProviderConfigurationOptions {
  ProviderId?: string | null;
  Options?: { [key: string]: string } | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface SmartCategories2 {
  NumberOfClaimsWithConsumables?: number | null;
  ConsumableCategories?: ConsumableCategories2[] | null;
  ProcedureCategories?: ProcedureCategories2[] | null;
  NumberOfClaimsWithModifiers?: number | null;
  ModifierCategories?: ModifierCategories2[] | null;
  NumberOfClaims?: number | null;
  DrugCategories?: DrugCategories2[] | null;
  ActiveTemplate?: number | null;
  NumberOfClaimsWithDrugs?: number | null;
  LastUpdate?: LastUpdate | null;
  NumberOfClaimsWithProcedures?: number | null;
}

export interface ConsumableCategories2 {
  Frequency?: number | null;
  ConsumableSubCategoryItems?: ConsumableSubCategoryItems2[] | null;
  Description?: string | null;
  Id?: number | null;
}

export interface ProcedureCategories2 {
  ProcedureSubCategoryItems?: ProcedureSubCategoryItems2[] | null;
  Id?: number | null;
  Frequency?: number | null;
  Description?: string | null;
}

export interface ModifierCategories2 {
  Description?: string | null;
  ModifierSubCategoryItems?: ModifierSubCategoryItems2[] | null;
  Id?: number | null;
  Frequency?: number | null;
}

export interface DrugCategories2 {
  Frequency?: number | null;
  DrugSubCategoryItems?: DrugSubCategoryItems2[] | null;
  Description?: string | null;
  Id?: number | null;
}

export interface LastUpdate {
  _seconds?: number | null;
  _nanoseconds?: number | null;
}

export interface ConsumableSubCategoryItems2 {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  Description?: string | null;
  Id?: number | null;
}

export interface ProcedureSubCategoryItems2 {
  DescriptionFull?: string | null;
  Source?: string | null;
  Frequency?: number | null;
  HbModifiedDescription?: number | null;
  Description?: string | null;
  Token?: string | null;
  Code?: string | null;
  Id?: number | null;
}

export interface ModifierSubCategoryItems2 {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  HbModifiedDescription?: string | null;
  DescriptionFull?: string | null;
  Description?: string | null;
  Id?: number | null;
}

export interface DrugSubCategoryItems2 {
  Source?: string | null;
  AppearsInStaticTemplates?: string | null;
  Frequency?: number | null;
  Description?: string | null;
  Token?: string | null;
  Code?: string | null;
  Id?: number | null;
}

export interface StaticCategory {
  tileName?: string | null;
  id?: number | null;
  textColor?: string | null;
  iconImageUrl?: string | null;
  tileDescription?: string | null;
  backgroundColor?: string | null;
  atc3List?: string[] | null;
}

export interface Medicines {
  ATC3Code?: string | null;
  ProductUsageItem?: { [key: string]: number } | null;
  DrugItem?: DrugItem[] | null;
}

export interface DrugItem {
  Id?: number | null;
  HasDispensedRecently?: number | null;
  Duration?: Duration[] | null;
  LastDispensedPackSize?: string | null;
  ATC5Code?: string | null;
  DrugFamilyGroup?: string | null;
  Token?: string | null;
  DrugInfoAvailable?: number | null;
  Rank?: number | null;
  Dosage?: Dosage[] | null;
  ATC4Code?: string | null;
  HasPrescribedRecently?: number | null;
  RouteOfAdministration?: string | null;
  NAPPICode?: string | null;
  ProductUsageCategory?: string | null;
  Description?: string | null;
  Strength?: string | null;
  AdvertisedItem?: number | null;
  StrengthUnits?: string | null;
  DrugFamilyGroupName?: string | null;
  MedicineInfo?: MedicineInfo | null;
}

export interface Duration {
  DurationUnits?: number | null;
  DurationType?: string | null;
  Frequency?: number | null;
}

export interface Dosage {
  PeriodType?: string | null;
  DosageText?: string | null;
  ReadableText?: string | null;
  PeriodUnits?: number | null;
  DosageType?: string | null;
  InformationText?: string | null;
  FrequencyUnits?: number | null;
  Rank?: number | null;
  DosageStrength?: number | null;
  DosageUnits?: number | null;
}

export interface MedicineInfo {
  MedicineSchedule?: number | null;
  VolumeUnits?: string | null;
  hbATC5Code?: string | null;
  Volume?: string | null;
  Units?: string | null;
  FormularyChronic?: FormularyChronic | null;
  ATC3Code?: string | null;
  ATC5_Ingredient_List?: string | null;
  hbProductUsageCategory?: string | null;
  hbProductUsageCategoryDescription?: string | null;
  hbProductUsageCode?: string | null;
  hbDrugClassDescription?: string | null;
  hbDrugClassGroupDescription?: string | null;
  hbDrugFamilyGroup?: string | null;
  hbDrugFamilyName?: string | null;
  hbDrugApplicationForm?: string | null;
  ProductForm?: string | null;
  NAPPICode?: string | null;
  ProductStrength?: string | null;
  ProductStatus?: string | null;
  RouteOfAdministration?: string | null;
  ATC5Code?: string | null;
  PackInfo?: PackInfo2[] | null;
  hbATC2Code?: string | null;
  ConsumableDrugFlag?: number | null;
  ATC5Description?: string | null;
  hbATC3Code?: string | null;
  Flags?: string | null;
  NAPPICode7?: string | null;
  GenericIndicator?: string | null;
  MinSingleExitPricePerUnit?: number | null;
  ProductName?: string | null;
  hbATC4Code?: string | null;
  ManufacturerCode?: string | null;
  ATC2Code?: string | null;
  ATC4Code?: string | null;
  ManufacturerName?: string | null;
}

export interface FormularyChronic {
  Active_Ingredient?: string | null;
  Additional_Notes?: string | null;
  SPO_Code?: SPO_Code[] | null;
  Medicine_Name?: string | null;
  PMB_Condition?: string | null;
  Medicine_Strength?: string | null;
  Nappi_Code?: string | null;
  Dosage_Form?: string | null;
}

export interface PackInfo2 {
  SingleExitPricePerUnit?: number | null;
  NAPPICode10?: string | null;
  NAPPIPack?: string | null;
  SingleExitPriceEffectiveDate?: SingleExitPriceEffectiveDate2 | null;
  PackSize?: number | null;
  SingleExitPricePerPack?: number | null;
  Volume?: number | null;
  VolumeUnits?: string | null;
  StdDispensingVolumePacksize?: number | null;
}

export interface SPO_Code {
  Code?: string | null;
  Detail?: string | null;
}

export interface SingleExitPriceEffectiveDate2 {
  _seconds?: number | null;
  _nanoseconds?: number | null;
}

export interface Consumables {
  ConsumableItem?: ConsumableItem[] | null;
  ATC3Code?: string | null;
}

export interface ConsumableItem {
  ProductUsageCategory?: string | null;
  NAPPICode?: string | null;
  ProductStrength?: string | null;
  Rank?: number | null;
  ATC5?: string | null;
  NAPPICodePack?: string | null;
  ProductName?: string | null;
  Id?: number | null;
  ConsumableInfo?: ConsumableInfo | null;
}

export interface ConsumableInfo {
  NAPPICode7?: string | null;
  GenericIndicator?: string | null;
  MinSingleExitPricePerUnit?: number | null;
  ProductName?: string | null;
  hbATC4Code?: string | null;
  ManufacturerCode?: string | null;
  ATC2Code?: string | null;
  ATC4Code?: string | null;
  ManufacturerName?: string | null;
  MedicineSchedule?: number | null;
  VolumeUnits?: string | null;
  hbATC5Code?: string | null;
  Volume?: string | null;
  Units?: string | null;
  ATC3Code?: string | null;
  ProductUsageCategory?: string | null;
  NAPPICode?: string | null;
  ProductStrength?: string | null;
  ProductStatus?: string | null;
  RouteOfAdministration?: string | null;
  ATC5Code?: string | null;
  PackInfo?: PackInfo[] | null;
  hbATC2Code?: string | null;
  ConsumableDrugFlag?: number | null;
  ATC5Description?: string | null;
  hbATC3Code?: string | null;
  Flags?: string | null;
}

export interface PackInfo {
  SingleExitPriceEffectiveDate?: SingleExitPriceEffectiveDate | null;
  PackSize?: number | null;
  SingleExitPricePerPack?: number | null;
  SingleExitPricePerUnit?: number | null;
  NAPPICode10?: string | null;
  NAPPIPack?: string | null;
}

export interface SingleExitPriceEffectiveDate {
  _seconds?: number | null;
  _nanoseconds?: number | null;
}

export interface DrugInfo {
  Pharmacokinetics?: string[] | null;
  Indications?: string[] | null;
  'Adult dose'?: string[] | null;
  'Special Prescribers Points'?: string[] | null;
  'Drug interactions'?: string[] | null;
  Contraindications?: string[] | null;
  'Paediatric dose'?: string[] | null;
  'Adverse effects'?: string[] | null;
  Cautions?: string[] | null;
  Preparations?: string[] | null;
  Details?: Details | null;
}

export interface Details {
  Prefix?: string | null;
  ATC5?: string | null;
  Schedule?: string | null;
  Name?: string | null;
}

export interface Dosages {
  Dosages?: Dosages1 | null;
}

export interface Dosages1 {
  Dosage?: Dosage3[] | null;
  Duration?: Duration3[] | null;
}

export interface Dosage3 {
  Count?: number | null;
  DosageFreq?: number | null;
  Interval?: number | null;
  Frequency?: number | null;
  DosagePeriod?: number | null;
  DosageType?: string | null;
  DosageQty?: number | null;
  ReadableText?: string | null;
  DosageStrength?: number | null;
  PeriodType?: string | null;
  DosageInstructions?: string[] | null;
}

export interface Duration3 {
  DurationUnit?: string | null;
  Frequency?: number | null;
  DurationQty?: number | null;
  Count?: number | null;
}

export interface ICDPredictionRequest {
  depToken?: string | null;
  tariffTokens?: string[] | null;
  numCodes?: number | null;
}

export interface ICDPredictions {
  PredictionResults?: PredictionResults[] | null;
}

export interface PredictionResults {
  ICD10_3Code?: string | null;
  Id?: number | null;
  Description?: string | null;
  SubCodes?: SubCodes[] | null;
}

export interface SubCodes {
  ICD10Code?: string | null;
  ICDDescription?: string | null;
  ValidForClinicalUse?: number | null;
  ValidAsPrimaryCode?: number | null;
  ValidAsAsteriskCode?: number | null;
  ValidAsDaggerCode?: number | null;
  ValidAsSequelaeCode?: number | null;
  ValidGender?: string | null;
  ValidAgeRange?: string | null;
  ICD10_3Code?: string | null;
  Id?: number | null;
  Probability?: number | null;
  CauseCodeReq?: number | null;
}

export interface SmartCategories {
  ConsumableCategories?: ConsumableCategories[] | null;
  NumberOfClaims?: number | null;
  ModifierCategories?: ModifierCategories[] | null;
  ActiveTemplate?: number | null;
  ProcedureCategories?: ProcedureCategories[] | null;
  DrugCategories?: DrugCategories[] | null;
}

export interface ConsumableCategories {
  Frequency?: number | null;
  ConsumableSubCategoryItems?: ConsumableSubCategoryItems[] | null;
  Description?: string | null;
  Id?: number | null;
}

export interface ModifierCategories {
  Description?: string | null;
  ModifierSubCategoryItems?: ModifierSubCategoryItems[] | null;
  Id?: number | null;
  Frequency?: number | null;
}

export interface ProcedureCategories {
  Description?: string | null;
  ProcedureSubCategoryItems?: ProcedureSubCategoryItems[] | null;
  Id?: number | null;
  Frequency?: number | null;
}

export interface DrugCategories {
  Id?: number | null;
  ProductUsageItem?: { [key: string]: number } | null;
  Frequency?: number | null;
  DrugSubCategoryItems?: DrugSubCategoryItems[] | null;
  Description?: string | null;
}

export interface ConsumableSubCategoryItems {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  Description?: string | null;
  Id?: number | null;
}

export interface ModifierSubCategoryItems {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  HbModifiedDescription?: string | null;
  DescriptionFull?: string | null;
  Description?: string | null;
  Id?: number | null;
}

export interface ProcedureSubCategoryItems {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  HbModifiedDescription?: string | null;
  DescriptionFull?: string | null;
  Description?: string | null;
  Id?: number | null;
}

export interface DrugSubCategoryItems {
  Frequency?: number | null;
  Source?: string | null;
  Token?: string | null;
  Code?: string | null;
  Description?: string | null;
  Id?: number | null;
  DrugItem?: DrugItem[] | null;
}

export interface RequestTrackingConditions {
  IcdCodes?: string[] | null;
}

export interface ConditionFilterVo {
  FromAge?: number | null;
  ToAge?: number | null;
  IcdCodes?: string[] | null;
  Gender?: string | null;
  LastVisit?: string | null;
}

export interface TriggerPatientCommunication {
  PatientCommunication?: PatientCommunicationFollowupVo | null;
  SendNow: boolean | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface PatientCommunicationFollowupVo {
  Id?: string | null;
  TenantId?: string | null;
  Provider?: ProviderVo2 | null;
  PatientId?: string | null;
  UserId?: string | null;
  Context?: string | null;
  ContextId?: string | null;
  /** 0 = Email, 1 = SMS */
  DeliveryType?: PatientCommunicationFollowupVoDeliveryType | null;
  Sender?: string | null;
  Message?: string | null;
  /** 0 = Low, 1 = Urgent */
  Priority?: PatientCommunicationFollowupVoPriority | null;
  Destination?: string | null;
  Subject?: string | null;
  Attachments?: CommunicationAttachment[] | null;
  /** 0 = InProgress, 1 = Cancelled, 2 = Sent, 3 = Received, 4 = Scheduled, 5 = Failed */
  Status?: PatientCommunicationFollowupVoStatus | null;
  ScheduledDate?: Date | null;
  SentDate?: Date | null;
  ReceivedDate?: Date | null;
  MediumSentReference?: string | null;
  BlindCopyDestination?: string | null;
}
export interface SendEncounterRequireFollowupPatientSms {
  FollowupWithPatientRegardingVisitOutcomeId?: string | null;
  EncounterId?: string | null;
  PatientCommunication?: PatientCommunicationVo | null;
  FollowUpReasons?: string[] | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface PatientCommunicationVo {
  PracticeId?: string | null;
  PatientId?: string | null;
  PatientName?: string | null;
  PatientSurname?: string | null;
  PatientCellphone?: string | null;
  PatientDOB?: Date | null;
  FollowUpDate?: Date | null;
  DoctorName?: string | null;
  CommunicationText?: string | null;
}

export interface CommunicationAttachment {
  DocumentUrl?: string | null;
  FileName?: string | null;
  MimeType?: string | null;
}

export interface UserFeedbackVo {
  FeedbackType?: string | null;
  Body?: string | null;
  Attachments?: UserFeedbackAttachment[] | null;
}

export interface UserFeedbackAttachment {
  DocumentDataBase64?: string | null;
  FileName?: string | null;
  MimeType?: string | null;
}

export interface RetryPatientCommunication {
  PatientCommunication?: PatientCommunicationFollowupVo | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface CommunicationRenderRequest {
  Encounter?: EncounterVo | null;
  Template?: CommunicationTemplateVo | null;
  Branch?: ProviderBranchConfigurationVo | null;
  PatientAllergies?: string[] | null;
  PatientAllergiesNote?: string | null;
  ClinicalNote?: string | null;
  ChronicConditions?: string[] | null;
  SurgicalHistory?: PatientSurgicalHistoryVo | null;
  PatientWeight?: PatientDashboardHistoryEventDto | null;
}

export interface MedicineInteractionVo {
  MedicineANappiCode?: string | null;
  MedicineBNappiCode?: string | null;
  MedicineAName?: string | null;
  MedicineBName?: string | null;
  Severity?: number | null;
  Details?: InteractionDetailVo[] | null;
}

export interface InteractionDetailVo {
  Category?: string | null;
  Description?: string | null;
}

export interface FormularyInfo {
  html?: string | null;
}

export interface RevisePatientAllergies {
  PracticeId?: string | null;
  PatientAllergies?: PatientAllergiesVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RevisePatientLifestyle {
  Lifestyle?: PatientLifestyleVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RevisePatientHospitalization {
  PatientSurgicalHistory?: PatientSurgicalHistoryVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RevisePatientClinicalNotes {
  PracticeId?: string | null;
  PatientClinicalNotes?: PatientClinicalNotesVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RevisePatientChronicConditions {
  PracticeId?: string | null;
  ChronicConditions?: PatientChronicConditionsVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ProviderCommunicationEmailVo {
  Subject?: string | null;
  Body?: string | null;
  Recipient?: string | null;
  Attachments?: AttachmentVo[] | null;
  BodyParams?: { [key: string]: string } | null;
}

export interface AttachmentVo {
  Title?: string | null;
  Type?: string | null;
  HtmlBody?: string | null;
}

export interface CreatePatientRequest {
  BillingPracticeNo?: string | null;
  LooseValidation?: boolean | null;
  PatientVo?: PatientVo | null;
  UpdateOtherPatientsAccountDetails?: boolean | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ChangePatientRequest {
  BillingPracticeNo?: string | null;
  LooseValidation?: boolean | null;
  PatientVo?: PatientVo | null;
  UpdateOtherPatientsAccountDetails?: boolean | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RemovePatientRequest {
  BillingPracticeNo?: string | null;
  PatientId?: string | null;
  PatientXRef?: string | null;
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface CreatePatient {
  LooseValidation?: boolean | null;
  PatientVo?: PatientVo | null;
  UpdateOtherPatientsAccountDetails?: boolean | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface ChangePatient {
  LooseValidation?: boolean | null;
  PatientVo?: PatientVo | null;
  UpdateOtherPatientsAccountDetails?: boolean | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RemovePatient {
  PatientId?: string | null;
  PatientXRef?: string | null;
  PracticeId?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface SchedulePatientVisit {
  PatientEventDetails?: PatientEventVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfCheckinPatientVisitResult {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: CheckinPatientVisitResult | null;
  Links?: RestApiLink[] | null;
}

/** Checkin patient visit details */
export interface CheckinPatientVisitResult {
  PatientId?: string | null;
  PatientEventId?: string | null;
  PatientDetailsIncomplete?: boolean | null;
  PatientAlreadyCheckedIn?: boolean | null;
  Description?: string | null;
}

export interface CheckInPatientVisit {
  PatientEventDetails?: PatientEventVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdatePatientVisit {
  PatientEventDetails?: PatientEventVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface CancelPatientVisit {
  PatientEventId?: string | null;
  PracticeId?: string | null;
  PatientEventXRef?: string | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface CompletePatientVisit {
  PatientEventId?: string | null;
  PatientEventXRef?: string | null;
  InvoiceCreated?: boolean | null;
  PracticeId?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface FeatureUsageVo {
  TenantId?: string | null;
  Id?: string | null;
  Feature?: string | null;
  Action?: string | null;
  Date?: Date | null;
  Parameters?: { [key: string]: string } | null;
}

export interface LogFeatureUsed {
  FeatureUsage?: FeatureUsageVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface MedicalAidVo {
  Name?: string | null;
  SchemeCode?: string | null;
  Plans?: PlanVo[] | null;
}

export interface PlanVo {
  Name?: string | null;
  PlanCode?: string | null;
  Options?: OptionVo[] | null;
}

export interface OptionVo {
  Name?: string | null;
  PVEnabled?: boolean | null;
  RoutingCode?: string | null;
  OptionCode?: string | null;
}

export interface RestApiResultOfFunderSpecificRuleVoOf {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: FunderSpecificRuleVo[] | null;
  Links?: RestApiLink[] | null;
}

export interface FunderSpecificRuleVo {
  Code?: string | null;
  Description?: string | null;
  ZeroMedicine?: boolean | null;
  ZeroConsumable?: boolean | null;
}

export interface RestApiResultOfFunderSpecificRuleVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: FunderSpecificRuleVo | null;
  Links?: RestApiLink[] | null;
}

export interface TokenResponse {
  token?: string | null;
  reference?: string | null;
  code?: number | null;
  message?: string | null;
  link?: string | null;
}

export interface RestEndpointVo {
  HttpMethod?: string | null;
  RoutePath?: string | null;
  Documentation?: string | null;
}

export interface CalendarEventVo {
  CalendarEventXRef?: string | null;
  PatientName?: string | null;
  PatientXRef?: string | null;
  PatientId?: string | null;
  PatientSurname?: string | null;
  BenefitCheckStatus?: string | null;
  AppointmentTitle?: string | null;
  AppointmentType?: string | null;
  AppointmentStatus?: string | null;
  AppointmentReason?: string | null;
  AppointmentNote?: string | null;
  Invoiced?: boolean | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  PracticeId?: string | null;
  Type?: string | null;
}

export interface AppointmentDetailsVo {
  AppointmentStatus?: string | null;
  AppointmentType?: string | null;
  AppointmentXRef?: string | null;
  PatientXRef?: string | null;
  VideoConsultLink?: string | null;
  VisitReason?: string | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
}

export interface TemplateSummaryVo {
  OriginalTemplate?: any | null;
  Caption?: string | null;
  TemplateXRef?: string | null;
  TemplateType?: string | null;
  GroupInvoiceTemplateXRef?: string | null;
  Code?: string | null;
  Description?: string | null;
  SortOrder?: number | null;
}

export interface AccountInfoVo {
  LastBenefitCheckStatus?: string | null;
  LastBenefitCheckReportUrl?: string | null;
  LastBcReferenceNum?: string | null;
  LastBenefitCheckDate?: Date | null;
  IsSuspended?: boolean | null;
  SuspensionReason?: string | null;
  PrimaryDoctorXref?: string | null;
  SecondaryDoctorXref?: string | null;
  IsPrimary?: boolean | null;
  AccountLiable?: number | null;
  LastBcContractData?: string | null;
}

export interface RestApiResultOfInt64 {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: number | null;
  Links?: RestApiLink[] | null;
}

export interface NodePublicKeyVo {
  Id?: string | null;
  NodeId?: number | null;
  TenantId?: string | null;
  Subject?: string | null;
  PublicKey?: string | null;
  Thumbprint?: string | null;
  Validated?: boolean | null;
  GeneratedTime?: Date | null;
  ValidatedTime?: Date | null;
  RevokedTime?: Date | null;
}

export interface ConfigureNode {
  Node?: NodeVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface NodeVo {
  NodeId?: string | null;
  NumericNodeId?: number | null;
  NumericInstanceId?: number | null;
  TenantId?: string | null;
  TenantIds?: string[] | null;
  NodeDescription?: string | null;
  NodeSecurityPolicy?: string | null;
  NodePairingSharedSecret?: string | null;
  NodeActive?: boolean | null;
  ReplicationOutboundQueueUri?: string | null;
  ReplicationOutboundQueueAccessToken?: string | null;
  ReplicationInboundQueueUri?: string | null;
  ReplicationInboundQueueAccessToken?: string | null;
  ConfigurationProperties?: { [key: string]: string } | null;
  NodePublicKey?: NodePublicKeyVo | null;
}

export interface AssignNodePolicy {
  NodeId?: string | null;
  TenantId?: string | null;
  Policy?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfNodeVo {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: NodeVo | null;
  Links?: RestApiLink[] | null;
}

export interface NotificationStatusView {
  Status?: string | null;
  LastNotificationAction?: NotificationActionVo | null;
  NotificationId?: string | null;
  NotificationXRef?: string | null;
  ProviderId?: string | null;
  Date?: Date | null;
  Context?: string | null;
  Subject?: string | null;
  Category?: string | null;
  Body?: string | null;
  BodyType?: string | null;
  Actions?: NotificationActionVo[] | null;
  Data?: { [key: string]: string } | null;
}

export interface NotificationActionVo {
  Description?: string | null;
  Name?: string | null;
  ActionLink?: string | null;
  Modal?: boolean | null;
}

export interface NotificationVo {
  NotificationId?: string | null;
  NotificationXRef?: string | null;
  ProviderId?: string | null;
  Date?: Date | null;
  Context?: string | null;
  Subject?: string | null;
  Category?: string | null;
  Body?: string | null;
  BodyType?: string | null;
  Actions?: NotificationActionVo[] | null;
  Data?: { [key: string]: string } | null;
}

export interface RaiseNotification {
  Notification?: NotificationVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface MarkNotificationAsViewed {
  ProviderId?: string | null;
  NotificationId?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface RestApiResultOfPatientVoOf {
  Sucess?: boolean | null;
  ResponseCode?: number | null;
  ResponseMessage?: string | null;
  Data?: PatientVo[] | null;
  Links?: RestApiLink[] | null;
}

export interface SendPatientDocumentEmail {
  PracticeId?: string | null;
  documentId?: string | null;
  body?: string | null;
  subject?: string | null;
  to?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdatePatientDocumentNote {
  PracticeId?: string | null;
  DocumentId?: string | null;
  Notes?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface UpdatePatientDocument {
  DocumentId?: string | null;
  PracticeId?: string | null;
  Category?: string | null;
  Description?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface PatientDocumentHistoryVo {
  PracticeId?: string | null;
  PatientDocumentId?: string | null;
  DocumentHistory?: DocumentActionHistoryVo[] | null;
}

export interface DocumentActionHistoryVo {
  ActionDate?: Date | null;
  Description?: string | null;
}

export interface PatientEventsByDateVo {
  Date?: Date | null;
  PatientEvents?: PatientEventView[] | null;
}

export interface PatientEventView {
  PatientEvent?: PatientEventVo | null;
  EncounterType?: string | null;
  BranchName?: string | null;
}

export interface PatientEventFilterVo {
  PracticeId?: string | null;
  DaysToReturn?: number | null;
  DateFrom?: Date | null;
  DateTo?: Date | null;
  ExcludeStatuses?: string[] | null;
}

export interface UpdateMedicalInsurer {
  MedicalInsurer?: MedicalInsurerVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface DeactivateMedicalInsurer {
  MedicalInsurer?: MedicalInsurerVo | null;
  Reason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface MarkPatientVisitInProgress {
  PatientEventDetails?: PatientEventVo | null;
  ConsultReason?: string | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface PowerBIReport {
  name?: string | null;
  reportId?: string | null;
  webUrl?: string | null;
  embedUrl?: string | null;
  accessToken?: string | null;
}

export interface ReminderVo {
  ReminderId?: string | null;
  Index?: number | null;
  ProviderId?: string | null;
  UpdatedDate?: Date | null;
  CreatedDate?: Date | null;
  DueDate?: Date | null;
  Title?: string | null;
  Description?: string | null;
  Completed?: boolean | null;
  /** 0 = Email, 1 = Followup, 2 = Task, 3 = Pathology */
  Type?: ReminderVoType | null;
  References?: ReminderReferenceVo[] | null;
  Category?: string[] | null;
}

export interface ReminderReferenceVo {
  ReferenceId?: string | null;
  Name?: string | null;
  ReferenceType?: string | null;
}

export interface TenantVo {
  TenantId?: string | null;
  TenantXRef?: string | null;
  Description?: string | null;
}

export interface UpdateTenant {
  TenantVo?: TenantVo | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface TimerVo {
  NodeId?: number | null;
  TimerId?: string | null;
  FollowUpDateTime?: Date | null;
  CallbackCommand?: Command | null;
}

export interface Command {
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface SetTimer {
  TimerId?: string | null;
  FollowUpDateTime?: Date | null;
  CallbackCommand?: Command | null;
  CorrelationIds?: string[] | null;
  OriginatedSystem?: string | null;
}

export interface TimerByDateVo {
  Timers?: TimerVo[] | null;
  FollowUpDateTime?: Date | null;
}

export interface TokenProviderVo {
  Token?: string | null;
  Scope?: string | null;
  ServiceUrl?: string | null;
}

export interface PatientInWaitingRoom {
  PatientEvent?: PatientEventVo | null;
  HasSummmaryOfCare?: boolean | null;
  HasQuote?: boolean | null;
}

export interface CaptureEncounterRequest {
  ConsultReason?: string | null;
}

export interface QuestionnaireVo {
  Id: string;
  Title: string;
  Severity: string;
  Score: number;
  MaxScore: number;
  Questions: QuestionVo[];
  Valid: boolean;
}

export interface QuestionVo {
  Id: string;
  Question: string;
  Type: string;
  Answer?: { Value: number; AnswerText: string }; // used for likerts
  SubQuestions?: SubQuestion[]; // multiselect
}

interface SubQuestion {
  Id: string;
  Question: string;
  Answer: boolean;
}

/** workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden */
export enum Status {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

/** workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden */
export enum Status2 {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

/** workflow status, can be Open, Read, Urgent0 = Open, 1 = Read, 2 = Urgent, 3 = Hidden */
export enum Status3 {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

/** Acute = 0, Chronic = 10 = Acute, 1 = Chronic */
export enum FormularyType {
  _0 = 0,
  _1 = 1,
}

/** 0 = CAPTION_ASC, 1 = CAPTION_DESC, 2 = SORT_ORDER_ASC, 3 = SORT_ORDER_DESC */
export enum SortingOrder {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

/** 0 = CAPTION_ASC, 1 = CAPTION_DESC, 2 = SORT_ORDER_ASC, 3 = SORT_ORDER_DESC */
export enum SortingOrder2 {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum PatientEventVoStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export enum InvoiceHeaderVoPlaceOfService {
  _0 = 0,
  _2 = 2,
  _11 = 11,
  _21 = 21,
  _24 = 24,
  _12 = 12,
}

export enum InvoiceWithStatusVoStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
  _14 = 14,
}

export enum CardPaymentStatusStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum CardReaderVoConnectionMethod {
  _1 = 1,
  _2 = 2,
  _5 = 5,
}

export enum TransactionResultTransactionStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum TransactionResultCardEntryType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum TransactionResultType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum TransactionResultVerificationMethod {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export enum ClaimOptomScriptsType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum EncounterHeaderVoPlaceOfService {
  _0 = 0,
  _2 = 2,
  _11 = 11,
  _21 = 21,
  _24 = 24,
  _12 = 12,
}

export enum PathologyReportWorkflowVoWorkflowStatusType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum PathologyReportPatientSex {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum PathologyReportTelephoneTypeType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum PathologyReportSpecimenType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum PatientCommunicationFollowupVoDeliveryType {
  _0 = 0,
  _1 = 1,
}

export enum PatientCommunicationFollowupVoPriority {
  _0 = 0,
  _1 = 1,
}

export enum PatientCommunicationFollowupVoStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export enum ReminderVoType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
